import React from 'react';
/*
1. AboutSVG
2. AboutSVG
3. ContactSVG
5. Envelope
6. MapMarker
7. ProjectsSVG
*/

export const AboutSVG = function () {
  return (
    <svg
      className={'AboutSVG heroSVG'}
      id="fe80fb2b-bcaf-407e-919b-306adc32f78b"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      width="1032"
      height="741.75278"
      viewBox="0 0 1032 741.75278"
    >
      <line
        y1="741.25278"
        x2="166"
        y2="741.25278"
        fill="none"
        stroke="#3f3d56"
        strokeMiterlimit="10"
      />
      <rect
        className={'AboutSVGDarkFill'}
        x="243"
        y="127.75278"
        width="737"
        height="499"
        rx="19.39764"
        fill="#f2f2f2"
      />
      <rect
        x="220.5"
        y="96.25278"
        width="737"
        height="499"
        rx="19.39764"
        fill="none"
        stroke="#3f3d56"
        strokeMiterlimit="10"
      />
      <line
        x1="220.5"
        y1="144.09298"
        x2="957.5"
        y2="144.09298"
        fill="none"
        stroke="#3f3d56"
        stroke-miterlimit="10"
      />
      <rect
        x="661"
        y="256.25278"
        width="201"
        height="31"
        rx="7.09252"
        fill="#3355ff"
        opacity="0.3"
      />
      <rect
        x="622.5"
        y="342.25278"
        width="278"
        height="25"
        rx="7.09252"
        fill="#3355ff"
        opacity="0.3"
      />
      <rect
        x="622.5"
        y="410.25278"
        width="278"
        height="25"
        rx="7.09252"
        fill="#3355ff"
        opacity="0.3"
      />
      <rect
        x="622.5"
        y="478.25278"
        width="278"
        height="25"
        rx="7.09252"
        fill="#3355ff"
        opacity="0.3"
      />
      <rect
        x="671"
        y="246.25278"
        width="201"
        height="31"
        rx="7.09252"
        fill="none"
        stroke="#3f3d56"
        stroke-miterlimit="10"
      />
      <rect
        x="632.5"
        y="332.25278"
        width="278"
        height="25"
        rx="7.09252"
        fill="none"
        stroke="#3f3d56"
        stroke-miterlimit="10"
      />
      <rect
        x="632.5"
        y="400.25278"
        width="278"
        height="25"
        rx="7.09252"
        fill="none"
        stroke="#3f3d56"
        stroke-miterlimit="10"
      />
      <rect
        x="632.5"
        y="468.25278"
        width="278"
        height="25"
        rx="7.09252"
        fill="none"
        stroke="#3f3d56"
        stroke-miterlimit="10"
      />
      <circle cx="276.5" cy="126.25278" r="15" fill="#3355ff" opacity="0.3" />
      <circle cx="318.5" cy="126.25278" r="15" fill="#3355ff" opacity="0.3" />
      <circle cx="360.5" cy="126.25278" r="15" fill="#3355ff" opacity="0.3" />
      <circle
        cx="282.5"
        cy="120.25278"
        r="15"
        fill="none"
        stroke="#3f3d56"
        stroke-miterlimit="10"
      />
      <circle
        cx="324.5"
        cy="120.25278"
        r="15"
        fill="none"
        stroke="#3f3d56"
        stroke-miterlimit="10"
      />
      <circle
        cx="366.5"
        cy="120.25278"
        r="15"
        fill="none"
        stroke="#3f3d56"
        stroke-miterlimit="10"
      />
      <path
        d="M537.854,653.37916c-2.51135-11.56848-3.17724-27.36932-2.33252-38.36047,0,0-12.69836-55.78644-22.68994-60.99133l-.00305.003c-.153.19678-5.00195,6.55383-5.61706,26.22443-.62452,19.98284-7.69971,33.09655-7.69971,33.09655s2.28955,24.90766.98047,40.02777Z"
        transform="translate(-84.5 -79.12639)"
        fill="#3355ff"
      />
      <path
        d="M630.22827,298.37916H399.77173A23.77169,23.77169,0,0,0,376,322.15083V629.6075a23.77168,23.77168,0,0,0,23.77173,23.77166h80.855c-2.7002-11.19934-6.057-28.69067-2.65735-40.85241l-.00159-.008.0022.00525c.15869-.56757.32727-1.12738.51611-1.67047a63.49747,63.49747,0,0,0,2.29175-24.35407,50.6095,50.6095,0,0,0,0-21.23175c-2.4978-11.65564-4.24634-23.10522-4.24634-23.10522s-1.377-15.40234-.1748-24.84424c.02661-.2074.05762-.404.08667-.60541-.42432-.09655-.66235-.15228-.66235-.15228s3.53881-16.02789,4.78759-26.22748c.29493-2.40783.683-5.46032,1.10315-8.71478a20.93993,20.93993,0,0,1-3.3927-.86035c-11.24035-3.9549-14.779-39.75751-14.779-39.75751V429.656s-3.74683-17.38092,9.36694-25.08258c12.62793-7.41644,17.66968-9.44617,18.02613-9.58643.09619-.06878.19018-.13128.28833-.20727a11.06127,11.06127,0,0,0,3.28967-4.23371q.02619-.42873.01233-.85211c-.21326-4.06665-3.04419-7.76507-5.73047-10.99225q-3.43653-4.12857-6.87341-8.25726a8.07194,8.07194,0,0,1-1.77027-2.86487,6.604,6.604,0,0,1-.187-1.80389q-.00275-.33691.004-.673.056-3.07836.16724-6.15545c.06445-1.79224.51562-4.05353,2.27075-4.42182.91284-.19159,2.12109.14246,2.60364-.65576a1.56534,1.56534,0,0,0,.11682-1.06054c-.00586.02661-.00733.05444-.015.0805-.00586-.03339-.01159-.06695-.01782-.09985a22.43656,22.43656,0,0,1-.65051-4.38636,5.84207,5.84207,0,0,1,.282-1.96984c1.01672-2.97516,4.51782-4.196,7.61133-4.75727,3.09375-.56134,6.56653-1.04425,8.5083-3.51709a26.9506,26.9506,0,0,1,1.68884-2.37384,6.62979,6.62979,0,0,1,3.16589-1.59674,17.49792,17.49792,0,0,1,11.50623,1.02118c1.49646.68286,2.99963,1.60248,4.64124,1.49841,1.70507-.108,3.16162-1.3081,4.84509-1.60009,2.71911-.47156,5.31872,1.56567,6.65869,3.97827a9.85108,9.85108,0,0,1,1.23279,5.02313,6.912,6.912,0,0,1-1.76416,4.74109c-1.17017,1.24145-2.91626,2.09418-3.4021,3.72955-.198.66565-.152,1.38257-.32691,2.05457-.02185.084-.05737.16241-.08606.24365.03211.04169.06714.08112.09888.123a21.231,21.231,0,0,1-10.33215,33.01928c-.00794.21058-.01624.42133-.01514.63306a9.173,9.173,0,0,0,2.8396,7.0647l18.54724,7.606s11.16565-1.3534,15.19495,15.30957a28.82628,28.82628,0,0,1,.68982,8.45746c-.14636,2.51251.19507,6.93573,3.05725,12.66,4.57934,9.15881,3.53857,30.18237-5.82837,32.26392-8.87231,1.97161-12.32361,1.14331-12.66382,1.05023l-.02014.3681c.14612,3.94489,1.55029,37.969,6.64758,42.086,1.40955,1.13849,1.14026,1.90753-.01635,2.42578l.0028.00336s.0094.21856.03113.612c.15308,2.48846.93994,11.96472,4.35254,17.357,3.956,6.24457,3.54077,42.25739,3.54077,42.25739l2.70386,21.23181s-1.66419,13.11371,0,15.4024c.94556,1.29785,2.09057,21.40351,2.905,38.56964h69.53027A23.77168,23.77168,0,0,0,654,629.6075V322.15083A23.77169,23.77169,0,0,0,630.22827,298.37916Z"
        transform="translate(-84.5 -79.12639)"
        fill="#3355ff"
      />
      <rect
        x="267.5"
        y="192.25278"
        width="278"
        height="355"
        rx="23.77165"
        fill="none"
        stroke="#3f3d56"
        stroke-miterlimit="10"
      />
      <path
        d="M185.32419,400.757S176,398,174,401s2.72669,24.7477,2.72669,24.7477l20.54589,1.24859-7.17022-18.10653Z"
        transform="translate(-84.5 -79.12639)"
        fill="#2f2e41"
      />
      <path
        d="M113.44417,579.34709s18.69466,41.04232,4.29762,39.753-19.98395-39.753-19.98395-39.753Z"
        transform="translate(-84.5 -79.12639)"
        fill="#a0616a"
        className={'AboutSVGDarkColorSkin'}
      />
      <path
        d="M235.71128,575.07127s-8.20129,44.34751,5.45523,39.61078,9.76437-43.40874,9.76437-43.40874Z"
        transform="translate(-84.5 -79.12639)"
        className={'AboutSVGDarkColorSkin'}
        fill="#a0616a"
      />
      <path
        d="M181.34664,390.46647s-.21488,20.6286,7.73573,21.703-4.51251,12.03335-4.51251,12.03335l-14.18216,2.79346L149.974,425.49212l-9.025-11.60359s15.90121-7.52084,9.025-30.9429Z"
        transform="translate(-84.5 -79.12639)"
        className={'AboutSVGDarkColorSkin'}
        fill="#a0616a"
      />
      <path
        d="M181.34664,390.46647s-.21488,20.6286,7.73573,21.703-4.51251,12.03335-4.51251,12.03335l-14.18216,2.79346L149.974,425.49212l-9.025-11.60359s15.90121-7.52084,9.025-30.9429Z"
        transform="translate(-84.5 -79.12639)"
        opacity="0.1"
      />
      <path
        className={'AboutSVGDarkColor'}
        d="M217.87645,564.95005s10.09942,21.703,2.14881,89.82036c0,0,2.3637,24.0667.42977,28.5792s-17.83515,65.75367-17.83515,65.75367-20.41371,4.5125-23.20717-9.025c0,0,2.79346-19.33931,2.57857-22.34765s4.51251-35.88516,4.51251-35.88516l-9.66966-63.60485-7.306,57.37329s0,16.54586-2.36369,20.19884,0,77.14236,0,77.14236,6.66132,11.17383-3.4381,11.38871-19.12443-.21488-19.984-7.306-1.28929-14.18216-3.4381-18.47979-4.94227-53.50543-4.29762-70.69593-14.18216-105.50669-9.45478-114.74659S217.87645,564.95005,217.87645,564.95005Z"
        transform="translate(-84.5 -79.12639)"
        fill="#2f2e41"
      />
      <circle
        cx="85.8877"
        cy="293.29006"
        r="25.78575"
        className={'AboutSVGDarkColorSkin'}
        fill="#a0616a"
      />
      <path
        className={'AboutSVGDarkFill'}
        d="M144.60195,414.31829s15.68633,11.60359,38.46374,2.3637c0,0,7.52084-3.653,6.8762-9.2399s15.68633,44.91018,15.68633,44.91018l16.54586,87.88643-.85953,35.88517s-7.306-3.653-30.08337,4.51251-59.95187-9.2399-59.95187-9.2399l1.28929-92.18405,1.28928-53.72031,3.4381-11.81847S139.015,410.45043,144.60195,414.31829Z"
        transform="translate(-84.5 -79.12639)"
        fill="#f2f2f2"
      />
      <path
        className={'AboutSVGDarkColor'}
        d="M182.06324,399.89323s3.79591-.61662,7.44889,5.18517,12.24823,9.45477,12.24823,9.45477,20.84348,1.28929,23.85182,12.46312,10.52918,26.43039,14.18216,54.57983,10.95894,73.05963,12.03335,76.71261-1.50417,14.8268,1.50417,18.2649-21.27325,3.4381-21.27325,3.4381-2.14881-17.62026-3.653-17.62026-1.0744,11.81847.42977,20.41372-10.95895,0-10.95895,0-9.66965-39.32327-18.90955-74.77867S184.355,452.99692,186.074,445.04631s6.44644-30.728,3.00834-32.87683S182.06324,399.89323,182.06324,399.89323Z"
        transform="translate(-84.5 -79.12639)"
        fill="#2f2e41"
      />
      <path
        className={'AboutSVGDarkColor'}
        d="M151.07551,399.87428s-5.614,3.05531-19.7962,13.15473-23.85182,17.83514-23.85182,17.83514-5.58691,4.29762-9.025,29.86849S87.22865,552.48693,90.237,560.8673s4.08275,13.32264,3.00834,18.26491,22.56253,4.72739,22.99229,3.653-.64464-20.6286.42977-21.05836,6.87619,11.60359,7.9506,21.703,13.53752,18.05,16.331,18.05,17.1905-58.23282,17.40538-97.98585-4.72739-73.2745-8.38037-78.00189S151.07551,399.87428,151.07551,399.87428Z"
        transform="translate(-84.5 -79.12639)"
        fill="#2f2e41"
      />
      <path
        d="M188.86748,751.03721s1.71905-4.72739,7.73573-3.22322,10.09942-3.86786,10.09942-3.86786,3.22322-.42977,1.0744,3.653-3.86786,6.8762-3.86786,6.8762,12.89288,29.43873,4.51251,36.52981-18.05,2.79346-18.05,2.79346-9.45477-6.66132-9.025-24.28159c0,0-.42976-5.58691-5.58691-14.61192s-9.025-22.77741-2.79346-25.356,7.83546-2.67436,7.83546-2.67436-2.916,13.33721,4.61624,17.99776Z"
        transform="translate(-84.5 -79.12639)"
        fill="#3f3d56"
      />
      <path
        d="M148.89957,784.3438s-5.15715-9.66966,3.4381-10.74406,17.83515-1.71905,17.40538,2.79345-1.50417,11.38871-1.50417,11.38871l1.50417,4.94227s.42977,12.24823,1.93393,13.7524,9.66966,14.397-7.73572,14.397-22.56253-1.93393-21.05836-6.01667,1.93393-24.28158,1.93393-24.28158Z"
        transform="translate(-84.5 -79.12639)"
        fill="#3f3d56"
      />
      <path
        className={'AboutSVGDarkColorHair'}
        d="M162.22221,351.78785s12.03335,3.22322,18.26491,4.51251,5.58691-2.3637,5.58691-2.3637,8.16549,1.07441,7.73572.21488,3.4381-5.372-1.0744-10.52918-3.22322-9.025-3.22322-9.025h-3.86786l-1.07441-1.50417h-6.01668s-4.5125-1.71905-16.331,0-27.93456,2.14881-29.22385,9.2399-7.95061,15.90121-5.58691,19.98395,15.90121,20.84348,17.1905,27.93456,7.30933,8.66659,7.09277,4.22585-6.23325-19.91218-1.0761-20.55682S164.5859,360.16822,162.22221,351.78785Z"
        transform="translate(-84.5 -79.12639)"
        fill="#2f2e41"
      />
      <path
        className={'AboutSVGDarkColorStroke'}
        d="M1019.38065,86.58377a22.982,22.982,0,0,0-19.80994,13.851c-4.9535,11.97382,1.42449,26.03885,10.999,34.77028s21.87358,13.72225,33.04831,20.28234c15.00952,8.81128,28.4968,21.04282,36.00691,36.74386s8.30888,35.15009-.51891,50.14991c-8.1937,13.9224-23.09255,22.2549-37.30219,29.9397"
        transform="translate(-84.5 -79.12639)"
        fill="none"
        stroke="#3f3d56"
        stroke-miterlimit="10"
      />
      <ellipse cx="947.5" cy="8.5" rx="17.5" ry="8.5" fill="#3355ff" />
      <ellipse cx="961.5" cy="64.5" rx="17.5" ry="8.5" fill="#3355ff" />
      <ellipse cx="929.5" cy="73.5" rx="17.5" ry="8.5" fill="#3355ff" />
      <ellipse cx="979.5" cy="120.5" rx="17.5" ry="8.5" fill="#3355ff" />
      <ellipse cx="1014.5" cy="120.5" rx="17.5" ry="8.5" fill="#3355ff" />
    </svg>
  );
};

export const AboutBlogSVG = function () {
  return (
    <svg
      className={'AboutBlogSVG'}
      id="c72640af-2824-4ace-a782-4df73f48977c"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="1143.14"
      height="862.91"
      viewBox="0 0 1143.14 862.91"
    >
      <defs>
        <linearGradient
          id="969f2d34-5bff-4fc3-8c31-c6509eddc389"
          x1="551.46"
          y1="688.44"
          x2="551.46"
          y2="150.11"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="gray" stop-opacity="0.25" />
          <stop offset="0.54" stop-color="gray" stop-opacity="0.12" />
          <stop offset="1" stop-color="gray" stop-opacity="0.1" />
        </linearGradient>
        <linearGradient
          id="488cd128-ff9c-494f-bd41-35fb6c1caf21"
          x1="1059.46"
          y1="856.62"
          x2="1059.46"
          y2="468.94"
          xlinkHref="#969f2d34-5bff-4fc3-8c31-c6509eddc389"
        />
        <linearGradient
          id="ccb18d0b-874b-442a-b8cb-57bcf76cdeb5"
          x1="814.74"
          y1="881.34"
          x2="814.74"
          y2="496.8"
          gradientTransform="matrix(-1, -0.04, -0.04, 1, 1070.86, 21.29)"
          xlinkHref="#969f2d34-5bff-4fc3-8c31-c6509eddc389"
        />
      </defs>
      <ellipse cx="1023.75" cy="834.07" rx="100.11" ry="24.73" fill="#3355ff" opacity="0.1" />
      <ellipse cx="140.04" cy="838.19" rx="100.11" ry="24.73" fill="#3355ff" opacity="0.1" />
      <path
        d="M713.17,251.41s-14.07-5.71-58.81,14.82S604,284.14,592.44,281s-18-3.88-30.46-21c0,0-8.76-47.48-17.23-54.84s-44.5,4.19-44.5,4.19-43.19,9.91-51.42-47.81c0,0,5.84-43.51-2.11-56.86,0,0,16,6.93,42.54-4.25s47.69,12,47.69,12,6.68,17.3,6,27.61,3.53,14.18,16.17,9.2c0,0,6.2-8.83-2.59-23.42s-15.06-25.47-12.6-36.8,9.5-27,32.16-34.9,53.44-9.38,68.22-15.53,18.35-10.15,18.35-10.15S653.55,37.58,675,76.19s7.77,55.38,7.77,55.38-11.4,27.16-61.7,25c0,0-48.47,1.77-22,22.33,0,0,16.93-3.45,42.23-11.49s43.57,25.15,48.1,48.25S713.17,251.41,713.17,251.41Z"
        transform="translate(-28.43 -18.54)"
        fill="#3355ff"
      />
      <path
        d="M648,57.75l.27-.07c1.94,7.37-19.73,37-38.24,60.53l-.22-.17C635.94,84.83,649.51,63.42,648,57.75Z"
        transform="translate(-28.43 -18.54)"
        fill="#444053"
      />
      <path
        d="M610.2,117.55l.11.3c-14.79,18.81-33.39,41.25-48.28,57.87-1.42,1.59-2.83,3.25-4.19,4.95l-.42-.35c1.36-1.7,2.78-3.37,4.2-5C576.5,158.75,595.42,136.35,610.2,117.55Z"
        transform="translate(-28.43 -18.54)"
        fill="#444053"
      />
      <path
        d="M557.78,179.88l.29.5c-27.1,33.83-28.89,86.36-29,86.82l-5.72-6.6C523.47,260.14,530.49,213.94,557.78,179.88Z"
        transform="translate(-28.43 -18.54)"
        fill="#444053"
      />
      <path
        d="M681.74,233.06s-32-16.61-56.85-10.65-81-21.06-81-21.06-23.81-9.68-28.59-20.7c0,0-16.33-17.26-17.26-26.2s-16.83-31.4-27.2-32.27"
        transform="translate(-28.43 -18.54)"
        fill="none"
        stroke="#444053"
        stroke-miterlimit="10"
      />
      <path
        d="M677.12,249.05S661,238.21,662.9,225.58"
        transform="translate(-28.43 -18.54)"
        fill="none"
        stroke="#444053"
        stroke-miterlimit="10"
      />
      <path
        d="M652.43,263.06s-23-8.36-25.32-41.11"
        transform="translate(-28.43 -18.54)"
        fill="none"
        stroke="#444053"
        stroke-miterlimit="10"
      />
      <path
        d="M615.3,271.54s-22-18.25-14.69-50.13"
        transform="translate(-28.43 -18.54)"
        fill="none"
        stroke="#444053"
        stroke-miterlimit="10"
      />
      <path
        d="M570.68,262.62s-14.65-30.71-1.62-50.69"
        transform="translate(-28.43 -18.54)"
        fill="none"
        stroke="#444053"
        stroke-miterlimit="10"
      />
      <path
        d="M682.12,212.82s-16.65,5.28-13.08,14"
        transform="translate(-28.43 -18.54)"
        fill="none"
        stroke="#444053"
        stroke-miterlimit="10"
      />
      <path
        d="M662,182.61s-22.27,7.07-22.8,38.57"
        transform="translate(-28.43 -18.54)"
        fill="none"
        stroke="#444053"
        stroke-miterlimit="10"
      />
      <path
        d="M631,175.34s-20.26,25-18.77,47.75"
        transform="translate(-28.43 -18.54)"
        fill="none"
        stroke="#444053"
        stroke-miterlimit="10"
      />
      <path
        d="M595.48,185.15s-20.13,19.24-17.56,29.95"
        transform="translate(-28.43 -18.54)"
        fill="none"
        stroke="#444053"
        stroke-miterlimit="10"
      />
      <path
        d="M583.34,178.35s-18.88,3.39-21.52-2.81"
        transform="translate(-28.43 -18.54)"
        fill="none"
        stroke="#444053"
        stroke-miterlimit="10"
      />
      <path
        d="M558.81,155.56s9.54,12.63,12,9.8"
        transform="translate(-28.43 -18.54)"
        fill="none"
        stroke="#444053"
        stroke-miterlimit="10"
      />
      <path
        d="M653.36,147.57S605.78,151,595,136.68"
        transform="translate(-28.43 -18.54)"
        fill="none"
        stroke="#444053"
        stroke-miterlimit="10"
      />
      <path
        d="M548.8,91.91s22.33,47.93,38.54,54"
        transform="translate(-28.43 -18.54)"
        fill="none"
        stroke="#444053"
        stroke-miterlimit="10"
      />
      <path
        d="M572.22,69.08s13.72,44.09,30.71,57.85"
        transform="translate(-28.43 -18.54)"
        fill="none"
        stroke="#444053"
        stroke-miterlimit="10"
      />
      <path
        d="M673.39,111.19s-36.19,15.53-57.92-.18"
        transform="translate(-28.43 -18.54)"
        fill="none"
        stroke="#444053"
        stroke-miterlimit="10"
        stroke-width="0.75"
      />
      <path
        d="M604.46,59.68s8.27,32.41,19.41,40.24"
        transform="translate(-28.43 -18.54)"
        fill="none"
        stroke="#444053"
        stroke-miterlimit="10"
        stroke-width="0.75"
      />
      <path
        d="M667.92,74.89s-20.33,7.7-27.93,1.8"
        transform="translate(-28.43 -18.54)"
        fill="none"
        stroke="#444053"
        stroke-miterlimit="10"
        stroke-width="0.75"
      />
      <path
        d="M541.39,166.15s0,28.25-7.69,30.26"
        transform="translate(-28.43 -18.54)"
        fill="none"
        stroke="#444053"
        stroke-miterlimit="10"
      />
      <path
        d="M478.52,202.75s30.54,2.62,44.63-13.14"
        transform="translate(-28.43 -18.54)"
        fill="none"
        stroke="#444053"
        stroke-miterlimit="10"
      />
      <path
        d="M533.51,132.78s-7.39,28.65-27.78,36.37"
        transform="translate(-28.43 -18.54)"
        fill="none"
        stroke="#444053"
        stroke-miterlimit="10"
      />
      <path
        d="M460.2,172.57s21.62,7.52,40.21-11.62"
        transform="translate(-28.43 -18.54)"
        fill="none"
        stroke="#444053"
        stroke-miterlimit="10"
      />
      <path
        d="M509.47,108.15s-2,24.33-15.27,35.72"
        transform="translate(-28.43 -18.54)"
        fill="none"
        stroke="#444053"
        stroke-miterlimit="10"
      />
      <path
        d="M461,135.49s17.94.13,22.14-5.72"
        transform="translate(-28.43 -18.54)"
        fill="none"
        stroke="#444053"
        stroke-miterlimit="10"
      />
      <path
        d="M620.4,156c-71.4,11.91-142.91,5.5-211.75-3.38s-137.52-20.22-209.07-18c-46,1.44-97.17,10.48-129,38.22-30.62,26.69-35,63.18-34.71,96.18.22,24.82,2.55,50.53,19.36,70.49,11.67,13.85,29.51,23.91,43,36.72,47,44.58,33.67,113.64,3.91,172.12-14,27.44-31.11,54.37-40.5,82.5S51.32,689.28,69,712.57c17.54,23.09,51.09,36.39,86,43.52,70.89,14.47,149.57,7,225.67-3.39,168.44-23.11,335-60.49,501.08-97.8,61.47-13.8,123.21-27.68,182.35-48,32.84-11.26,66.25-25.43,87.28-47.84,26.69-28.45,26.93-67.72.56-91.54-44.24-40-143.21-32.48-177.6-78-18.94-25-11.23-58.62,3.24-88.17,31-63.4,91.75-125.65,83-189.36-6-43.76-48.38-80.4-104.68-90.53-59-10.61-134.41,7.11-167.78,50.62C753.76,117,683.44,145.5,620.4,156Z"
        transform="translate(-28.43 -18.54)"
        fill="#3355ff"
        opacity="0.1"
      />
      <rect
        x="76.29"
        y="150.11"
        width="950.33"
        height="538.33"
        rx="12.49"
        ry="12.49"
        fill="url(#969f2d34-5bff-4fc3-8c31-c6509eddc389)"
      />
      <rect x="77.8" y="157.68" width="947.42" height="528.97" rx="12.49" ry="12.49" fill="#fff" />
      <rect x="77.8" y="157.68" width="947.42" height="528.97" rx="12.49" ry="12.49" fill="#fff" />
      <rect
        x="77.8"
        y="157.68"
        width="947.42"
        height="528.97"
        rx="12.49"
        ry="12.49"
        fill="#5a5773"
        opacity="0.04"
      />
      <path
        d="M1048.84,170.15H111a4.81,4.81,0,0,0-4.81,4.81V195.3h947.42V175A4.81,4.81,0,0,0,1048.84,170.15Z"
        transform="translate(-28.43 -18.54)"
        fill="#5a5773"
      />
      <g id="83eb5f8b-b68b-4721-b047-6100bc74156f" data-name="buttons">
        <circle cx="96.72" cy="164.18" r="6.5" fill="#fff" />
        <circle cx="114.22" cy="164.18" r="6.5" fill="#fff" />
        <circle cx="131.72" cy="164.18" r="6.5" fill="#fff" />
      </g>
      <rect x="141.22" y="293.86" width="790" height="392.78" rx="10.19" ry="10.19" fill="#fff" />
      <rect
        x="107.72"
        y="203.45"
        width="227.24"
        height="23.85"
        rx="3.86"
        ry="3.86"
        fill="#5a5773"
        opacity="0.2"
      />
      <rect
        x="536.22"
        y="339.45"
        width="227.24"
        height="23.85"
        rx="3.86"
        ry="3.86"
        fill="#3355ff"
        opacity="0.2"
      />
      <rect
        x="536.22"
        y="406.23"
        width="354.83"
        height="23.85"
        rx="3.86"
        ry="3.86"
        fill="#3355ff"
        opacity="0.2"
      />
      <rect
        x="536.22"
        y="445.23"
        width="354.83"
        height="23.85"
        rx="3.86"
        ry="3.86"
        fill="#3355ff"
        opacity="0.2"
      />
      <rect
        x="536.22"
        y="484.23"
        width="354.83"
        height="23.85"
        rx="3.86"
        ry="3.86"
        fill="#3355ff"
        opacity="0.2"
      />
      <rect
        x="536.22"
        y="523.23"
        width="354.83"
        height="23.85"
        rx="3.86"
        ry="3.86"
        fill="#3355ff"
        opacity="0.2"
      />
      <rect
        x="184.05"
        y="566.23"
        width="707"
        height="23.85"
        rx="3.86"
        ry="3.86"
        fill="#3355ff"
        opacity="0.2"
      />
      <rect
        x="184.05"
        y="605.23"
        width="707"
        height="23.85"
        rx="3.86"
        ry="3.86"
        fill="#3355ff"
        opacity="0.2"
      />
      <rect
        x="184.05"
        y="644.23"
        width="707"
        height="23.85"
        rx="3.86"
        ry="3.86"
        fill="#3355ff"
        opacity="0.2"
      />
      <path
        d="M757.73,678.54s5.93,7.75-2.74,19.46-15.81,21.59-12.92,28.89c0,0,13.07-21.74,23.72-22S769.44,691.61,757.73,678.54Z"
        transform="translate(-28.43 -18.54)"
        fill="#3355ff"
      />
      <path
        d="M757.73,678.54a9.6,9.6,0,0,1,1.21,2.43c10.39,12.2,15.92,23.59,5.94,23.87-9.3.27-20.46,16.9-23.13,21.09a7.72,7.72,0,0,0,.32,1s13.07-21.74,23.72-22S769.44,691.61,757.73,678.54Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M768.75,688.42c0,2.73-.3,4.94-.68,4.94s-.68-2.21-.68-4.94.38-1.44.76-1.44S768.75,685.69,768.75,688.42Z"
        transform="translate(-28.43 -18.54)"
        fill="#ffd037"
      />
      <path
        d="M772.54,691.68c-2.4,1.3-4.49,2.09-4.67,1.76s1.62-1.66,4-3,1.45-.36,1.63,0S774.93,690.37,772.54,691.68Z"
        transform="translate(-28.43 -18.54)"
        fill="#ffd037"
      />
      <path
        d="M726.41,678.54s-5.93,7.75,2.73,19.46,15.82,21.59,12.93,28.89c0,0-13.08-21.74-23.72-22S714.7,691.61,726.41,678.54Z"
        transform="translate(-28.43 -18.54)"
        fill="#3355ff"
      />
      <path
        d="M726.41,678.54a9.39,9.39,0,0,0-1.22,2.43c-10.38,12.2-15.91,23.59-5.93,23.87,9.3.27,20.45,16.9,23.12,21.09a7.68,7.68,0,0,1-.31,1s-13.08-21.74-23.72-22S714.7,691.61,726.41,678.54Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M715.38,688.42c0,2.73.31,4.94.69,4.94s.68-2.21.68-4.94S716.37,687,716,687,715.38,685.69,715.38,688.42Z"
        transform="translate(-28.43 -18.54)"
        fill="#ffd037"
      />
      <path
        d="M711.6,691.68c2.4,1.3,4.49,2.09,4.67,1.76s-1.62-1.66-4-3-1.45-.36-1.63,0S709.2,690.37,711.6,691.68Z"
        transform="translate(-28.43 -18.54)"
        fill="#ffd037"
      />
      <ellipse cx="713.64" cy="758.15" rx="62" ry="9.51" fill="#3355ff" opacity="0.1" />
      <path
        d="M774,716.44l-.3,2.42-.41,3.42-.18,1.43-.41,3.42-.18,1.43-.42,3.41-4.74,38.9c-.43,3.47-6.1,6.18-13,6.18H729.74c-6.85,0-12.51-2.71-12.93-6.18L712.05,732l-.41-3.41-.18-1.43-.42-3.42-.17-1.43-.42-3.42-.3-2.42c-.23-2,2.84-3.62,6.71-3.62h50.42C771.15,712.82,774.22,714.47,774,716.44Z"
        transform="translate(-28.43 -18.54)"
        fill="#65617d"
      />
      <polygon
        points="745.25 700.32 744.84 703.74 682.44 703.74 682.02 700.32 745.25 700.32"
        fill="#9d9cb5"
      />
      <polygon
        points="744.66 705.16 744.25 708.58 683.03 708.58 682.61 705.16 744.66 705.16"
        fill="#9d9cb5"
      />
      <polygon
        points="744.07 710.01 743.65 713.43 683.62 713.43 683.21 710.01 744.07 710.01"
        fill="#9d9cb5"
      />
      <rect
        x="184.05"
        y="326.22"
        width="302"
        height="221.54"
        rx="8.5"
        ry="8.5"
        fill="#3355ff"
        opacity="0.2"
      />
      <path
        d="M1153.48,591.15c.38-1-2.44-6.72-2.44-7s-2.91-3.45-2.91-5.22-3.85-5.6-3.85-5.6-5.17-2.14-5.73-6.81-6.19-4.75-6.2-4.75h0s0-.42,0-1.07a14.72,14.72,0,0,0-.69-5.45,5.49,5.49,0,0,0-3.19-2.71s-.57-3.64-1.69-4.76a5.35,5.35,0,0,1-1.32-5c.57-1.76-.75-6.24-3.47-6.9s-5.83-1.68-5.83-1.68l-.75.13-.37-.13a15.59,15.59,0,0,1-2,.25,2.47,2.47,0,0,1-1.59-.52c-.94-1-8.55-3-10-3s-5.45-1.87-5.45-1.87-2.82-2.14-4-3.08-3.23-4.35-3.54-4.87l0-.07h0l0,0a17.25,17.25,0,0,1-.85-2.45h0a22.06,22.06,0,0,0,3.49-4.81c.1-.18.19-.36.28-.55a2.1,2.1,0,0,0,.61-.09l.25-.1a4.06,4.06,0,0,0,2-2.38h0a6.32,6.32,0,0,0,.18-.62c0-.07,0-.14,0-.21l.09-.42a2,2,0,0,1,0-.24l.06-.42,0-.24c0-.18,0-.35.07-.53h0a18.7,18.7,0,0,1,.29-2v0h0c.56-2.53,2.09-4.67,3.16-7h0c.15-.33.3-.67.43-1s.26-.75.37-1.13l.09-.35c.07-.28.13-.56.19-.84s0-.25.07-.38q.09-.57.15-1.17a14.46,14.46,0,0,0-1-6.55c-.7-1.75-1.75-3.33-2.46-5.08-1.08-2.65-1.37-5.66-2.68-8.19a9.75,9.75,0,0,0-11.7-4.76c-2,.76-3.82,2.23-5.89,2.89-2.78.89-5.74.22-8.62-.17s-6-.44-8.36,1.44c-2.66,2.16-3.38,6.22-5.88,8.59-1,1-2.35,1.63-3.46,2.55a5.65,5.65,0,0,0-1.74,2.38l-.06.19a1.83,1.83,0,0,0-.06.25,2.33,2.33,0,0,0-.05.28,1.11,1.11,0,0,0,0,.19,2.09,2.09,0,0,0,0,.5h0a3.81,3.81,0,0,0,.07.47l0,.13c0,.13.07.26.12.39s0,.05,0,.07.11.29.17.43l.09.21c0,.06,0,.12.08.17a12.44,12.44,0,0,1,.87,2.17,2.41,2.41,0,0,1-.09,1.43,4.22,4.22,0,0,1-1,1.37,19.35,19.35,0,0,0-4.24,6.79q-.17.44-.3.87v0l.13,0a5.68,5.68,0,0,0,.82.17,4,4,0,0,0,.47,0,7.32,7.32,0,0,0,1.92-.14l.48-.12a10.87,10.87,0,0,0,1.9-.69c0,.19,0,.38,0,.57s0,.21,0,.32a22.18,22.18,0,0,0,12.33,19.84c0,.2.05.4.08.6l.06.51-.25-.24s-1.69-.84-3.29,1.58a10.62,10.62,0,0,1-4.6,3.55s-17.1,2.7-17.76,4.94l-8,.47s-2.82.37-3.1,6.25-1.78,6.43-1.78,6.43-3.29,5.79-3,8.77a4.89,4.89,0,0,1-2.54,4.48l-.37,5.32s-3.1-.47-4,3.17a12.65,12.65,0,0,1-2.34,5.31s-5.17,4.3-5.45,7.93l-3.2,2s-7.42-1.68-9.11-4.66c0,0-.2-.2-.52-.49l0-.07v0c-1.11-1-3.46-3.24-3.1-2.73a2.25,2.25,0,0,1,.15,1.5l-.55-.61-1.48-1.64s-12-11.24-19-12.13h0c-.09-.18-.55-2-1.75-.85a9.8,9.8,0,0,0-.07,14.37l11.24,10.49.29.21,2.41,3.1c-.41,1-.75,1.92-1,2.78l0,.09-.18.54a1.21,1.21,0,0,0-.05.18c-.06.18-.11.35-.16.52l-.09.3c0,.06,0,.12,0,.18-.27.94-.44,1.66-.52,2.06l-.63-.2.61.27,0,.09c0,.13,0,.2,0,.2l.58.25c3.29,1.43,19.71,8.64,20.55,9.73s7.14,4.76,12.78,1.77,6.85-7.55,6.85-7.55,5.45-7.56,5.64-8.68,4.41-2.42,4.41-2.42.38,12.49-1.78,17.07-6.2,24.81-6.2,24.81a2.86,2.86,0,0,1,.8,0l-.24,1.17a2.72,2.72,0,0,1,1,0c-.3,2.3-2,13-2,13s-.56,4.85-1.5,6.53-1,10.45-1,10.45l-1.51,6.34s.2.44.57,1.09v0a16.23,16.23,0,0,0,4.32,5.59,11.06,11.06,0,0,1-.76,2.9,10.2,10.2,0,0,0-.75,4.48s-1.59,7.18-1.41,9.23-1,7.09-1,7.09l-1.69,16.23s-1.12,14.08-.56,17.91a34.37,34.37,0,0,1-.38,9s1.13,11.1.85,12.31-1.69,6.44-.85,9.33.38,10.82.38,10.82.56,10.45,1.22,13.81a23.64,23.64,0,0,1-.19,7.65s-.66,7.18-.94,7.18-2.72,4.94,2.25,9.79,1.89,4.1,1.89,4.1-4-2-3.48,2.06c.44,3.81,1.06,2.82,1.12,2.71l-.94,3.07.66.09-.54.65a14.05,14.05,0,0,1-1.9,2,4.07,4.07,0,0,0-1.22,2.7s-6.95,7.56-13.43,11.38c-3.41,2-6.35,3.71-7.63,5.13-1.16,1.26-1,2.28,1.43,3.08,5.07,1.68,14,2.52,20.38.37a23.84,23.84,0,0,0,10-6.43s4-2.06,8-1.31,11.84-4.38,11.84-4.38l-.15-1.32-.41-3.82a3,3,0,0,1-.66-2.32,12,12,0,0,0-.33-3.36c-.07-.37-.14-.74-.21-1.08l.72-.14s-.93-4.75.76-5.69,1.21-13.15,1.21-13.15-2.15-2.8-3.28-3.26-.1-6.26.1-7,1.69-15.21,1.69-15.21-.57-4.56.18-6.52-.94-9.52-.94-9.52a1.74,1.74,0,0,1,.47-2.05c1-1.12.66-11.1.66-11.1s-.09-5-.09-6.35,1.12-6.06,2.16-7.64.37-6.53.37-6.53v0l.06-.37c0-.14,0-.32.08-.53l.08-.5a72.67,72.67,0,0,1,1.84-8.1c1.22-3.91,2.63-10.81,2.63-10.81l8.73-22.78.1-.27s4,7.46,4,14.37c0,0,1,8.3.76,10.54S1065,728,1065,728s1.22,15.11,1.22,15.76,1.51,12.31,2.45,14.09-.94,7.18-1.51,7.74.19,14.27.19,14.27-1.41,10.82-1.69,13.06-1.41,10.82-.47,14.18.56,3.82.56,3.82,3.39,3.46,1.41,3.74a5.17,5.17,0,0,0-3.76,6.8,89.61,89.61,0,0,0,4.14,10l1.56-.33,0,1.11.11,5.56s.66,5.31.28,6.53c-.27.88-.65,5.06-.83,7.25-.07.8-.11,1.33-.11,1.33s0,4.94,10.43,3.45,12.3-5.6,12.3-5.6l.08-.51c.15-.94.49-2.94.77-4.06.37-1.49-3-8.21-3-8.21s-.56-4.57-1.5-5.59a5,5,0,0,1-.76-2c-.08-.38-.16-.77-.22-1.15a6.78,6.78,0,0,1,.7.12s-.57-3.26,1.6-4.29,1.59-3.17,1.31-4.1.84-6.16.84-6.16a3,3,0,0,1,.75-3c1.32-1.31,2.35-10.45,2.35-10.45l.19-35.26s.66-6.25-.09-8.77-1.5-7.37-.47-8.68.09-7.36.09-7.36,0-12.78,1.41-16,.94-23.23.94-23.23l.37-13.15s3.07-2.9,2.35-18c3.27-.21,7-.33,7.52.13,1,.84,7.7,5.13,11.65,2.42a52.29,52.29,0,0,0,4.69-3.63l-1.66-28c1,1.56,1.66,2.59,1.66,2.59,0-3.91,11.09-16.6,11.09-16.6s10.33-13.34,12.58-14.92,6.67-10,6.67-10a40.59,40.59,0,0,1,2.26-4.66C1156.49,596.65,1153.11,592.17,1153.48,591.15Zm-24.23,9.79c-2.82.28-8.74,6.72-8.83,8.12a5.76,5.76,0,0,1-1.25,2.5c0-.56-.09-1.13-.14-1.71-.66-8.25-1.38-18.29-1-19.26.56-1.68.37-9.24.37-9.24h0l.11-.15c1.89,5.86,7.77,12.76,7.77,12.76s1,3,2.26,3.07S1129.25,600.94,1129.25,600.94Z"
        transform="translate(-28.43 -18.54)"
        fill="url(#488cd128-ff9c-494f-bd41-35fb6c1caf21)"
      />
      <path
        d="M978.65,598.81s3.43-18,14.44-18l8.06,16.57-5.37,3.7S984.11,601.4,978.65,598.81Z"
        transform="translate(-28.43 -18.54)"
        fill="#65617d"
      />
      <path
        d="M1001.15,597.33l-5.37,3.7s-8.21.26-14.08-1.18a16.24,16.24,0,0,1-3.05-1l.06-.29,0-.06a40,40,0,0,1,2.08-6.6c.34-.81.72-1.64,1.14-2.47,1.61-3.1,3.88-6.15,7-7.65a9.49,9.49,0,0,1,3.67-1h.49l.18.37,2.72,5.6Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M1092.61,671.94s11.57-1.11,12.59-.27,7.59,5.09,11.47,2.4,1.3-12,1.3-12.4-.37-13.61-.37-13.61l-6.94-9.35-8.7-16.38-17.78-1.76.46,26-.09,13.33Z"
        transform="translate(-28.43 -18.54)"
        fill="#65617d"
      />
      <path
        d="M1092.61,671.94s11.57-1.11,12.59-.27,7.59,5.09,11.47,2.4,1.3-12,1.3-12.4-.37-13.61-.37-13.61l-6.94-9.35-8.7-16.38-17.78-1.76.46,26-.09,13.33Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M990.78,580.3s-.93,11.29-8,11.48c0,0-2-1.2-4.68-3.21-6.18-4.63-16-13.52-13.28-21.79,3.89-11.85,22.77,10,22.77,10l1.46,1.63Z"
        transform="translate(-28.43 -18.54)"
        fill="#fbbebe"
      />
      <path
        d="M990.78,580.3s-.93,11.29-8,11.48c0,0-2-1.2-4.68-3.21l-.6-.77a9.21,9.21,0,0,0,3.86,1,5.21,5.21,0,0,0,5-3.17,40,40,0,0,0,2-4.49,14,14,0,0,0,.71-2.77Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M987.72,600.76l-1.58-2-5.33-6.86-2.71-3.51a9.13,9.13,0,0,0,3.85,1,5.18,5.18,0,0,0,5-3.17,39.18,39.18,0,0,0,1.95-4.48c.88-2.5.86-3.78.55-4.22s2,1.68,3.06,2.72l0,0,.51.48.19.38L996,586.5a1.45,1.45,0,0,1,0,.23C996.2,588.43,997.1,599.22,987.72,600.76Z"
        transform="translate(-28.43 -18.54)"
        fill="#e7effd"
      />
      <path
        d="M1043.18,839s-7.78,5.1-11.67,4.35a14,14,0,0,0-7.87,1.3,23.36,23.36,0,0,1-9.81,6.39c-6.3,2.13-15.09,1.29-20.09-.37-2.36-.79-2.55-1.81-1.41-3.06s4.16-3.09,7.52-5.09c6.39-3.8,13.24-11.29,13.24-11.29a4,4,0,0,1,1.2-2.69,13.8,13.8,0,0,0,1.87-2c1-1.17,1.93-2.4,1.93-2.4L1041,825s.39,1.65.7,3.34a12.08,12.08,0,0,1,.32,3.33,3,3,0,0,0,.65,2.31l.41,3.78Z"
        transform="translate(-28.43 -18.54)"
        fill="#65617d"
      />
      <path
        d="M1091,845.42c-.27,1.11-.61,3.09-.76,4,0,.31-.07.51-.07.51s-1.85,4.07-12.13,5.55-10.27-3.42-10.27-3.42l.1-1.33c.18-2.16.55-6.31.82-7.19.37-1.2-.27-6.48-.27-6.48l-.11-5.52-.08-3.83,17-1.76a32.8,32.8,0,0,0,.55,3.79,4.87,4.87,0,0,0,.75,2c.92,1,1.48,5.55,1.48,5.55S1091.4,843.94,1091,845.42Z"
        transform="translate(-28.43 -18.54)"
        fill="#65617d"
      />
      <path
        d="M1041,825s.39,1.65.7,3.34c-2.47.45-13.27,2.32-16,1-3.06-1.48-9.63-2.31-9.63-2.31l.11-.38c1-1.17,1.93-2.4,1.93-2.4Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M1085.84,829.77c-4.31-.73-13.78,1-17.5,1.8l-.08-3.83,17-1.76A32.8,32.8,0,0,0,1085.84,829.77Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M1095.47,689.44l-.36,13s.46,19.9-.93,23-1.39,15.83-1.39,15.83.93,6-.09,7.31-.28,6.11.46,8.61.09,8.7.09,8.7l-.18,35s-1,9.07-2.32,10.37a3.05,3.05,0,0,0-.74,3s-1.11,5.18-.83,6.11.83,3.05-1.29,4.07-1.58,4.26-1.58,4.26c-5.09-1.21-19.53,2-19.53,2a88.58,88.58,0,0,1-4.08-9.91,5.13,5.13,0,0,1,3.71-6.76c1.94-.27-1.39-3.7-1.39-3.7s.37-.46-.56-3.8.19-11.85.47-14.07,1.66-13,1.66-13-.74-13.61-.18-14.16,2.4-5.93,1.48-7.68-2.41-13.33-2.41-14-1.2-15.65-1.2-15.65-1.11-10.46-.83-12.68-.75-10.46-.75-10.46c0-6.85-4-14.26-4-14.26l-.1.27L1050,713.6s-1.39,6.85-2.59,10.74a70.55,70.55,0,0,0-1.81,8l-.08.5-.08.52-.06.37v0s.64,4.9-.38,6.48a23.11,23.11,0,0,0-2.12,7.59c0,1.3.09,6.3.09,6.3s.37,9.9-.65,11a1.73,1.73,0,0,0-.46,2s1.66,7.5.92,9.44-.18,6.48-.18,6.48-1.48,14.35-1.67,15.09-1.2,6.48-.09,6.94,3.24,3.24,3.24,3.24.46,12.13-1.2,13.05-.75,5.65-.75,5.65-13.42,2.59-16.47,1.11-9.63-2.31-9.63-2.31l.92-3c-.06.11-.67,1.1-1.1-2.69-.47-4,3.42-2,3.42-2s3.06.74-1.85-4.07-2.5-9.72-2.22-9.72.92-7.13.92-7.13a23.57,23.57,0,0,0,.19-7.59c-.65-3.33-1.2-13.7-1.2-13.7s.46-7.87-.38-10.74.56-8,.84-9.26-.84-12.22-.84-12.22a34.27,34.27,0,0,0,.38-9c-.56-3.8.55-17.78.55-17.78l1.67-16.1s1.2-5,1-7,1.39-9.16,1.39-9.16a10.16,10.16,0,0,1,.74-4.45c.93-1.85,1.3-8,1.3-8l8.89-20.36,4.35-18,58.78-.56s.21,1.56.57,4.39.86,7,1.42,12.19c.51,4.7,1.07,10.23,1.62,16.38C1099.18,685.92,1095.47,689.44,1095.47,689.44Z"
        transform="translate(-28.43 -18.54)"
        fill="#3f3d56"
      />
      <path
        d="M1090,527.35,1076.31,542s-17.58-7-15.73-9.45c.71-.93.6-3.87.19-7.11-.65-5.13-2-11-2-11s30.73-5,28.13.18a8.52,8.52,0,0,0-.19,6.15A23.29,23.29,0,0,0,1090,527.35Z"
        transform="translate(-28.43 -18.54)"
        fill="#fbbebe"
      />
      <path
        d="M1086.86,514.57c-.94,1.9-1.39,2.08-.8,4.12-4,4.31-9.13,9-15.49,9a21.92,21.92,0,0,1-9.8-2.3c-.65-5.13-2-11-2-11S1089.46,509.39,1086.86,514.57Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M1092.61,505.13a22,22,0,0,1-44.07,0c0-.11,0-.21,0-.32a22,22,0,0,1,44.06.32Z"
        transform="translate(-28.43 -18.54)"
        fill="#fbbebe"
      />
      <path
        d="M1095.8,650.48c-2.92,0-12.64.1-23.5.28h-.13l-3.59.06h-.11c-12.88.2-25.57-2.31-30.67-1.84-10.83,1,3.89-10,3.89-10a90.83,90.83,0,0,0,24.67,2.49l3.12-.16c9.84-.56,19.73-1.48,24.9-3C1094.74,641.15,1095.24,645.31,1095.8,650.48Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M1095.8,649.92c-2.92,0-12.64.11-23.5.28h-.13l-3.59.06h-.11c-12.88.21-25.57-2.31-30.67-1.83-10.83,1,3.89-10,3.89-10a90.37,90.37,0,0,0,24.67,2.49l3.12-.16c9.84-.55,19.73-1.48,24.9-3C1094.74,640.59,1095.24,644.75,1095.8,649.92Z"
        transform="translate(-28.43 -18.54)"
        fill="#5f5d7e"
      />
      <path
        d="M1064.65,533.46l-17,8-13.15,101.64s7.78-3.52,12.22-1.3,18.14.19,18.14.19,10-.56,11.48.56,18.89-4.63,18.89-4.63,3.15-7,.74-8.15.74-12,.74-12l-1.48-73.32-3-9.44-8-4.82-8.14,6.48-3.89.56Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M1064.65,532.35l-17,8L1034.47,642s7.78-3.52,12.22-1.3,18.14.19,18.14.19,10-.56,11.48.55,18.89-4.62,18.89-4.62,3.15-7,.74-8.15.74-12,.74-12l-1.48-73.32-3-9.44-8-4.82-8.14,6.48-3.89.56Z"
        transform="translate(-28.43 -18.54)"
        fill="#e7effd"
      />
      <path
        d="M1064.37,537.07s4.91,5.83,4.82,7-.28,4.08-.28,4.08l-3.7,7.49s-2,9.35-2,11.3-3.24,18.79-3.24,18.79L1056,611.68l-4.91,34,5,8.61,5.93-5,7.87-60.54,1.66-11.94s1.76-21.48,1.76-23.7a75.45,75.45,0,0,0-1-8.05s1.21-5.56,6.21-6.85-.38-.28-.38-.28l-2.86-2.31-2.5,1S1065.85,534.48,1064.37,537.07Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M1063.82,536.51s4.9,5.83,4.81,7-.28,4.07-.28,4.07l-3.7,7.5s-2,9.35-2,11.29-3.24,18.79-3.24,18.79l-3.88,25.92-4.91,34,5,8.61,5.92-5,7.87-60.54,1.67-11.94s1.76-21.48,1.76-23.7a75.73,75.73,0,0,0-1-8.06s1.2-5.55,6.2-6.85-.37-.27-.37-.27l-2.87-2.32-2.5,1S1065.3,533.92,1063.82,536.51Z"
        transform="translate(-28.43 -18.54)"
        fill="#3355ff"
      />
      <path
        d="M1060.58,526.79s-.74.56-.93,4.26-2.78,12-2.78,12,9.63-6.66,14.44-5.92Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M1060.58,525.68s-.74.56-.93,4.26-2.78,12-2.78,12,9.63-6.66,14.44-5.92Z"
        transform="translate(-28.43 -18.54)"
        fill="#e7effd"
      />
      <path
        d="M1086.87,523.83l-15.18,13.33s12.77,7.59,14.44,9.44,3.33-18.14,3.33-18.14Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M1087.42,522.72l-15.18,13.33s12.78,7.59,14.44,9.44,3.33-18.14,3.33-18.14Z"
        transform="translate(-28.43 -18.54)"
        fill="#e7effd"
      />
      <path
        d="M1061.13,526.79s-1.66-.83-3.24,1.58a10.45,10.45,0,0,1-4.53,3.51s-16.85,2.69-17.5,4.91l-7.87.46s-2.78.37-3,6.21-1.76,6.38-1.76,6.38-3.24,5.74-3,8.7a4.87,4.87,0,0,1-2.5,4.45l11.57,30.08s.37,12.41-1.76,16.94-6.11,24.63-6.11,24.63,1.67-.37,1.57.74-2,13.24-2,13.24-.56,4.81-1.48,6.48-1,10.36-1,10.36l-1.48,6.3s3.51,7.87,8.88,6.76S1041,656.39,1041,656.39l6.2-22.68,4.82-22.4,1.39-15.18,2.22-33.61,3.24-22.21S1062.43,528.37,1061.13,526.79Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M1060.58,525.68s-1.67-.83-3.24,1.58a10.51,10.51,0,0,1-4.54,3.51s-16.85,2.69-17.5,4.91l-7.86.46s-2.78.37-3.06,6.2-1.76,6.39-1.76,6.39-3.24,5.74-3,8.7a4.85,4.85,0,0,1-2.5,4.45L1028.73,592s.37,12.41-1.76,16.94-6.11,24.63-6.11,24.63,1.67-.37,1.58.74-2,13.23-2,13.23-.55,4.82-1.48,6.48-1,10.37-1,10.37l-1.48,6.3s3.52,7.87,8.89,6.75,15.09-22.12,15.09-22.12l6.2-22.68,4.81-22.4L1052.8,595l2.22-33.61,3.24-22.21S1061.87,527.26,1060.58,525.68Z"
        transform="translate(-28.43 -18.54)"
        fill="#65617d"
      />
      <path
        d="M1001.15,597.33l-5.37,3.7s-8.21.26-14.08-1.18l-3-1.33-.6-.26.62.2a12.26,12.26,0,0,0,7.41.26c7.6-2.56,6.76-15.1,6.46-17.94,0-.29-.05-.47-.06-.54v0l0,.07a5,5,0,0,0,.35.49l.34.36h0L996,586.5a1.45,1.45,0,0,1,0,.23Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M1019.75,561.14l-2.59.74-.37,5.27s-3-.46-3.89,3.15a12.71,12.71,0,0,1-2.31,5.28s-5.09,4.26-5.37,7.87l-3.15,1.94s-7.31-1.67-9-4.63c0,0,3.34,23.88-14.44,18,0,0,19.9,8.7,20.83,9.91s7,4.72,12.59,1.76,6.76-7.5,6.76-7.5,5.37-7.5,5.55-8.61,4.35-2.41,4.35-2.41l8-19.25Z"
        transform="translate(-28.43 -18.54)"
        fill="#65617d"
      />
      <path
        d="M1084.74,534.94l2.68-12.22s1.21,4,2.41,4.91l4,3s4,1.85,5.37,1.85,8.89,2,9.81,3,4.63.28,4.63.28,3.05,1,5.74,1.67,4,5.09,3.42,6.85a5.35,5.35,0,0,0,1.3,5c1.11,1.11,1.67,4.72,1.67,4.72a5.42,5.42,0,0,1,3.14,2.68c.93,2,.65,6.48.65,6.48l-13.79,19.44s.18,7.5-.37,9.17,1.94,30,1.94,30l2.87,48.69a50.51,50.51,0,0,1-4.63,3.61c-.83.37-1.66-17.22-1.66-17.86s-21.39-32-21.39-32-2.87-4.63-2.87-5.65-2.68-10.37-2.68-10.37l-4.07-18Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M1130.69,562.11c0,.64,0,1.06,0,1.06l-13.78,19.42v0s.19,7.5-.37,9.17c-.32,1,.38,10.93,1,19.11.47,5.9.9,10.88.9,10.88l1.22,20.65,1.65,28a50.51,50.51,0,0,1-4.63,3.61c-.83.37-1.66-17.22-1.66-17.87s-21.39-32-21.39-32-2.87-4.63-2.87-5.65-2.68-10.37-2.68-10.37l-4.07-18,1.85-55.17,1.57-12.22s2.32,4,3.52,4.9l4,3.06s4,1.85,5.37,1.85,8.89,2,9.81,3,4.63.28,4.63.28,3.06,1,5.74,1.67,4,5.09,3.42,6.85a5.36,5.36,0,0,0,1.3,5c1.11,1.11,1.67,4.72,1.67,4.72a5.42,5.42,0,0,1,3.14,2.68A15,15,0,0,1,1130.69,562.11Z"
        transform="translate(-28.43 -18.54)"
        fill="#65617d"
      />
      <path
        d="M1017.53,808.76c.46,0,19.9.74,19.53,3.89S1017.53,808.76,1017.53,808.76Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M1021.88,814s13.05,2.13,9.63,4.07S1021.88,814,1021.88,814Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M1070.39,806.73s21.66,1.85,18.42,4.25-10.92,2.78-11.29,2.87S1070.39,806.73,1070.39,806.73Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M1067.8,816.26s12,2,12.4,4.35S1067.8,816.26,1067.8,816.26Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M1074.46,760.53s11,2.59,11.67,4.35Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M1032,768.49s-5.74,1.67-.18,5S1032,768.49,1032,768.49Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M1057.43,679.53c.65,0,10.74-3.33,14.26-1.85a23.45,23.45,0,0,0,7.86,1.48Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M1058.73,690.08l-.1.92L1050,713.6s-1.39,6.85-2.59,10.74a70.55,70.55,0,0,0-1.81,8l7.64-47.37Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M1072.17,650.2l-3.59.06h-.11l-2.11-9.33,3.12-.17Z"
        transform="translate(-28.43 -18.54)"
        fill="#3f3d56"
      />
      <path
        d="M1115.84,638.9l-2.3,1.9-7.7,6.33s-20.82,11.11-26.56.56c-5.06-9.3,18.55-15.94,24.24-17.39l1.21-.29Z"
        transform="translate(-28.43 -18.54)"
        fill="#fbbebe"
      />
      <path
        d="M1026.88,547.9s4.07,1.85,5,4.44S1026.88,547.9,1026.88,547.9Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M1014.29,575.67s-5.92,7.22-3.52,10S1014.29,575.67,1014.29,575.67Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M1120.19,552s-5.55.56-5.74,5.37Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M1068.72,627.88c.56-.56,13.33-19.44,16.3-17.77Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M1092.61,505.13a22,22,0,0,1-2.61,10.4l-.16,0c-1.4-.3-2.13-1.92-3.19-2.94a4.33,4.33,0,0,0-5-.7,5.08,5.08,0,0,0-2.46,4.75c-.7-3-.48-6.12-1.17-9.09s-2.76-6-5.6-6c-1.22,0-2.65.45-3.53-.47-.53-.55-.64-1.42-1-2.09-2-3.29-8.2-1.63-10.72.06s-5.45,4.37-8.58,5.81a22,22,0,0,1,44.06.32Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M1067.85,498.38c.4.67.51,1.54,1,2.1.88.91,2.31.44,3.53.46,2.84.05,4.92,3.06,5.6,6s.47,6.12,1.18,9.08a5,5,0,0,1,2.45-4.74,4.35,4.35,0,0,1,5,.69c1.06,1,1.79,2.65,3.19,2.94s2.74-1.05,3.24-2.52a38.58,38.58,0,0,0,.8-4.61c.63-2.88,2.52-5.25,3.56-8a14.51,14.51,0,0,0-.09-10.34c-.7-1.74-1.73-3.3-2.43-5-1.07-2.63-1.35-5.61-2.65-8.12a9.6,9.6,0,0,0-11.53-4.74c-2,.76-3.76,2.22-5.8,2.88-2.74.88-5.66.22-8.49-.18s-6-.43-8.24,1.43c-2.62,2.15-3.34,6.18-5.8,8.53-1,1-2.32,1.62-3.41,2.53a4.7,4.7,0,0,0-1.91,3.76c.17,1.92,2,3.66,1.35,5.44a4.22,4.22,0,0,1-1,1.35,19.38,19.38,0,0,0-4.48,7.63c5,1.54,10.32-3.92,14.19-6.5C1059.65,496.76,1065.82,495.1,1067.85,498.38Z"
        transform="translate(-28.43 -18.54)"
        fill="#7c5c5c"
      />
      <path
        d="M1115.84,638.9l-2.3,1.9c-2-3.39-10.38-10.15-10.38-10.15l.36-.35,1.21-.29Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M1118.06,635.47s-.82,2.06-1.68,3.84-1.79,3.4-1.83,2.09c-.1-2.6-10.83-11.3-10.83-11.3l1.45-1.42,1.69-1.64Z"
        transform="translate(-28.43 -18.54)"
        fill="#e7effd"
      />
      <path
        d="M1118.43,621.77l1.22,20.65c-2.88-4.47-10.77-15.93-15.84-15.56l12.31-14.16a16.5,16.5,0,0,0,1.41-1.81C1118,616.79,1118.43,621.77,1118.43,621.77Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M1118.06,635.47s-.82,2.06-1.68,3.84c-3.23-4.42-7.66-9.65-11.21-10.63l1.69-1.64Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M1127.32,560.58l3.33,2.59s5.56.1,6.11,4.72,5.65,6.76,5.65,6.76,3.79,3.8,3.79,5.56,2.87,4.9,2.87,5.18,2.78,5.92,2.41,6.94,3,5.46,1.94,7.13a42.87,42.87,0,0,0-2.22,4.63s-4.35,8.33-6.57,9.9-12.4,14.82-12.4,14.82-10.93,12.58-10.93,16.47c0,0-10.64-17.77-16.94-17.31l12.31-14.16s2.13-2.32,2.23-3.7,5.92-7.78,8.7-8.06c0,0,.46-3.79-.74-3.89s-2.22-3-2.22-3-8.15-9.63-8.24-15.74S1127.32,560.58,1127.32,560.58Z"
        transform="translate(-28.43 -18.54)"
        fill="#65617d"
      />
      <path
        d="M1132.23,569.37s-7.78,5.74-6.11,7.6S1132.23,569.37,1132.23,569.37Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M1132.6,593.07s14.44-4.63,15.92,0Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M1043.18,839s-7.78,5.1-11.67,4.35a14,14,0,0,0-7.87,1.3,23.36,23.36,0,0,1-9.81,6.39c-6.3,2.13-15.09,1.29-20.09-.37-2.36-.79-2.55-1.81-1.41-3.06,5.43,1.08,17.58,3.23,20.85,1.67a86.78,86.78,0,0,0,10.37-6.48s8-1.11,9.07-1.11c.79,0,6.94-2.54,10.41-4Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M1090.27,849.45c0,.31-.07.51-.07.51s-1.85,4.07-12.13,5.55-10.27-3.42-10.27-3.42l.1-1.33C1071.15,852,1078.25,853.37,1090.27,849.45Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M1030.72,568.26s0,21.11-1.8,23.19S1030.72,568.26,1030.72,568.26Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M1114.17,575.07l2.69,7.54S1117.92,575.21,1114.17,575.07Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <g opacity="0.1">
        <path
          d="M1048.72,494.15c.68-1.73-1.1-3.44-1.33-5.3a3.41,3.41,0,0,0-.3,1.67c.12,1.41,1.16,2.72,1.43,4A2.28,2.28,0,0,0,1048.72,494.15Z"
          transform="translate(-28.43 -18.54)"
        />
        <path
          d="M1079.44,514.09c-.66-2.92-.46-6-1.14-8.93s-2.76-6-5.6-6c-1.22,0-2.65.44-3.53-.47-.54-.55-.64-1.42-1-2.1-2-3.28-8.2-1.61-10.73.07-3.78,2.51-9,7.78-13.84,6.58-.23.56-.45,1.13-.63,1.72,5,1.54,10.32-3.92,14.19-6.5,2.53-1.68,8.7-3.34,10.73-.06.4.67.51,1.54,1,2.1.88.91,2.31.44,3.53.46,2.84.05,4.92,3.06,5.6,6s.47,6.12,1.18,9.08A5,5,0,0,1,1079.44,514.09Z"
          transform="translate(-28.43 -18.54)"
        />
        <path
          d="M1093.36,510.62c-.5,1.47-1.82,2.82-3.25,2.52s-2.12-1.92-3.18-2.94a4.36,4.36,0,0,0-5-.7,5.06,5.06,0,0,0-2.46,4.49,4.83,4.83,0,0,1,2.18-2.68,4.35,4.35,0,0,1,5,.69c1.06,1,1.79,2.65,3.19,2.94s2.74-1.05,3.24-2.52a11.81,11.81,0,0,0,.51-2.66A6.42,6.42,0,0,1,1093.36,510.62Z"
          transform="translate(-28.43 -18.54)"
        />
        <path
          d="M1097.72,498c-1,2.74-2.93,5.11-3.56,8-.12.58-.2,1.18-.27,1.78.64-2.88,2.51-5.24,3.55-8a13.89,13.89,0,0,0,.85-3.84A14,14,0,0,1,1097.72,498Z"
          transform="translate(-28.43 -18.54)"
        />
      </g>
      <circle cx="935.51" cy="546.26" r="0.23" fill="#e6e8ec" />
      <rect x="849.12" y="551.42" width="181.18" height="208.22" rx="6.61" ry="6.61" fill="#fff" />
      <rect
        x="849.12"
        y="551.42"
        width="181.18"
        height="208.22"
        rx="6.61"
        ry="6.61"
        fill="#5a5773"
        opacity="0.1"
      />
      <rect x="858.36" y="562.04" width="162.7" height="186.98" rx="6.61" ry="6.61" fill="#fff" />
      <rect
        x="882.03"
        y="599.54"
        width="111.62"
        height="38.52"
        rx="6.03"
        ry="6.03"
        fill="#3355ff"
      />
      <rect x="886.13" y="652.15" width="103.43" height="7.86" fill="#3355ff" />
      <rect x="868.55" y="668.74" width="142.32" height="7.86" fill="#3355ff" />
      <rect x="868.55" y="686.2" width="142.32" height="7.86" fill="#3355ff" />
      <rect x="868.55" y="703.66" width="142.32" height="7.86" fill="#3355ff" />
      <rect y="482.59" width="426.61" height="208.22" rx="6.61" ry="6.61" fill="#fff" />
      <rect
        y="482.59"
        width="426.61"
        height="208.22"
        rx="6.61"
        ry="6.61"
        fill="#5a5773"
        opacity="0.1"
      />
      <rect x="21.76" y="493.21" width="383.08" height="186.98" rx="6.61" ry="6.61" fill="#fff" />
      <rect x="77.51" y="530.72" width="262.81" height="38.52" rx="6.03" ry="6.03" fill="#3355ff" />
      <rect x="87.15" y="583.32" width="243.53" height="7.86" fill="#3355ff" />
      <rect x="45.75" y="599.91" width="335.1" height="7.86" fill="#3355ff" />
      <rect x="45.75" y="617.37" width="335.1" height="7.86" fill="#3355ff" />
      <rect x="45.75" y="634.83" width="335.1" height="7.86" fill="#3355ff" />
      <path
        d="M132.7,859.18c1.19-4.34,2-8.16,2-8.16a17,17,0,0,1,2.22-8.27l0-1.2h0l.34-8.81a29.33,29.33,0,0,0-2-4.7c-1.48-2.83.5-12.92.5-12.92s6.43-14.07,5.35-23.2,13.62-39.83,13.62-39.83a39.48,39.48,0,0,0-.92-9,6.9,6.9,0,0,1-.1-1.87,1.77,1.77,0,0,1,0-.23v.07c.43-6,5.59-17,5.59-17l.19-21.4s-2.54-12.72,3-29.45c1.95-5.84,3.23-10.52,4.07-14.14.1-.41.19-.8.27-1.18-10.08-1.94-17.78-3.52-17.78-3.52s6.83-24.38,11-28.53,7.83-17.57,7.83-17.57,2.74-17.3-.4-22.5-3.28-14-3.28-14-7.42-5.83-8.28-8.32-2.23-8.1-2.12-11,1.17-5.5.91-7.05,2.51-7.29,1.34-10.11a7.74,7.74,0,0,1-.4-2.69s0,0,0-.08v0a37.42,37.42,0,0,1,.95-7.19,20.4,20.4,0,0,1,7.7-3.74l.19-.66.5-1.71a8.33,8.33,0,0,1,.76-.42l.05-.63.16-2.49L165,510c-2-9.86,11.12-10.81,11.12-10.81a6.87,6.87,0,0,1,3.81-3.1c2.66-.82-.12,14.71-1.39,15.66-1,.71-4,5.5-5.45,7.85h0l-.24.39a5.4,5.4,0,0,1,.58.65l-.63,3.37-.1.51a14,14,0,0,1,1.95,3.63s-2.49,2.52-2.12,5.46a17.59,17.59,0,0,1-1,6.73c.14-.15,1.89-1.9,3.55-1.4s6.28,2.09,6.28,2.09,3.47.75,3.12,1.51,2.23,4.24,2.23,4.24l9.73-8.53c.11-.27.21-.53.31-.8a22.35,22.35,0,0,0,1-3.87,20.92,20.92,0,0,1-3-1.07,6.53,6.53,0,0,1-2.54-1.76c-.9-1.16-1-2.7-1.35-4.11-.64-2.76-2.14-5.26-3.19-7.91a25.29,25.29,0,0,1-1.34-14,9.32,9.32,0,0,1,1.6-4c1.62-2.05,4.43-2.8,6.52-4.4s3.49-4.13,5.89-5.3c2.18-1.06,4.77-.82,7.16-.34A38.26,38.26,0,0,1,220.55,496c1.34.87,2.81,1.87,4.4,1.64a6.07,6.07,0,0,0,3.3-2.23.74.74,0,0,1,0-.14l.11-.11a16.49,16.49,0,0,1,1.18,7.08c0,.37,0,.75-.08,1.12,0,.13,0,.26,0,.39a1.82,1.82,0,0,0,0,.33h0a1.65,1.65,0,0,0,.06.49,3.51,3.51,0,0,0,.83,1.31,7.15,7.15,0,0,1,.72,1.07c0-.13-.07-.26-.11-.39a5.58,5.58,0,0,1,.86,3,2.93,2.93,0,0,1-.79,2.09,9.29,9.29,0,0,1-1.58,1.18,17.95,17.95,0,0,1-9.28,18.29c-.12.26-.24.53-.35.8a22.36,22.36,0,0,0-2.1,10.17c0,.25,0,.5.08.75s.23.27.33.41h0s15.5.75,19.28-2.42,8.9,8.43,8.9,8.43,5.52,1.29,6.67.26,7.64.14,7.64.14a14,14,0,0,1,9.82-3.17,28.69,28.69,0,0,1,7.27-3.68h0l.18-.06h0a7.84,7.84,0,0,1,3.51-.31s7.87-6,10.22-9.31S305,517.69,305,517.63l.07-.6.19-1.82a6.12,6.12,0,0,0,.94.12l.24-.63a34.33,34.33,0,0,1,2.45-5.08s.09-2.31-.56-2.91.63-9,.63-9,7.49-15.8,13.18-3.57c0,0,11.34,8.21,1.22,16.87,0,0-4,1.74-4.57,3.21-.4,1-1.83,3.62-2.79,5.39l-.43.79.11.1-.2,1.5-.08.59c1.79,1.11,3,2.19,2.67,3a17,17,0,0,0-1.27,4.11S302.66,546,300.64,553.19c0,0-37.06,20.14-49,21.22l1.65,10.84a86.42,86.42,0,0,1,.14,8.79c-.25,2.3.94,12.81.94,12.81s1.47,15.46,3.14,17.68,1,11.44,1,11.44a77.91,77.91,0,0,0,1.88,13.16c1.52,5.91,0,13.09,0,13.09s5.51,14.07-8.59,4.13c0,0-7.08-.71-15.24-1.3,0,.26,0,.54,0,.81,0,1.06-.05,2.2-.08,3.4-.2,7.93-.57,18.85-1.25,27.1-1.2,14.59-6.76,43.33-6.76,43.33l-.56,14.52a19.24,19.24,0,0,1,.26,4.17,27,27,0,0,1-4.47,14.39l-1.49,9.65s-2.85,6.28-3.05,10.09a4.54,4.54,0,0,0,.08.93,7.42,7.42,0,0,1,.07,1.49c0,4.4-3.08,14.82-3.08,14.82s-.57,10.61-2.18,11.16c-1.38.48,1.58,6.19,2.46,7.83a1.63,1.63,0,0,0,.07-.3l.19.32a7.54,7.54,0,0,1,.39,2.71,3.87,3.87,0,0,1-1.91,3.66c-3.09,1.73-4.77,3.2-2.23,3.92a28.23,28.23,0,0,1,2.78.69l.15-.35a1.71,1.71,0,0,1,1,1.9,7.77,7.77,0,0,1-1.09,3.56,38.76,38.76,0,0,1-4.6,7.68l-1.22-.18a6.1,6.1,0,0,0,.66,1.33,5.08,5.08,0,0,0,1.74,1.67,5.56,5.56,0,0,0,2.14.82,6.17,6.17,0,0,1,4.42,2.37c1.5,2.11,2.39,4.94-.84,7.27l-11.51,3.48s-19.64,1.79-18.44-2.55,2-8.16,2-8.16a17.35,17.35,0,0,1,1.88-7.72,10.32,10.32,0,0,1,.74-1.12l-.69-.1S191,839.89,189.12,838c-.42-.45-.51-.78-.4-1-.17-.53.33-.82,1-1,0,.12.09.25.13.38a9.65,9.65,0,0,1,1.9-.13s.83-5.05-1.16-7a1.9,1.9,0,0,1-.34-1.52,7.79,7.79,0,0,1,.29-2.06.75.75,0,0,0,.07.12c1.22-4.56,5-11.74,5-11.74s.33-4.61-.87-6.51,1.13-25.06,1.13-25.06-.05-11.24,1.58-16.41-1.31-11.45-1.31-11.45,0-.12.05-.33a.41.41,0,0,0,0-.09s.1-.69.26-1.76l0,.11c.44-3,1.25-8.31,1.79-10.79.77-3.51.63-20.46.63-20.46L196.28,714l-5.57,12.26-6,16.4s-2.81,3.4-3,7c0,.18,0,.35,0,.53a8.32,8.32,0,0,1,0,1.11,9.92,9.92,0,0,1-1.88,5.85s-1.73,7.79-4,9.7-2.45,5.76-2.45,5.76-3.14,11.28-4.49,13.23c-1.13,1.64-1.37,6.27-1.41,7.69h0c0,.26,0,.41,0,.41s-.53,4.06-.65,7.48c0,.42,0,.83,0,1.21a.22.22,0,0,1,0-.08,11.59,11.59,0,0,0,.22,2.77s0,.11,0,.17l0-.58a29.09,29.09,0,0,1,.55,7.12c-.09,4.09-.9,8.91-3.49,11.66-4.48,4.76-7.15,4-7.15,4s1.83,6.23,4.32,7.56a1.59,1.59,0,0,1,.27.18c0-.12,0-.24.07-.35a3,3,0,0,1,.66,2.32c.08,2.71-1.8,7-3.5,9a5,5,0,0,1-2.19,1.18,3.77,3.77,0,0,0,.39.26,7.85,7.85,0,0,0,.86.44,4.25,4.25,0,0,0,1.28.39,6.08,6.08,0,0,1,4.42,2.37c1.5,2.1,2.39,4.93-.84,7.26l-11.51,3.48S131.49,863.52,132.7,859.18Z"
        transform="translate(-28.43 -18.54)"
        fill="url(#ccb18d0b-874b-442a-b8cb-57bcf76cdeb5)"
      />
      <path
        d="M207.05,869.31l11.15-3.49c3.13-2.34,2.27-5.17.82-7.28a5.84,5.84,0,0,0-4.27-2.35,5.22,5.22,0,0,1-2.08-.83A5,5,0,0,1,211,853.7a8.2,8.2,0,0,1-1.09-4.3s-11.94-4-15.38-.59A9,9,0,0,0,193,850.9a18,18,0,0,0-1.84,7.72s-.76,3.81-1.93,8.16S207.05,869.31,207.05,869.31Z"
        transform="translate(-28.43 -18.54)"
        fill="#2d293d"
      />
      <path
        d="M153.44,861.82l11.15-3.49c3.13-2.34,2.27-5.17.82-7.27a5.84,5.84,0,0,0-4.28-2.36,3.93,3.93,0,0,1-1.24-.38,7.86,7.86,0,0,1-.83-.45c-3-1.81-2.77-6-2.77-6s-11.94-4-15.38-.59a8.84,8.84,0,0,0-1.22,1.52,17.45,17.45,0,0,0-2.16,8.29s-.77,3.82-1.93,8.16S153.44,861.82,153.44,861.82Z"
        transform="translate(-28.43 -18.54)"
        fill="#2d293d"
      />
      <path
        d="M194.52,848.81A9,9,0,0,0,193,850.9h0l18,2.79a8.2,8.2,0,0,1-1.09-4.3S198,845.4,194.52,848.81Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M139.69,842.84l-.13,3.39c2.64,4.75,16.29,4.26,20.33,2.09a7.86,7.86,0,0,1-.83-.45c-3-1.81-2.77-6-2.77-6s-11.94-4-15.38-.59A8.84,8.84,0,0,0,139.69,842.84Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M138.1,828.16a31.07,31.07,0,0,1,2,4.7L139.61,845c2.88,5.2,18.94,4.12,21.2,1.44s4.84-9.83,2.43-11.15-4.18-7.56-4.18-7.56,2.59.72,6.94-4,3.53-15.73,2.85-18.37.45-11.38.45-11.38.08-6.16,1.39-8.11,4.36-13.23,4.36-13.23.14-3.85,2.37-5.76,3.92-9.71,3.92-9.71a10.06,10.06,0,0,0,1.79-6.55c-.31-3.86,2.92-7.9,2.92-7.9l5.87-16.4,5.4-12.27,2.49,7.33s.12,16.95-.63,20.46-2,12.86-2,12.86,2.84,6.27,1.26,11.45-1.56,16.41-1.56,16.41-2.28,23.17-1.12,25.06.83,6.5.83,6.5-6.82,13.29-4.9,15.22,1.12,7,1.12,7-4.3-.17-2.53,1.75S193,849.68,193,849.68l18.51,2.87a39.17,39.17,0,0,0,4.46-7.69c2.68-5.59-.26-5.09-2.71-5.8s-.83-2.19,2.16-3.92,1.46-5.95,1.46-5.95-4.17-7.71-2.6-8.26,2.12-11.16,2.12-11.16,3.56-12.5,2.92-15.91,2.91-11.44,2.91-11.44l1.44-9.64a26.63,26.63,0,0,0,4.09-18.17l.58-14.92S233.78,711,235,696.36c.76-9.34,1.14-22.11,1.31-30.08.1-4.48.14-7.44.14-7.44l-66.17-9.48a54.61,54.61,0,0,1-1.59,9.82c-.81,3.63-2.06,8.31-4,14.15-5.42,16.73-3,29.45-3,29.45l-.21,21.4s-6.4,14.08-5.35,19.05a40.64,40.64,0,0,1,.88,9S142.77,782.91,143.81,792s-5.21,23.21-5.21,23.21S136.67,825.33,138.1,828.16Z"
        transform="translate(-28.43 -18.54)"
        fill="#575988"
      />
      <path
        d="M179.17,749.5,159.05,746S170.06,758.16,179.17,749.5Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.05"
      />
      <path
        d="M162.73,726.39s-1,7.12,3.31,10C166,736.37,158.25,734.84,162.73,726.39Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M164.85,703.67s16.37,14.57,22.56,13.66S164.85,703.67,164.85,703.67Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M204,757s12.73,3.42,12.92,8.58S204,757,204,757Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M198.69,821s18,4.08,12.78,6.19-13.77,3.63-13.77,3.63S191.84,830.92,198.69,821Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.05"
      />
      <g opacity="0.05">
        <path
          d="M215,831a3.6,3.6,0,0,0,1.76-2.56l.17.33s1.54,4.21-1.46,6c-.34.19-.66.39-1,.58-.53-.12-1.11-.22-1.66-.38C210.37,834.22,212,832.74,215,831Z"
          transform="translate(-28.43 -18.54)"
        />
        <path
          d="M191.66,828.88c-.48-.48-.41-1.66,0-3.17a8.59,8.59,0,0,1,.86,4.5A3.5,3.5,0,0,0,191.66,828.88Z"
          transform="translate(-28.43 -18.54)"
        />
        <path
          d="M197.4,752.48a20.92,20.92,0,0,1,1,5.71,21.81,21.81,0,0,0-1.26-3.94S197.25,753.56,197.4,752.48Z"
          transform="translate(-28.43 -18.54)"
        />
        <path
          d="M156.17,742.81a7.34,7.34,0,0,1-.11-1.69c.19,1.16.31,2.23.38,3.17C156.36,743.81,156.27,743.32,156.17,742.81Z"
          transform="translate(-28.43 -18.54)"
        />
        <path
          d="M195.73,807.17a10.19,10.19,0,0,1-.32-3.43,11.57,11.57,0,0,1,.72,4.34A4.23,4.23,0,0,0,195.73,807.17Z"
          transform="translate(-28.43 -18.54)"
        />
        <path
          d="M190.81,836a60.4,60.4,0,0,1,1.75,9.53l18.51,2.87a38.76,38.76,0,0,0,4.47-7.69c.24-.49.42-.93.58-1.33,1.09.55,1.49,1.73-.11,5.05a39.23,39.23,0,0,1-4.46,7.68L193,849.26s-1-9.74-2.79-11.65C189.38,836.66,190,836.23,190.81,836Z"
          transform="translate(-28.43 -18.54)"
        />
        <path
          d="M216.44,809.35s-.56,10.61-2.12,11.16h0c-.71-1.79-1.17-3.47-.47-3.72,1.56-.56,2.13-11.16,2.13-11.16s3.56-12.49,2.92-15.91,2.9-11.43,2.9-11.43l1.45-9.65a26.63,26.63,0,0,0,4.09-18.17l.57-14.92s5.42-28.74,6.6-43.33c.75-9.34,1.13-22.11,1.31-30.08,0-1.44.06-2.72.08-3.8l.53.08s0,3-.14,7.43c-.17,8-.55,20.75-1.31,30.09-1.18,14.58-6.59,43.33-6.59,43.33l-.58,14.91a26.66,26.66,0,0,1-4.08,18.17L222.27,782s-3.55,8-2.91,11.44S216.44,809.35,216.44,809.35Z"
          transform="translate(-28.43 -18.54)"
        />
        <path
          d="M160.35,842.31a18,18,0,0,0,3.22-7.19c1.83,1.78-.6,8.35-2.75,10.9s-18.32,3.76-21.2-1.43l.11-2.93C143.73,845.94,158.21,844.85,160.35,842.31Z"
          transform="translate(-28.43 -18.54)"
        />
        <path
          d="M137.64,824a31.07,31.07,0,0,1,2,4.7l-.09,2.15a33.59,33.59,0,0,0-1.42-3.14,9.27,9.27,0,0,1-.52-3.83Z"
          transform="translate(-28.43 -18.54)"
        />
        <path
          d="M160,827.32a30.07,30.07,0,0,1-1.38-3.71s2.59.71,6.93-4.05c3.16-3.47,3.59-10.22,3.33-14.66.68,2.65,1.49,13.61-2.85,18.37C163.17,826.39,161.08,827.16,160,827.32Z"
          transform="translate(-28.43 -18.54)"
        />
        <path
          d="M169.31,793.52a82.23,82.23,0,0,0-.66,9.11,13,13,0,0,0-.26-1.44c-.67-2.65.44-11.38.44-11.38s.09-6.16,1.39-8.11,4.36-13.23,4.36-13.23.15-3.84,2.38-5.76,3.92-9.71,3.92-9.71a10.12,10.12,0,0,0,1.79-6.55c-.31-3.86,2.92-7.9,2.92-7.9l5.87-16.4,5.4-12.27,2.49,7.34s0,.9,0,2.34l-2-6-5.4,12.26-5.87,16.41s-3.23,4-2.92,7.9a10.06,10.06,0,0,1-1.79,6.55s-1.69,7.79-3.92,9.7-2.37,5.76-2.37,5.76-3.06,11.28-4.36,13.24S169.31,793.52,169.31,793.52Z"
          transform="translate(-28.43 -18.54)"
        />
      </g>
      <path
        d="M167.28,510.1l.94,5.66-.16,2.5-.12,1.84,6.39.91.77-1.3h0c1.42-2.35,4.36-7.14,5.29-7.86,1.22-.95,3.94-16.48,1.36-15.66a6.75,6.75,0,0,0-3.7,3.1S165.39,500.25,167.28,510.1Z"
        transform="translate(-28.43 -18.54)"
        fill="#ffcdd3"
      />
      <path
        d="M167.94,520.1l6.39.91.77-1.3h0a5.67,5.67,0,0,0-7-1.44Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M166.2,523.08l8.39,2.29.22-1.26.61-3.37a5.83,5.83,0,0,0-8.15-1.43l-.48,1.71Z"
        transform="translate(-28.43 -18.54)"
        fill="#dce6f2"
      />
      <path
        d="M303.74,516l8.84,5.2s.37-.71.89-1.68c.93-1.77,2.31-4.43,2.7-5.39.59-1.47,4.43-3.22,4.43-3.22,9.81-8.67-1.16-16.86-1.16-16.86-5.5-12.23-12.76,3.58-12.76,3.58s-1.25,8.43-.62,9,.54,2.91.54,2.91a34,34,0,0,0-2.38,5.08C303.91,515.45,303.74,516,303.74,516Z"
        transform="translate(-28.43 -18.54)"
        fill="#ffcdd3"
      />
      <path
        d="M303.74,516l8.84,5.2s.37-.71.89-1.68c-1.24-1.11-5.62-5-7.11-4.84a10.73,10.73,0,0,1-2.14,0C303.91,515.45,303.74,516,303.74,516Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M302.71,518.67l10,5.39.28-2.18.2-1.5s-5.68-5.26-7.42-5.14a9.44,9.44,0,0,1-2.66-.11l-.18,1.82Z"
        transform="translate(-28.43 -18.54)"
        fill="#dce6f2"
      />
      <path
        d="M190.45,548.34s44.07,6.7,35.9,3.7c-5.69-2.1-7.84-5.85-8.16-9.93a23.22,23.22,0,0,1,2-10.18,44.62,44.62,0,0,1,4.27-7.84s-33.12-19.91-27-2.73a27.14,27.14,0,0,1,1.61,8.09,22.8,22.8,0,0,1-1.18,8.08A24.2,24.2,0,0,1,190.45,548.34Z"
        transform="translate(-28.43 -18.54)"
        fill="#ffcdd3"
      />
      <path
        d="M197.5,521.36a27.14,27.14,0,0,1,1.61,8.09c3.08,2.79,6.58,2.75,11.07,2.92,3.45.14,7.23,1.12,10-.44a44.62,44.62,0,0,1,4.27-7.84S191.38,504.18,197.5,521.36Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <circle cx="183.01" cy="496.73" r="18.31" fill="#ffcdd3" />
      <path
        d="M190.45,548.34s44.07,6.7,35.9,3.7c-5.69-2.1-7.84-5.85-8.16-9.93-2.11-2.47-6.47-4.36-9.28-5.39a13.33,13.33,0,0,0-8-.44,11,11,0,0,0-3,1.25A24.2,24.2,0,0,1,190.45,548.34Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M166.2,523.08l8.39,2.29.22-1.26a7.47,7.47,0,0,0-8-3.09Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M302.71,518.67l10,5.39.28-2.18A75.72,75.72,0,0,0,302.89,517Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M168.65,659.18c17,3.37,41.3,7.83,45.21,6.8,3.25-.85,13.5-.35,22.41.3.1-4.48.14-7.44.14-7.44l-66.17-9.48A54.61,54.61,0,0,1,168.65,659.18Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M151.72,654.5s56.06,11.86,62.19,10.25,37.15,1.58,37.15,1.58c13.63,9.92,8.32-4.14,8.32-4.14s1.51-7.18,0-13.09a80,80,0,0,1-1.81-13.16s.67-9.22-.94-11.43-3-17.68-3-17.68-1.13-10.51-.89-12.81-.12-8.79-.12-8.79l-1.59-10.84c11.59-1.09,47.48-21.27,47.48-21.27,2-7.16,15.69-23.58,15.69-23.58a17.76,17.76,0,0,1,1.24-4.11c1-2.42-12.63-7.87-12.63-7.87S292,529.77,289.76,533.07s-9.91,9.32-9.91,9.32a7.51,7.51,0,0,0-3.4.31l-.18,0h0a27.47,27.47,0,0,0-7,3.69,13.4,13.4,0,0,0-9.52,3.17s-6.27-1.16-7.38-.13-6.46-.25-6.46-.25-5-11.58-8.61-8.41-18.67,2.44-18.67,2.44c-1.89-2.74-6.69-4.83-9.69-5.93a13.25,13.25,0,0,0-8-.44,10.39,10.39,0,0,0-3.23,1.41l-9.44,8.56s-2.49-3.48-2.15-4.24-3-1.5-3-1.5-4.41-1.56-6.08-2.08-3.3,1.24-3.44,1.4a17.78,17.78,0,0,0,1-6.73c-.35-2.94,2.05-5.47,2.05-5.47-4.87-13.43-17.44-2.82-17.44-2.82s-1.67,7.17-.54,10-1.56,8.56-1.32,10.11-.77,4.13-.88,7.05,1.21,8.52,2,11,8,8.32,8,8.32.13,8.78,3.16,14,.37,22.5.37,22.5-3.6,13.41-7.61,17.57S151.72,654.5,151.72,654.5Z"
        transform="translate(-28.43 -18.54)"
        fill="#656691"
      />
      <path
        d="M237.88,556.48s1.89-5,3.44-5.41a35.43,35.43,0,0,0,4.54-1.83l-.92-1.93s-5.84,1.37-6.82,3S237.88,556.48,237.88,556.48Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M269.22,546.45c.25,1.55,13.88,3.46,13.88,3.46l-6.65-7.21h0l-.17,0h0A27.47,27.47,0,0,0,269.22,546.45Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <circle cx="281.2" cy="508.32" r="1.23" fill="#575988" />
      <circle cx="279.53" cy="510.72" r="1.23" fill="#575988" />
      <circle cx="277.9" cy="512.93" r="1.23" fill="#575988" />
      <circle cx="276.2" cy="515.33" r="1.23" fill="#575988" />
      <circle cx="131.25" cy="509.62" r="1" fill="#575988" />
      <circle cx="131.01" cy="511.88" r="1" fill="#575988" />
      <circle cx="130.78" cy="514.14" r="1" fill="#575988" />
      <path
        d="M236.2,598.15c.15-.17-36.2,42.27-62.14,15.94C174.06,614.09,216.36,621.49,236.2,598.15Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M255.24,621.68s-20.77-.23-23.17,5.65l-.24,6.21a4,4,0,0,0,3.86.15c2.14-1.05,14.92-6.94,19.23-3.7Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M254.85,621.66s-19.85-.22-22.15,5.39l-.23,5.92a3.8,3.8,0,0,0,3.69.14c2-1,14.27-6.61,18.39-3.53Z"
        transform="translate(-28.43 -18.54)"
        fill="#656691"
      />
      <path
        d="M245.65,576.2a67.4,67.4,0,0,1-8.57,13.49A54.07,54.07,0,0,1,224,601.37S245.19,579,245.65,576.2Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M253.36,552.36s-4,14.81-13.15,19.54Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M258.61,554.07c.1-.27,2.62,11.94-12.21,18.07C246.4,572.14,252.67,570.27,258.61,554.07Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M168.42,540.57c.23,0-7.37,4.45-9.47,6.56C159,547.13,164.05,540.09,168.42,540.57Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M215.75,532.05a3.93,3.93,0,0,1-1.53,2.42,3.77,3.77,0,0,1-1.74.31c-5.59.14-11.41.16-16.48-2.19a6.22,6.22,0,0,1-2.45-1.76c-.88-1.16-1-2.69-1.31-4.11-.62-2.76-2.07-5.25-3.08-7.9a26,26,0,0,1-1.27-14,9.37,9.37,0,0,1,1.55-4c1.56-2.05,4.29-2.8,6.31-4.41s3.38-4.13,5.72-5.31c2.1-1.06,4.61-.83,6.92-.34a36.32,36.32,0,0,1,12.7,5.33c1.29.87,2.71,1.86,4.25,1.63a5.92,5.92,0,0,0,3.26-2.3,17,17,0,0,1,1.06,8,3.45,3.45,0,0,0,0,1.2,3.65,3.65,0,0,0,.8,1.31c1.31,1.65,2.08,4.21.66,5.77-.62.68-1.55,1-2.15,1.73-1.08,1.24-.81,3.1-.85,4.75a2.5,2.5,0,0,1-.46,1.61,2.39,2.39,0,0,1-2.28.45,6.22,6.22,0,0,0-2.4-.32,4,4,0,0,0-2.15,1.52C218.12,524.58,217,528.15,215.75,532.05Z"
        transform="translate(-28.43 -18.54)"
        fill="#2d293d"
      />
      <g opacity="0.1">
        <path
          d="M193,529.39a6.14,6.14,0,0,0,2.45,1.77c5.07,2.35,10.89,2.32,16.48,2.19a3.65,3.65,0,0,0,1.74-.32,3.88,3.88,0,0,0,1.53-2.41c1.23-3.91,2.37-7.47,5.08-10.65a4,4,0,0,1,2.15-1.53,6.42,6.42,0,0,1,2.4.32,2.36,2.36,0,0,0,2.28-.45,2.46,2.46,0,0,0,.46-1.6c0-1.65-.23-3.51.85-4.76.6-.69,1.53-1,2.15-1.72a3.62,3.62,0,0,0,.49-3.66c.92,1.59,1.27,3.6.07,4.91-.62.68-1.54,1-2.15,1.73-1.08,1.24-.8,3.1-.84,4.75a2.45,2.45,0,0,1-.47,1.61,2.38,2.38,0,0,1-2.28.45,6.17,6.17,0,0,0-2.39-.32,4,4,0,0,0-2.16,1.53c-2.7,3.17-3.84,6.74-5.08,10.64a2.89,2.89,0,0,1-3.26,2.74c-5.59.13-11.41.15-16.49-2.2a6.26,6.26,0,0,1-2.45-1.76,4.8,4.8,0,0,1-.73-1.51A1.84,1.84,0,0,0,193,529.39Z"
          transform="translate(-28.43 -18.54)"
        />
        <path
          d="M229.62,504.1a2.47,2.47,0,0,1-.52-1,3.45,3.45,0,0,1,0-1.2,17.05,17.05,0,0,0-.6-6.66l.1-.11a16.87,16.87,0,0,1,1.07,8A5.43,5.43,0,0,0,229.62,504.1Z"
          transform="translate(-28.43 -18.54)"
        />
      </g>
      <path
        d="M218.58,543.27s-23,2.15-24.9-1.37"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M174.51,532.1s-12.71-.47-15.68,4.18"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
    </svg>
  );
};

export const TagsBlogSVG = function () {
  return (
    <svg
      className={'AboutBlogSVG tagssvg'}
      id="c72640af-2824-4ace-a782-4df73f48977c"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="1143.14"
      height="862.91"
      viewBox="0 0 1143.14 862.91"
    >
      <defs>
        <linearGradient
          id="969f2d34-5bff-4fc3-8c31-c6509eddc389"
          x1="551.46"
          y1="688.44"
          x2="551.46"
          y2="150.11"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="gray" stop-opacity="0.25" />
          <stop offset="0.54" stop-color="gray" stop-opacity="0.12" />
          <stop offset="1" stop-color="gray" stop-opacity="0.1" />
        </linearGradient>
        <linearGradient
          id="488cd128-ff9c-494f-bd41-35fb6c1caf21"
          x1="1059.46"
          y1="856.62"
          x2="1059.46"
          y2="468.94"
          xlinkHref="#969f2d34-5bff-4fc3-8c31-c6509eddc389"
        />
        <linearGradient
          id="ccb18d0b-874b-442a-b8cb-57bcf76cdeb5"
          x1="814.74"
          y1="881.34"
          x2="814.74"
          y2="496.8"
          gradientTransform="matrix(-1, -0.04, -0.04, 1, 1070.86, 21.29)"
          xlinkHref="#969f2d34-5bff-4fc3-8c31-c6509eddc389"
        />
      </defs>
      <ellipse cx="1023.75" cy="834.07" rx="100.11" ry="24.73" fill="#3355ff" opacity="0.1" />
      <ellipse cx="140.04" cy="838.19" rx="100.11" ry="24.73" fill="#3355ff" opacity="0.1" />
      <path
        d="M713.17,251.41s-14.07-5.71-58.81,14.82S604,284.14,592.44,281s-18-3.88-30.46-21c0,0-8.76-47.48-17.23-54.84s-44.5,4.19-44.5,4.19-43.19,9.91-51.42-47.81c0,0,5.84-43.51-2.11-56.86,0,0,16,6.93,42.54-4.25s47.69,12,47.69,12,6.68,17.3,6,27.61,3.53,14.18,16.17,9.2c0,0,6.2-8.83-2.59-23.42s-15.06-25.47-12.6-36.8,9.5-27,32.16-34.9,53.44-9.38,68.22-15.53,18.35-10.15,18.35-10.15S653.55,37.58,675,76.19s7.77,55.38,7.77,55.38-11.4,27.16-61.7,25c0,0-48.47,1.77-22,22.33,0,0,16.93-3.45,42.23-11.49s43.57,25.15,48.1,48.25S713.17,251.41,713.17,251.41Z"
        transform="translate(-28.43 -18.54)"
        fill="#3355ff"
      />
      <path
        d="M648,57.75l.27-.07c1.94,7.37-19.73,37-38.24,60.53l-.22-.17C635.94,84.83,649.51,63.42,648,57.75Z"
        transform="translate(-28.43 -18.54)"
        fill="#444053"
      />
      <path
        d="M610.2,117.55l.11.3c-14.79,18.81-33.39,41.25-48.28,57.87-1.42,1.59-2.83,3.25-4.19,4.95l-.42-.35c1.36-1.7,2.78-3.37,4.2-5C576.5,158.75,595.42,136.35,610.2,117.55Z"
        transform="translate(-28.43 -18.54)"
        fill="#444053"
      />
      <path
        d="M557.78,179.88l.29.5c-27.1,33.83-28.89,86.36-29,86.82l-5.72-6.6C523.47,260.14,530.49,213.94,557.78,179.88Z"
        transform="translate(-28.43 -18.54)"
        fill="#444053"
      />
      <path
        d="M681.74,233.06s-32-16.61-56.85-10.65-81-21.06-81-21.06-23.81-9.68-28.59-20.7c0,0-16.33-17.26-17.26-26.2s-16.83-31.4-27.2-32.27"
        transform="translate(-28.43 -18.54)"
        fill="none"
        stroke="#444053"
        stroke-miterlimit="10"
      />
      <path
        d="M677.12,249.05S661,238.21,662.9,225.58"
        transform="translate(-28.43 -18.54)"
        fill="none"
        stroke="#444053"
        stroke-miterlimit="10"
      />
      <path
        d="M652.43,263.06s-23-8.36-25.32-41.11"
        transform="translate(-28.43 -18.54)"
        fill="none"
        stroke="#444053"
        stroke-miterlimit="10"
      />
      <path
        d="M615.3,271.54s-22-18.25-14.69-50.13"
        transform="translate(-28.43 -18.54)"
        fill="none"
        stroke="#444053"
        stroke-miterlimit="10"
      />
      <path
        d="M570.68,262.62s-14.65-30.71-1.62-50.69"
        transform="translate(-28.43 -18.54)"
        fill="none"
        stroke="#444053"
        stroke-miterlimit="10"
      />
      <path
        d="M682.12,212.82s-16.65,5.28-13.08,14"
        transform="translate(-28.43 -18.54)"
        fill="none"
        stroke="#444053"
        stroke-miterlimit="10"
      />
      <path
        d="M662,182.61s-22.27,7.07-22.8,38.57"
        transform="translate(-28.43 -18.54)"
        fill="none"
        stroke="#444053"
        stroke-miterlimit="10"
      />
      <path
        d="M631,175.34s-20.26,25-18.77,47.75"
        transform="translate(-28.43 -18.54)"
        fill="none"
        stroke="#444053"
        stroke-miterlimit="10"
      />
      <path
        d="M595.48,185.15s-20.13,19.24-17.56,29.95"
        transform="translate(-28.43 -18.54)"
        fill="none"
        stroke="#444053"
        stroke-miterlimit="10"
      />
      <path
        d="M583.34,178.35s-18.88,3.39-21.52-2.81"
        transform="translate(-28.43 -18.54)"
        fill="none"
        stroke="#444053"
        stroke-miterlimit="10"
      />
      <path
        d="M558.81,155.56s9.54,12.63,12,9.8"
        transform="translate(-28.43 -18.54)"
        fill="none"
        stroke="#444053"
        stroke-miterlimit="10"
      />
      <path
        d="M653.36,147.57S605.78,151,595,136.68"
        transform="translate(-28.43 -18.54)"
        fill="none"
        stroke="#444053"
        stroke-miterlimit="10"
      />
      <path
        d="M548.8,91.91s22.33,47.93,38.54,54"
        transform="translate(-28.43 -18.54)"
        fill="none"
        stroke="#444053"
        stroke-miterlimit="10"
      />
      <path
        d="M572.22,69.08s13.72,44.09,30.71,57.85"
        transform="translate(-28.43 -18.54)"
        fill="none"
        stroke="#444053"
        stroke-miterlimit="10"
      />
      <path
        d="M673.39,111.19s-36.19,15.53-57.92-.18"
        transform="translate(-28.43 -18.54)"
        fill="none"
        stroke="#444053"
        stroke-miterlimit="10"
        stroke-width="0.75"
      />
      <path
        d="M604.46,59.68s8.27,32.41,19.41,40.24"
        transform="translate(-28.43 -18.54)"
        fill="none"
        stroke="#444053"
        stroke-miterlimit="10"
        stroke-width="0.75"
      />
      <path
        d="M667.92,74.89s-20.33,7.7-27.93,1.8"
        transform="translate(-28.43 -18.54)"
        fill="none"
        stroke="#444053"
        stroke-miterlimit="10"
        stroke-width="0.75"
      />
      <path
        d="M541.39,166.15s0,28.25-7.69,30.26"
        transform="translate(-28.43 -18.54)"
        fill="none"
        stroke="#444053"
        stroke-miterlimit="10"
      />
      <path
        d="M478.52,202.75s30.54,2.62,44.63-13.14"
        transform="translate(-28.43 -18.54)"
        fill="none"
        stroke="#444053"
        stroke-miterlimit="10"
      />
      <path
        d="M533.51,132.78s-7.39,28.65-27.78,36.37"
        transform="translate(-28.43 -18.54)"
        fill="none"
        stroke="#444053"
        stroke-miterlimit="10"
      />
      <path
        d="M460.2,172.57s21.62,7.52,40.21-11.62"
        transform="translate(-28.43 -18.54)"
        fill="none"
        stroke="#444053"
        stroke-miterlimit="10"
      />
      <path
        d="M509.47,108.15s-2,24.33-15.27,35.72"
        transform="translate(-28.43 -18.54)"
        fill="none"
        stroke="#444053"
        stroke-miterlimit="10"
      />
      <path
        d="M461,135.49s17.94.13,22.14-5.72"
        transform="translate(-28.43 -18.54)"
        fill="none"
        stroke="#444053"
        stroke-miterlimit="10"
      />
      <path
        d="M620.4,156c-71.4,11.91-142.91,5.5-211.75-3.38s-137.52-20.22-209.07-18c-46,1.44-97.17,10.48-129,38.22-30.62,26.69-35,63.18-34.71,96.18.22,24.82,2.55,50.53,19.36,70.49,11.67,13.85,29.51,23.91,43,36.72,47,44.58,33.67,113.64,3.91,172.12-14,27.44-31.11,54.37-40.5,82.5S51.32,689.28,69,712.57c17.54,23.09,51.09,36.39,86,43.52,70.89,14.47,149.57,7,225.67-3.39,168.44-23.11,335-60.49,501.08-97.8,61.47-13.8,123.21-27.68,182.35-48,32.84-11.26,66.25-25.43,87.28-47.84,26.69-28.45,26.93-67.72.56-91.54-44.24-40-143.21-32.48-177.6-78-18.94-25-11.23-58.62,3.24-88.17,31-63.4,91.75-125.65,83-189.36-6-43.76-48.38-80.4-104.68-90.53-59-10.61-134.41,7.11-167.78,50.62C753.76,117,683.44,145.5,620.4,156Z"
        transform="translate(-28.43 -18.54)"
        fill="#3355ff"
        opacity="0.1"
      />
      <rect
        x="76.29"
        y="150.11"
        width="950.33"
        height="538.33"
        rx="12.49"
        ry="12.49"
        fill="url(#969f2d34-5bff-4fc3-8c31-c6509eddc389)"
      />
      <rect x="77.8" y="157.68" width="947.42" height="528.97" rx="12.49" ry="12.49" fill="#fff" />
      <rect x="77.8" y="157.68" width="947.42" height="528.97" rx="12.49" ry="12.49" fill="#fff" />
      <rect
        x="77.8"
        y="157.68"
        width="947.42"
        height="528.97"
        rx="12.49"
        ry="12.49"
        fill="#5a5773"
        opacity="0.04"
      />
      <path
        d="M1048.84,170.15H111a4.81,4.81,0,0,0-4.81,4.81V195.3h947.42V175A4.81,4.81,0,0,0,1048.84,170.15Z"
        transform="translate(-28.43 -18.54)"
        fill="#5a5773"
      />
      <g id="83eb5f8b-b68b-4721-b047-6100bc74156f" data-name="buttons">
        <circle cx="96.72" cy="164.18" r="6.5" fill="#fff" />
        <circle cx="114.22" cy="164.18" r="6.5" fill="#fff" />
        <circle cx="131.72" cy="164.18" r="6.5" fill="#fff" />
      </g>
      <rect x="141.22" y="293.86" width="790" height="392.78" rx="10.19" ry="10.19" fill="#fff" />
      <rect
        x="107.72"
        y="203.45"
        width="227.24"
        height="23.85"
        rx="3.86"
        ry="3.86"
        fill="#5a5773"
        opacity="0.2"
      />
      <rect
        x="536.22"
        y="339.45"
        width="227.24"
        height="23.85"
        rx="3.86"
        ry="3.86"
        fill="#3355ff"
        opacity="0.2"
      />
      <rect
        x="536.22"
        y="406.23"
        width="354.83"
        height="23.85"
        rx="3.86"
        ry="3.86"
        fill="#3355ff"
        opacity="0.2"
      />
      <rect
        x="536.22"
        y="445.23"
        width="354.83"
        height="23.85"
        rx="3.86"
        ry="3.86"
        fill="#3355ff"
        opacity="0.2"
      />
      <rect
        x="536.22"
        y="484.23"
        width="354.83"
        height="23.85"
        rx="3.86"
        ry="3.86"
        fill="#3355ff"
        opacity="0.2"
      />
      <rect
        x="536.22"
        y="523.23"
        width="354.83"
        height="23.85"
        rx="3.86"
        ry="3.86"
        fill="#3355ff"
        opacity="0.2"
      />
      <rect
        x="184.05"
        y="566.23"
        width="707"
        height="23.85"
        rx="3.86"
        ry="3.86"
        fill="#3355ff"
        opacity="0.2"
      />
      <rect
        x="184.05"
        y="605.23"
        width="707"
        height="23.85"
        rx="3.86"
        ry="3.86"
        fill="#3355ff"
        opacity="0.2"
      />
      <rect
        x="184.05"
        y="644.23"
        width="707"
        height="23.85"
        rx="3.86"
        ry="3.86"
        fill="#3355ff"
        opacity="0.2"
      />
      <path
        d="M757.73,678.54s5.93,7.75-2.74,19.46-15.81,21.59-12.92,28.89c0,0,13.07-21.74,23.72-22S769.44,691.61,757.73,678.54Z"
        transform="translate(-28.43 -18.54)"
        fill="#3355ff"
      />
      <path
        d="M757.73,678.54a9.6,9.6,0,0,1,1.21,2.43c10.39,12.2,15.92,23.59,5.94,23.87-9.3.27-20.46,16.9-23.13,21.09a7.72,7.72,0,0,0,.32,1s13.07-21.74,23.72-22S769.44,691.61,757.73,678.54Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M768.75,688.42c0,2.73-.3,4.94-.68,4.94s-.68-2.21-.68-4.94.38-1.44.76-1.44S768.75,685.69,768.75,688.42Z"
        transform="translate(-28.43 -18.54)"
        fill="#ffd037"
      />
      <path
        d="M772.54,691.68c-2.4,1.3-4.49,2.09-4.67,1.76s1.62-1.66,4-3,1.45-.36,1.63,0S774.93,690.37,772.54,691.68Z"
        transform="translate(-28.43 -18.54)"
        fill="#ffd037"
      />
      <path
        d="M726.41,678.54s-5.93,7.75,2.73,19.46,15.82,21.59,12.93,28.89c0,0-13.08-21.74-23.72-22S714.7,691.61,726.41,678.54Z"
        transform="translate(-28.43 -18.54)"
        fill="#3355ff"
      />
      <path
        d="M726.41,678.54a9.39,9.39,0,0,0-1.22,2.43c-10.38,12.2-15.91,23.59-5.93,23.87,9.3.27,20.45,16.9,23.12,21.09a7.68,7.68,0,0,1-.31,1s-13.08-21.74-23.72-22S714.7,691.61,726.41,678.54Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M715.38,688.42c0,2.73.31,4.94.69,4.94s.68-2.21.68-4.94S716.37,687,716,687,715.38,685.69,715.38,688.42Z"
        transform="translate(-28.43 -18.54)"
        fill="#ffd037"
      />
      <path
        d="M711.6,691.68c2.4,1.3,4.49,2.09,4.67,1.76s-1.62-1.66-4-3-1.45-.36-1.63,0S709.2,690.37,711.6,691.68Z"
        transform="translate(-28.43 -18.54)"
        fill="#ffd037"
      />
      <ellipse cx="713.64" cy="758.15" rx="62" ry="9.51" fill="#3355ff" opacity="0.1" />
      <path
        d="M774,716.44l-.3,2.42-.41,3.42-.18,1.43-.41,3.42-.18,1.43-.42,3.41-4.74,38.9c-.43,3.47-6.1,6.18-13,6.18H729.74c-6.85,0-12.51-2.71-12.93-6.18L712.05,732l-.41-3.41-.18-1.43-.42-3.42-.17-1.43-.42-3.42-.3-2.42c-.23-2,2.84-3.62,6.71-3.62h50.42C771.15,712.82,774.22,714.47,774,716.44Z"
        transform="translate(-28.43 -18.54)"
        fill="#65617d"
      />
      <polygon
        points="745.25 700.32 744.84 703.74 682.44 703.74 682.02 700.32 745.25 700.32"
        fill="#9d9cb5"
      />
      <polygon
        points="744.66 705.16 744.25 708.58 683.03 708.58 682.61 705.16 744.66 705.16"
        fill="#9d9cb5"
      />
      <polygon
        points="744.07 710.01 743.65 713.43 683.62 713.43 683.21 710.01 744.07 710.01"
        fill="#9d9cb5"
      />
      <rect
        x="184.05"
        y="326.22"
        width="302"
        height="221.54"
        rx="8.5"
        ry="8.5"
        fill="#3355ff"
        opacity="0.2"
      />
      <path
        d="M1153.48,591.15c.38-1-2.44-6.72-2.44-7s-2.91-3.45-2.91-5.22-3.85-5.6-3.85-5.6-5.17-2.14-5.73-6.81-6.19-4.75-6.2-4.75h0s0-.42,0-1.07a14.72,14.72,0,0,0-.69-5.45,5.49,5.49,0,0,0-3.19-2.71s-.57-3.64-1.69-4.76a5.35,5.35,0,0,1-1.32-5c.57-1.76-.75-6.24-3.47-6.9s-5.83-1.68-5.83-1.68l-.75.13-.37-.13a15.59,15.59,0,0,1-2,.25,2.47,2.47,0,0,1-1.59-.52c-.94-1-8.55-3-10-3s-5.45-1.87-5.45-1.87-2.82-2.14-4-3.08-3.23-4.35-3.54-4.87l0-.07h0l0,0a17.25,17.25,0,0,1-.85-2.45h0a22.06,22.06,0,0,0,3.49-4.81c.1-.18.19-.36.28-.55a2.1,2.1,0,0,0,.61-.09l.25-.1a4.06,4.06,0,0,0,2-2.38h0a6.32,6.32,0,0,0,.18-.62c0-.07,0-.14,0-.21l.09-.42a2,2,0,0,1,0-.24l.06-.42,0-.24c0-.18,0-.35.07-.53h0a18.7,18.7,0,0,1,.29-2v0h0c.56-2.53,2.09-4.67,3.16-7h0c.15-.33.3-.67.43-1s.26-.75.37-1.13l.09-.35c.07-.28.13-.56.19-.84s0-.25.07-.38q.09-.57.15-1.17a14.46,14.46,0,0,0-1-6.55c-.7-1.75-1.75-3.33-2.46-5.08-1.08-2.65-1.37-5.66-2.68-8.19a9.75,9.75,0,0,0-11.7-4.76c-2,.76-3.82,2.23-5.89,2.89-2.78.89-5.74.22-8.62-.17s-6-.44-8.36,1.44c-2.66,2.16-3.38,6.22-5.88,8.59-1,1-2.35,1.63-3.46,2.55a5.65,5.65,0,0,0-1.74,2.38l-.06.19a1.83,1.83,0,0,0-.06.25,2.33,2.33,0,0,0-.05.28,1.11,1.11,0,0,0,0,.19,2.09,2.09,0,0,0,0,.5h0a3.81,3.81,0,0,0,.07.47l0,.13c0,.13.07.26.12.39s0,.05,0,.07.11.29.17.43l.09.21c0,.06,0,.12.08.17a12.44,12.44,0,0,1,.87,2.17,2.41,2.41,0,0,1-.09,1.43,4.22,4.22,0,0,1-1,1.37,19.35,19.35,0,0,0-4.24,6.79q-.17.44-.3.87v0l.13,0a5.68,5.68,0,0,0,.82.17,4,4,0,0,0,.47,0,7.32,7.32,0,0,0,1.92-.14l.48-.12a10.87,10.87,0,0,0,1.9-.69c0,.19,0,.38,0,.57s0,.21,0,.32a22.18,22.18,0,0,0,12.33,19.84c0,.2.05.4.08.6l.06.51-.25-.24s-1.69-.84-3.29,1.58a10.62,10.62,0,0,1-4.6,3.55s-17.1,2.7-17.76,4.94l-8,.47s-2.82.37-3.1,6.25-1.78,6.43-1.78,6.43-3.29,5.79-3,8.77a4.89,4.89,0,0,1-2.54,4.48l-.37,5.32s-3.1-.47-4,3.17a12.65,12.65,0,0,1-2.34,5.31s-5.17,4.3-5.45,7.93l-3.2,2s-7.42-1.68-9.11-4.66c0,0-.2-.2-.52-.49l0-.07v0c-1.11-1-3.46-3.24-3.1-2.73a2.25,2.25,0,0,1,.15,1.5l-.55-.61-1.48-1.64s-12-11.24-19-12.13h0c-.09-.18-.55-2-1.75-.85a9.8,9.8,0,0,0-.07,14.37l11.24,10.49.29.21,2.41,3.1c-.41,1-.75,1.92-1,2.78l0,.09-.18.54a1.21,1.21,0,0,0-.05.18c-.06.18-.11.35-.16.52l-.09.3c0,.06,0,.12,0,.18-.27.94-.44,1.66-.52,2.06l-.63-.2.61.27,0,.09c0,.13,0,.2,0,.2l.58.25c3.29,1.43,19.71,8.64,20.55,9.73s7.14,4.76,12.78,1.77,6.85-7.55,6.85-7.55,5.45-7.56,5.64-8.68,4.41-2.42,4.41-2.42.38,12.49-1.78,17.07-6.2,24.81-6.2,24.81a2.86,2.86,0,0,1,.8,0l-.24,1.17a2.72,2.72,0,0,1,1,0c-.3,2.3-2,13-2,13s-.56,4.85-1.5,6.53-1,10.45-1,10.45l-1.51,6.34s.2.44.57,1.09v0a16.23,16.23,0,0,0,4.32,5.59,11.06,11.06,0,0,1-.76,2.9,10.2,10.2,0,0,0-.75,4.48s-1.59,7.18-1.41,9.23-1,7.09-1,7.09l-1.69,16.23s-1.12,14.08-.56,17.91a34.37,34.37,0,0,1-.38,9s1.13,11.1.85,12.31-1.69,6.44-.85,9.33.38,10.82.38,10.82.56,10.45,1.22,13.81a23.64,23.64,0,0,1-.19,7.65s-.66,7.18-.94,7.18-2.72,4.94,2.25,9.79,1.89,4.1,1.89,4.1-4-2-3.48,2.06c.44,3.81,1.06,2.82,1.12,2.71l-.94,3.07.66.09-.54.65a14.05,14.05,0,0,1-1.9,2,4.07,4.07,0,0,0-1.22,2.7s-6.95,7.56-13.43,11.38c-3.41,2-6.35,3.71-7.63,5.13-1.16,1.26-1,2.28,1.43,3.08,5.07,1.68,14,2.52,20.38.37a23.84,23.84,0,0,0,10-6.43s4-2.06,8-1.31,11.84-4.38,11.84-4.38l-.15-1.32-.41-3.82a3,3,0,0,1-.66-2.32,12,12,0,0,0-.33-3.36c-.07-.37-.14-.74-.21-1.08l.72-.14s-.93-4.75.76-5.69,1.21-13.15,1.21-13.15-2.15-2.8-3.28-3.26-.1-6.26.1-7,1.69-15.21,1.69-15.21-.57-4.56.18-6.52-.94-9.52-.94-9.52a1.74,1.74,0,0,1,.47-2.05c1-1.12.66-11.1.66-11.1s-.09-5-.09-6.35,1.12-6.06,2.16-7.64.37-6.53.37-6.53v0l.06-.37c0-.14,0-.32.08-.53l.08-.5a72.67,72.67,0,0,1,1.84-8.1c1.22-3.91,2.63-10.81,2.63-10.81l8.73-22.78.1-.27s4,7.46,4,14.37c0,0,1,8.3.76,10.54S1065,728,1065,728s1.22,15.11,1.22,15.76,1.51,12.31,2.45,14.09-.94,7.18-1.51,7.74.19,14.27.19,14.27-1.41,10.82-1.69,13.06-1.41,10.82-.47,14.18.56,3.82.56,3.82,3.39,3.46,1.41,3.74a5.17,5.17,0,0,0-3.76,6.8,89.61,89.61,0,0,0,4.14,10l1.56-.33,0,1.11.11,5.56s.66,5.31.28,6.53c-.27.88-.65,5.06-.83,7.25-.07.8-.11,1.33-.11,1.33s0,4.94,10.43,3.45,12.3-5.6,12.3-5.6l.08-.51c.15-.94.49-2.94.77-4.06.37-1.49-3-8.21-3-8.21s-.56-4.57-1.5-5.59a5,5,0,0,1-.76-2c-.08-.38-.16-.77-.22-1.15a6.78,6.78,0,0,1,.7.12s-.57-3.26,1.6-4.29,1.59-3.17,1.31-4.1.84-6.16.84-6.16a3,3,0,0,1,.75-3c1.32-1.31,2.35-10.45,2.35-10.45l.19-35.26s.66-6.25-.09-8.77-1.5-7.37-.47-8.68.09-7.36.09-7.36,0-12.78,1.41-16,.94-23.23.94-23.23l.37-13.15s3.07-2.9,2.35-18c3.27-.21,7-.33,7.52.13,1,.84,7.7,5.13,11.65,2.42a52.29,52.29,0,0,0,4.69-3.63l-1.66-28c1,1.56,1.66,2.59,1.66,2.59,0-3.91,11.09-16.6,11.09-16.6s10.33-13.34,12.58-14.92,6.67-10,6.67-10a40.59,40.59,0,0,1,2.26-4.66C1156.49,596.65,1153.11,592.17,1153.48,591.15Zm-24.23,9.79c-2.82.28-8.74,6.72-8.83,8.12a5.76,5.76,0,0,1-1.25,2.5c0-.56-.09-1.13-.14-1.71-.66-8.25-1.38-18.29-1-19.26.56-1.68.37-9.24.37-9.24h0l.11-.15c1.89,5.86,7.77,12.76,7.77,12.76s1,3,2.26,3.07S1129.25,600.94,1129.25,600.94Z"
        transform="translate(-28.43 -18.54)"
        fill="url(#488cd128-ff9c-494f-bd41-35fb6c1caf21)"
      />
      <path
        d="M978.65,598.81s3.43-18,14.44-18l8.06,16.57-5.37,3.7S984.11,601.4,978.65,598.81Z"
        transform="translate(-28.43 -18.54)"
        fill="#65617d"
      />
      <path
        d="M1001.15,597.33l-5.37,3.7s-8.21.26-14.08-1.18a16.24,16.24,0,0,1-3.05-1l.06-.29,0-.06a40,40,0,0,1,2.08-6.6c.34-.81.72-1.64,1.14-2.47,1.61-3.1,3.88-6.15,7-7.65a9.49,9.49,0,0,1,3.67-1h.49l.18.37,2.72,5.6Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M1092.61,671.94s11.57-1.11,12.59-.27,7.59,5.09,11.47,2.4,1.3-12,1.3-12.4-.37-13.61-.37-13.61l-6.94-9.35-8.7-16.38-17.78-1.76.46,26-.09,13.33Z"
        transform="translate(-28.43 -18.54)"
        fill="#65617d"
      />
      <path
        d="M1092.61,671.94s11.57-1.11,12.59-.27,7.59,5.09,11.47,2.4,1.3-12,1.3-12.4-.37-13.61-.37-13.61l-6.94-9.35-8.7-16.38-17.78-1.76.46,26-.09,13.33Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M990.78,580.3s-.93,11.29-8,11.48c0,0-2-1.2-4.68-3.21-6.18-4.63-16-13.52-13.28-21.79,3.89-11.85,22.77,10,22.77,10l1.46,1.63Z"
        transform="translate(-28.43 -18.54)"
        fill="#fbbebe"
      />
      <path
        d="M990.78,580.3s-.93,11.29-8,11.48c0,0-2-1.2-4.68-3.21l-.6-.77a9.21,9.21,0,0,0,3.86,1,5.21,5.21,0,0,0,5-3.17,40,40,0,0,0,2-4.49,14,14,0,0,0,.71-2.77Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M987.72,600.76l-1.58-2-5.33-6.86-2.71-3.51a9.13,9.13,0,0,0,3.85,1,5.18,5.18,0,0,0,5-3.17,39.18,39.18,0,0,0,1.95-4.48c.88-2.5.86-3.78.55-4.22s2,1.68,3.06,2.72l0,0,.51.48.19.38L996,586.5a1.45,1.45,0,0,1,0,.23C996.2,588.43,997.1,599.22,987.72,600.76Z"
        transform="translate(-28.43 -18.54)"
        fill="#e7effd"
      />
      <path
        d="M1043.18,839s-7.78,5.1-11.67,4.35a14,14,0,0,0-7.87,1.3,23.36,23.36,0,0,1-9.81,6.39c-6.3,2.13-15.09,1.29-20.09-.37-2.36-.79-2.55-1.81-1.41-3.06s4.16-3.09,7.52-5.09c6.39-3.8,13.24-11.29,13.24-11.29a4,4,0,0,1,1.2-2.69,13.8,13.8,0,0,0,1.87-2c1-1.17,1.93-2.4,1.93-2.4L1041,825s.39,1.65.7,3.34a12.08,12.08,0,0,1,.32,3.33,3,3,0,0,0,.65,2.31l.41,3.78Z"
        transform="translate(-28.43 -18.54)"
        fill="#65617d"
      />
      <path
        d="M1091,845.42c-.27,1.11-.61,3.09-.76,4,0,.31-.07.51-.07.51s-1.85,4.07-12.13,5.55-10.27-3.42-10.27-3.42l.1-1.33c.18-2.16.55-6.31.82-7.19.37-1.2-.27-6.48-.27-6.48l-.11-5.52-.08-3.83,17-1.76a32.8,32.8,0,0,0,.55,3.79,4.87,4.87,0,0,0,.75,2c.92,1,1.48,5.55,1.48,5.55S1091.4,843.94,1091,845.42Z"
        transform="translate(-28.43 -18.54)"
        fill="#65617d"
      />
      <path
        d="M1041,825s.39,1.65.7,3.34c-2.47.45-13.27,2.32-16,1-3.06-1.48-9.63-2.31-9.63-2.31l.11-.38c1-1.17,1.93-2.4,1.93-2.4Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M1085.84,829.77c-4.31-.73-13.78,1-17.5,1.8l-.08-3.83,17-1.76A32.8,32.8,0,0,0,1085.84,829.77Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M1095.47,689.44l-.36,13s.46,19.9-.93,23-1.39,15.83-1.39,15.83.93,6-.09,7.31-.28,6.11.46,8.61.09,8.7.09,8.7l-.18,35s-1,9.07-2.32,10.37a3.05,3.05,0,0,0-.74,3s-1.11,5.18-.83,6.11.83,3.05-1.29,4.07-1.58,4.26-1.58,4.26c-5.09-1.21-19.53,2-19.53,2a88.58,88.58,0,0,1-4.08-9.91,5.13,5.13,0,0,1,3.71-6.76c1.94-.27-1.39-3.7-1.39-3.7s.37-.46-.56-3.8.19-11.85.47-14.07,1.66-13,1.66-13-.74-13.61-.18-14.16,2.4-5.93,1.48-7.68-2.41-13.33-2.41-14-1.2-15.65-1.2-15.65-1.11-10.46-.83-12.68-.75-10.46-.75-10.46c0-6.85-4-14.26-4-14.26l-.1.27L1050,713.6s-1.39,6.85-2.59,10.74a70.55,70.55,0,0,0-1.81,8l-.08.5-.08.52-.06.37v0s.64,4.9-.38,6.48a23.11,23.11,0,0,0-2.12,7.59c0,1.3.09,6.3.09,6.3s.37,9.9-.65,11a1.73,1.73,0,0,0-.46,2s1.66,7.5.92,9.44-.18,6.48-.18,6.48-1.48,14.35-1.67,15.09-1.2,6.48-.09,6.94,3.24,3.24,3.24,3.24.46,12.13-1.2,13.05-.75,5.65-.75,5.65-13.42,2.59-16.47,1.11-9.63-2.31-9.63-2.31l.92-3c-.06.11-.67,1.1-1.1-2.69-.47-4,3.42-2,3.42-2s3.06.74-1.85-4.07-2.5-9.72-2.22-9.72.92-7.13.92-7.13a23.57,23.57,0,0,0,.19-7.59c-.65-3.33-1.2-13.7-1.2-13.7s.46-7.87-.38-10.74.56-8,.84-9.26-.84-12.22-.84-12.22a34.27,34.27,0,0,0,.38-9c-.56-3.8.55-17.78.55-17.78l1.67-16.1s1.2-5,1-7,1.39-9.16,1.39-9.16a10.16,10.16,0,0,1,.74-4.45c.93-1.85,1.3-8,1.3-8l8.89-20.36,4.35-18,58.78-.56s.21,1.56.57,4.39.86,7,1.42,12.19c.51,4.7,1.07,10.23,1.62,16.38C1099.18,685.92,1095.47,689.44,1095.47,689.44Z"
        transform="translate(-28.43 -18.54)"
        fill="#3f3d56"
      />
      <path
        d="M1090,527.35,1076.31,542s-17.58-7-15.73-9.45c.71-.93.6-3.87.19-7.11-.65-5.13-2-11-2-11s30.73-5,28.13.18a8.52,8.52,0,0,0-.19,6.15A23.29,23.29,0,0,0,1090,527.35Z"
        transform="translate(-28.43 -18.54)"
        fill="#fbbebe"
      />
      <path
        d="M1086.86,514.57c-.94,1.9-1.39,2.08-.8,4.12-4,4.31-9.13,9-15.49,9a21.92,21.92,0,0,1-9.8-2.3c-.65-5.13-2-11-2-11S1089.46,509.39,1086.86,514.57Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M1092.61,505.13a22,22,0,0,1-44.07,0c0-.11,0-.21,0-.32a22,22,0,0,1,44.06.32Z"
        transform="translate(-28.43 -18.54)"
        fill="#fbbebe"
      />
      <path
        d="M1095.8,650.48c-2.92,0-12.64.1-23.5.28h-.13l-3.59.06h-.11c-12.88.2-25.57-2.31-30.67-1.84-10.83,1,3.89-10,3.89-10a90.83,90.83,0,0,0,24.67,2.49l3.12-.16c9.84-.56,19.73-1.48,24.9-3C1094.74,641.15,1095.24,645.31,1095.8,650.48Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M1095.8,649.92c-2.92,0-12.64.11-23.5.28h-.13l-3.59.06h-.11c-12.88.21-25.57-2.31-30.67-1.83-10.83,1,3.89-10,3.89-10a90.37,90.37,0,0,0,24.67,2.49l3.12-.16c9.84-.55,19.73-1.48,24.9-3C1094.74,640.59,1095.24,644.75,1095.8,649.92Z"
        transform="translate(-28.43 -18.54)"
        fill="#5f5d7e"
      />
      <path
        d="M1064.65,533.46l-17,8-13.15,101.64s7.78-3.52,12.22-1.3,18.14.19,18.14.19,10-.56,11.48.56,18.89-4.63,18.89-4.63,3.15-7,.74-8.15.74-12,.74-12l-1.48-73.32-3-9.44-8-4.82-8.14,6.48-3.89.56Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M1064.65,532.35l-17,8L1034.47,642s7.78-3.52,12.22-1.3,18.14.19,18.14.19,10-.56,11.48.55,18.89-4.62,18.89-4.62,3.15-7,.74-8.15.74-12,.74-12l-1.48-73.32-3-9.44-8-4.82-8.14,6.48-3.89.56Z"
        transform="translate(-28.43 -18.54)"
        fill="#e7effd"
      />
      <path
        d="M1064.37,537.07s4.91,5.83,4.82,7-.28,4.08-.28,4.08l-3.7,7.49s-2,9.35-2,11.3-3.24,18.79-3.24,18.79L1056,611.68l-4.91,34,5,8.61,5.93-5,7.87-60.54,1.66-11.94s1.76-21.48,1.76-23.7a75.45,75.45,0,0,0-1-8.05s1.21-5.56,6.21-6.85-.38-.28-.38-.28l-2.86-2.31-2.5,1S1065.85,534.48,1064.37,537.07Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M1063.82,536.51s4.9,5.83,4.81,7-.28,4.07-.28,4.07l-3.7,7.5s-2,9.35-2,11.29-3.24,18.79-3.24,18.79l-3.88,25.92-4.91,34,5,8.61,5.92-5,7.87-60.54,1.67-11.94s1.76-21.48,1.76-23.7a75.73,75.73,0,0,0-1-8.06s1.2-5.55,6.2-6.85-.37-.27-.37-.27l-2.87-2.32-2.5,1S1065.3,533.92,1063.82,536.51Z"
        transform="translate(-28.43 -18.54)"
        fill="#3355ff"
      />
      <path
        d="M1060.58,526.79s-.74.56-.93,4.26-2.78,12-2.78,12,9.63-6.66,14.44-5.92Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M1060.58,525.68s-.74.56-.93,4.26-2.78,12-2.78,12,9.63-6.66,14.44-5.92Z"
        transform="translate(-28.43 -18.54)"
        fill="#e7effd"
      />
      <path
        d="M1086.87,523.83l-15.18,13.33s12.77,7.59,14.44,9.44,3.33-18.14,3.33-18.14Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M1087.42,522.72l-15.18,13.33s12.78,7.59,14.44,9.44,3.33-18.14,3.33-18.14Z"
        transform="translate(-28.43 -18.54)"
        fill="#e7effd"
      />
      <path
        d="M1061.13,526.79s-1.66-.83-3.24,1.58a10.45,10.45,0,0,1-4.53,3.51s-16.85,2.69-17.5,4.91l-7.87.46s-2.78.37-3,6.21-1.76,6.38-1.76,6.38-3.24,5.74-3,8.7a4.87,4.87,0,0,1-2.5,4.45l11.57,30.08s.37,12.41-1.76,16.94-6.11,24.63-6.11,24.63,1.67-.37,1.57.74-2,13.24-2,13.24-.56,4.81-1.48,6.48-1,10.36-1,10.36l-1.48,6.3s3.51,7.87,8.88,6.76S1041,656.39,1041,656.39l6.2-22.68,4.82-22.4,1.39-15.18,2.22-33.61,3.24-22.21S1062.43,528.37,1061.13,526.79Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M1060.58,525.68s-1.67-.83-3.24,1.58a10.51,10.51,0,0,1-4.54,3.51s-16.85,2.69-17.5,4.91l-7.86.46s-2.78.37-3.06,6.2-1.76,6.39-1.76,6.39-3.24,5.74-3,8.7a4.85,4.85,0,0,1-2.5,4.45L1028.73,592s.37,12.41-1.76,16.94-6.11,24.63-6.11,24.63,1.67-.37,1.58.74-2,13.23-2,13.23-.55,4.82-1.48,6.48-1,10.37-1,10.37l-1.48,6.3s3.52,7.87,8.89,6.75,15.09-22.12,15.09-22.12l6.2-22.68,4.81-22.4L1052.8,595l2.22-33.61,3.24-22.21S1061.87,527.26,1060.58,525.68Z"
        transform="translate(-28.43 -18.54)"
        fill="#65617d"
      />
      <path
        d="M1001.15,597.33l-5.37,3.7s-8.21.26-14.08-1.18l-3-1.33-.6-.26.62.2a12.26,12.26,0,0,0,7.41.26c7.6-2.56,6.76-15.1,6.46-17.94,0-.29-.05-.47-.06-.54v0l0,.07a5,5,0,0,0,.35.49l.34.36h0L996,586.5a1.45,1.45,0,0,1,0,.23Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M1019.75,561.14l-2.59.74-.37,5.27s-3-.46-3.89,3.15a12.71,12.71,0,0,1-2.31,5.28s-5.09,4.26-5.37,7.87l-3.15,1.94s-7.31-1.67-9-4.63c0,0,3.34,23.88-14.44,18,0,0,19.9,8.7,20.83,9.91s7,4.72,12.59,1.76,6.76-7.5,6.76-7.5,5.37-7.5,5.55-8.61,4.35-2.41,4.35-2.41l8-19.25Z"
        transform="translate(-28.43 -18.54)"
        fill="#65617d"
      />
      <path
        d="M1084.74,534.94l2.68-12.22s1.21,4,2.41,4.91l4,3s4,1.85,5.37,1.85,8.89,2,9.81,3,4.63.28,4.63.28,3.05,1,5.74,1.67,4,5.09,3.42,6.85a5.35,5.35,0,0,0,1.3,5c1.11,1.11,1.67,4.72,1.67,4.72a5.42,5.42,0,0,1,3.14,2.68c.93,2,.65,6.48.65,6.48l-13.79,19.44s.18,7.5-.37,9.17,1.94,30,1.94,30l2.87,48.69a50.51,50.51,0,0,1-4.63,3.61c-.83.37-1.66-17.22-1.66-17.86s-21.39-32-21.39-32-2.87-4.63-2.87-5.65-2.68-10.37-2.68-10.37l-4.07-18Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M1130.69,562.11c0,.64,0,1.06,0,1.06l-13.78,19.42v0s.19,7.5-.37,9.17c-.32,1,.38,10.93,1,19.11.47,5.9.9,10.88.9,10.88l1.22,20.65,1.65,28a50.51,50.51,0,0,1-4.63,3.61c-.83.37-1.66-17.22-1.66-17.87s-21.39-32-21.39-32-2.87-4.63-2.87-5.65-2.68-10.37-2.68-10.37l-4.07-18,1.85-55.17,1.57-12.22s2.32,4,3.52,4.9l4,3.06s4,1.85,5.37,1.85,8.89,2,9.81,3,4.63.28,4.63.28,3.06,1,5.74,1.67,4,5.09,3.42,6.85a5.36,5.36,0,0,0,1.3,5c1.11,1.11,1.67,4.72,1.67,4.72a5.42,5.42,0,0,1,3.14,2.68A15,15,0,0,1,1130.69,562.11Z"
        transform="translate(-28.43 -18.54)"
        fill="#65617d"
      />
      <path
        d="M1017.53,808.76c.46,0,19.9.74,19.53,3.89S1017.53,808.76,1017.53,808.76Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M1021.88,814s13.05,2.13,9.63,4.07S1021.88,814,1021.88,814Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M1070.39,806.73s21.66,1.85,18.42,4.25-10.92,2.78-11.29,2.87S1070.39,806.73,1070.39,806.73Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M1067.8,816.26s12,2,12.4,4.35S1067.8,816.26,1067.8,816.26Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M1074.46,760.53s11,2.59,11.67,4.35Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M1032,768.49s-5.74,1.67-.18,5S1032,768.49,1032,768.49Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M1057.43,679.53c.65,0,10.74-3.33,14.26-1.85a23.45,23.45,0,0,0,7.86,1.48Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M1058.73,690.08l-.1.92L1050,713.6s-1.39,6.85-2.59,10.74a70.55,70.55,0,0,0-1.81,8l7.64-47.37Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M1072.17,650.2l-3.59.06h-.11l-2.11-9.33,3.12-.17Z"
        transform="translate(-28.43 -18.54)"
        fill="#3f3d56"
      />
      <path
        d="M1115.84,638.9l-2.3,1.9-7.7,6.33s-20.82,11.11-26.56.56c-5.06-9.3,18.55-15.94,24.24-17.39l1.21-.29Z"
        transform="translate(-28.43 -18.54)"
        fill="#fbbebe"
      />
      <path
        d="M1026.88,547.9s4.07,1.85,5,4.44S1026.88,547.9,1026.88,547.9Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M1014.29,575.67s-5.92,7.22-3.52,10S1014.29,575.67,1014.29,575.67Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M1120.19,552s-5.55.56-5.74,5.37Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M1068.72,627.88c.56-.56,13.33-19.44,16.3-17.77Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M1092.61,505.13a22,22,0,0,1-2.61,10.4l-.16,0c-1.4-.3-2.13-1.92-3.19-2.94a4.33,4.33,0,0,0-5-.7,5.08,5.08,0,0,0-2.46,4.75c-.7-3-.48-6.12-1.17-9.09s-2.76-6-5.6-6c-1.22,0-2.65.45-3.53-.47-.53-.55-.64-1.42-1-2.09-2-3.29-8.2-1.63-10.72.06s-5.45,4.37-8.58,5.81a22,22,0,0,1,44.06.32Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M1067.85,498.38c.4.67.51,1.54,1,2.1.88.91,2.31.44,3.53.46,2.84.05,4.92,3.06,5.6,6s.47,6.12,1.18,9.08a5,5,0,0,1,2.45-4.74,4.35,4.35,0,0,1,5,.69c1.06,1,1.79,2.65,3.19,2.94s2.74-1.05,3.24-2.52a38.58,38.58,0,0,0,.8-4.61c.63-2.88,2.52-5.25,3.56-8a14.51,14.51,0,0,0-.09-10.34c-.7-1.74-1.73-3.3-2.43-5-1.07-2.63-1.35-5.61-2.65-8.12a9.6,9.6,0,0,0-11.53-4.74c-2,.76-3.76,2.22-5.8,2.88-2.74.88-5.66.22-8.49-.18s-6-.43-8.24,1.43c-2.62,2.15-3.34,6.18-5.8,8.53-1,1-2.32,1.62-3.41,2.53a4.7,4.7,0,0,0-1.91,3.76c.17,1.92,2,3.66,1.35,5.44a4.22,4.22,0,0,1-1,1.35,19.38,19.38,0,0,0-4.48,7.63c5,1.54,10.32-3.92,14.19-6.5C1059.65,496.76,1065.82,495.1,1067.85,498.38Z"
        transform="translate(-28.43 -18.54)"
        fill="#7c5c5c"
      />
      <path
        d="M1115.84,638.9l-2.3,1.9c-2-3.39-10.38-10.15-10.38-10.15l.36-.35,1.21-.29Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M1118.06,635.47s-.82,2.06-1.68,3.84-1.79,3.4-1.83,2.09c-.1-2.6-10.83-11.3-10.83-11.3l1.45-1.42,1.69-1.64Z"
        transform="translate(-28.43 -18.54)"
        fill="#e7effd"
      />
      <path
        d="M1118.43,621.77l1.22,20.65c-2.88-4.47-10.77-15.93-15.84-15.56l12.31-14.16a16.5,16.5,0,0,0,1.41-1.81C1118,616.79,1118.43,621.77,1118.43,621.77Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M1118.06,635.47s-.82,2.06-1.68,3.84c-3.23-4.42-7.66-9.65-11.21-10.63l1.69-1.64Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M1127.32,560.58l3.33,2.59s5.56.1,6.11,4.72,5.65,6.76,5.65,6.76,3.79,3.8,3.79,5.56,2.87,4.9,2.87,5.18,2.78,5.92,2.41,6.94,3,5.46,1.94,7.13a42.87,42.87,0,0,0-2.22,4.63s-4.35,8.33-6.57,9.9-12.4,14.82-12.4,14.82-10.93,12.58-10.93,16.47c0,0-10.64-17.77-16.94-17.31l12.31-14.16s2.13-2.32,2.23-3.7,5.92-7.78,8.7-8.06c0,0,.46-3.79-.74-3.89s-2.22-3-2.22-3-8.15-9.63-8.24-15.74S1127.32,560.58,1127.32,560.58Z"
        transform="translate(-28.43 -18.54)"
        fill="#65617d"
      />
      <path
        d="M1132.23,569.37s-7.78,5.74-6.11,7.6S1132.23,569.37,1132.23,569.37Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M1132.6,593.07s14.44-4.63,15.92,0Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M1043.18,839s-7.78,5.1-11.67,4.35a14,14,0,0,0-7.87,1.3,23.36,23.36,0,0,1-9.81,6.39c-6.3,2.13-15.09,1.29-20.09-.37-2.36-.79-2.55-1.81-1.41-3.06,5.43,1.08,17.58,3.23,20.85,1.67a86.78,86.78,0,0,0,10.37-6.48s8-1.11,9.07-1.11c.79,0,6.94-2.54,10.41-4Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M1090.27,849.45c0,.31-.07.51-.07.51s-1.85,4.07-12.13,5.55-10.27-3.42-10.27-3.42l.1-1.33C1071.15,852,1078.25,853.37,1090.27,849.45Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M1030.72,568.26s0,21.11-1.8,23.19S1030.72,568.26,1030.72,568.26Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M1114.17,575.07l2.69,7.54S1117.92,575.21,1114.17,575.07Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <g opacity="0.1">
        <path
          d="M1048.72,494.15c.68-1.73-1.1-3.44-1.33-5.3a3.41,3.41,0,0,0-.3,1.67c.12,1.41,1.16,2.72,1.43,4A2.28,2.28,0,0,0,1048.72,494.15Z"
          transform="translate(-28.43 -18.54)"
        />
        <path
          d="M1079.44,514.09c-.66-2.92-.46-6-1.14-8.93s-2.76-6-5.6-6c-1.22,0-2.65.44-3.53-.47-.54-.55-.64-1.42-1-2.1-2-3.28-8.2-1.61-10.73.07-3.78,2.51-9,7.78-13.84,6.58-.23.56-.45,1.13-.63,1.72,5,1.54,10.32-3.92,14.19-6.5,2.53-1.68,8.7-3.34,10.73-.06.4.67.51,1.54,1,2.1.88.91,2.31.44,3.53.46,2.84.05,4.92,3.06,5.6,6s.47,6.12,1.18,9.08A5,5,0,0,1,1079.44,514.09Z"
          transform="translate(-28.43 -18.54)"
        />
        <path
          d="M1093.36,510.62c-.5,1.47-1.82,2.82-3.25,2.52s-2.12-1.92-3.18-2.94a4.36,4.36,0,0,0-5-.7,5.06,5.06,0,0,0-2.46,4.49,4.83,4.83,0,0,1,2.18-2.68,4.35,4.35,0,0,1,5,.69c1.06,1,1.79,2.65,3.19,2.94s2.74-1.05,3.24-2.52a11.81,11.81,0,0,0,.51-2.66A6.42,6.42,0,0,1,1093.36,510.62Z"
          transform="translate(-28.43 -18.54)"
        />
        <path
          d="M1097.72,498c-1,2.74-2.93,5.11-3.56,8-.12.58-.2,1.18-.27,1.78.64-2.88,2.51-5.24,3.55-8a13.89,13.89,0,0,0,.85-3.84A14,14,0,0,1,1097.72,498Z"
          transform="translate(-28.43 -18.54)"
        />
      </g>
      <circle cx="935.51" cy="546.26" r="0.23" fill="#e6e8ec" />
      <rect x="849.12" y="551.42" width="181.18" height="208.22" rx="6.61" ry="6.61" fill="#fff" />
      <rect
        x="849.12"
        y="551.42"
        width="181.18"
        height="208.22"
        rx="6.61"
        ry="6.61"
        fill="#5a5773"
        opacity="0.1"
      />
      <rect x="858.36" y="562.04" width="162.7" height="186.98" rx="6.61" ry="6.61" fill="#fff" />
      <rect
        x="882.03"
        y="599.54"
        width="111.62"
        height="38.52"
        rx="6.03"
        ry="6.03"
        fill="#3355ff"
      />
      <rect x="886.13" y="652.15" width="103.43" height="7.86" fill="#3355ff" />
      <rect x="868.55" y="668.74" width="142.32" height="7.86" fill="#3355ff" />
      <rect x="868.55" y="686.2" width="142.32" height="7.86" fill="#3355ff" />
      <rect x="868.55" y="703.66" width="142.32" height="7.86" fill="#3355ff" />
      <rect y="482.59" width="426.61" height="208.22" rx="6.61" ry="6.61" fill="#fff" />
      <rect
        y="482.59"
        width="426.61"
        height="208.22"
        rx="6.61"
        ry="6.61"
        fill="#5a5773"
        opacity="0.1"
      />
      <rect x="21.76" y="493.21" width="383.08" height="186.98" rx="6.61" ry="6.61" fill="#fff" />
      <rect x="77.51" y="530.72" width="262.81" height="38.52" rx="6.03" ry="6.03" fill="#3355ff" />
      <rect x="87.15" y="583.32" width="243.53" height="7.86" fill="#3355ff" />
      <rect x="45.75" y="599.91" width="335.1" height="7.86" fill="#3355ff" />
      <rect x="45.75" y="617.37" width="335.1" height="7.86" fill="#3355ff" />
      <rect x="45.75" y="634.83" width="335.1" height="7.86" fill="#3355ff" />
      <path
        d="M132.7,859.18c1.19-4.34,2-8.16,2-8.16a17,17,0,0,1,2.22-8.27l0-1.2h0l.34-8.81a29.33,29.33,0,0,0-2-4.7c-1.48-2.83.5-12.92.5-12.92s6.43-14.07,5.35-23.2,13.62-39.83,13.62-39.83a39.48,39.48,0,0,0-.92-9,6.9,6.9,0,0,1-.1-1.87,1.77,1.77,0,0,1,0-.23v.07c.43-6,5.59-17,5.59-17l.19-21.4s-2.54-12.72,3-29.45c1.95-5.84,3.23-10.52,4.07-14.14.1-.41.19-.8.27-1.18-10.08-1.94-17.78-3.52-17.78-3.52s6.83-24.38,11-28.53,7.83-17.57,7.83-17.57,2.74-17.3-.4-22.5-3.28-14-3.28-14-7.42-5.83-8.28-8.32-2.23-8.1-2.12-11,1.17-5.5.91-7.05,2.51-7.29,1.34-10.11a7.74,7.74,0,0,1-.4-2.69s0,0,0-.08v0a37.42,37.42,0,0,1,.95-7.19,20.4,20.4,0,0,1,7.7-3.74l.19-.66.5-1.71a8.33,8.33,0,0,1,.76-.42l.05-.63.16-2.49L165,510c-2-9.86,11.12-10.81,11.12-10.81a6.87,6.87,0,0,1,3.81-3.1c2.66-.82-.12,14.71-1.39,15.66-1,.71-4,5.5-5.45,7.85h0l-.24.39a5.4,5.4,0,0,1,.58.65l-.63,3.37-.1.51a14,14,0,0,1,1.95,3.63s-2.49,2.52-2.12,5.46a17.59,17.59,0,0,1-1,6.73c.14-.15,1.89-1.9,3.55-1.4s6.28,2.09,6.28,2.09,3.47.75,3.12,1.51,2.23,4.24,2.23,4.24l9.73-8.53c.11-.27.21-.53.31-.8a22.35,22.35,0,0,0,1-3.87,20.92,20.92,0,0,1-3-1.07,6.53,6.53,0,0,1-2.54-1.76c-.9-1.16-1-2.7-1.35-4.11-.64-2.76-2.14-5.26-3.19-7.91a25.29,25.29,0,0,1-1.34-14,9.32,9.32,0,0,1,1.6-4c1.62-2.05,4.43-2.8,6.52-4.4s3.49-4.13,5.89-5.3c2.18-1.06,4.77-.82,7.16-.34A38.26,38.26,0,0,1,220.55,496c1.34.87,2.81,1.87,4.4,1.64a6.07,6.07,0,0,0,3.3-2.23.74.74,0,0,1,0-.14l.11-.11a16.49,16.49,0,0,1,1.18,7.08c0,.37,0,.75-.08,1.12,0,.13,0,.26,0,.39a1.82,1.82,0,0,0,0,.33h0a1.65,1.65,0,0,0,.06.49,3.51,3.51,0,0,0,.83,1.31,7.15,7.15,0,0,1,.72,1.07c0-.13-.07-.26-.11-.39a5.58,5.58,0,0,1,.86,3,2.93,2.93,0,0,1-.79,2.09,9.29,9.29,0,0,1-1.58,1.18,17.95,17.95,0,0,1-9.28,18.29c-.12.26-.24.53-.35.8a22.36,22.36,0,0,0-2.1,10.17c0,.25,0,.5.08.75s.23.27.33.41h0s15.5.75,19.28-2.42,8.9,8.43,8.9,8.43,5.52,1.29,6.67.26,7.64.14,7.64.14a14,14,0,0,1,9.82-3.17,28.69,28.69,0,0,1,7.27-3.68h0l.18-.06h0a7.84,7.84,0,0,1,3.51-.31s7.87-6,10.22-9.31S305,517.69,305,517.63l.07-.6.19-1.82a6.12,6.12,0,0,0,.94.12l.24-.63a34.33,34.33,0,0,1,2.45-5.08s.09-2.31-.56-2.91.63-9,.63-9,7.49-15.8,13.18-3.57c0,0,11.34,8.21,1.22,16.87,0,0-4,1.74-4.57,3.21-.4,1-1.83,3.62-2.79,5.39l-.43.79.11.1-.2,1.5-.08.59c1.79,1.11,3,2.19,2.67,3a17,17,0,0,0-1.27,4.11S302.66,546,300.64,553.19c0,0-37.06,20.14-49,21.22l1.65,10.84a86.42,86.42,0,0,1,.14,8.79c-.25,2.3.94,12.81.94,12.81s1.47,15.46,3.14,17.68,1,11.44,1,11.44a77.91,77.91,0,0,0,1.88,13.16c1.52,5.91,0,13.09,0,13.09s5.51,14.07-8.59,4.13c0,0-7.08-.71-15.24-1.3,0,.26,0,.54,0,.81,0,1.06-.05,2.2-.08,3.4-.2,7.93-.57,18.85-1.25,27.1-1.2,14.59-6.76,43.33-6.76,43.33l-.56,14.52a19.24,19.24,0,0,1,.26,4.17,27,27,0,0,1-4.47,14.39l-1.49,9.65s-2.85,6.28-3.05,10.09a4.54,4.54,0,0,0,.08.93,7.42,7.42,0,0,1,.07,1.49c0,4.4-3.08,14.82-3.08,14.82s-.57,10.61-2.18,11.16c-1.38.48,1.58,6.19,2.46,7.83a1.63,1.63,0,0,0,.07-.3l.19.32a7.54,7.54,0,0,1,.39,2.71,3.87,3.87,0,0,1-1.91,3.66c-3.09,1.73-4.77,3.2-2.23,3.92a28.23,28.23,0,0,1,2.78.69l.15-.35a1.71,1.71,0,0,1,1,1.9,7.77,7.77,0,0,1-1.09,3.56,38.76,38.76,0,0,1-4.6,7.68l-1.22-.18a6.1,6.1,0,0,0,.66,1.33,5.08,5.08,0,0,0,1.74,1.67,5.56,5.56,0,0,0,2.14.82,6.17,6.17,0,0,1,4.42,2.37c1.5,2.11,2.39,4.94-.84,7.27l-11.51,3.48s-19.64,1.79-18.44-2.55,2-8.16,2-8.16a17.35,17.35,0,0,1,1.88-7.72,10.32,10.32,0,0,1,.74-1.12l-.69-.1S191,839.89,189.12,838c-.42-.45-.51-.78-.4-1-.17-.53.33-.82,1-1,0,.12.09.25.13.38a9.65,9.65,0,0,1,1.9-.13s.83-5.05-1.16-7a1.9,1.9,0,0,1-.34-1.52,7.79,7.79,0,0,1,.29-2.06.75.75,0,0,0,.07.12c1.22-4.56,5-11.74,5-11.74s.33-4.61-.87-6.51,1.13-25.06,1.13-25.06-.05-11.24,1.58-16.41-1.31-11.45-1.31-11.45,0-.12.05-.33a.41.41,0,0,0,0-.09s.1-.69.26-1.76l0,.11c.44-3,1.25-8.31,1.79-10.79.77-3.51.63-20.46.63-20.46L196.28,714l-5.57,12.26-6,16.4s-2.81,3.4-3,7c0,.18,0,.35,0,.53a8.32,8.32,0,0,1,0,1.11,9.92,9.92,0,0,1-1.88,5.85s-1.73,7.79-4,9.7-2.45,5.76-2.45,5.76-3.14,11.28-4.49,13.23c-1.13,1.64-1.37,6.27-1.41,7.69h0c0,.26,0,.41,0,.41s-.53,4.06-.65,7.48c0,.42,0,.83,0,1.21a.22.22,0,0,1,0-.08,11.59,11.59,0,0,0,.22,2.77s0,.11,0,.17l0-.58a29.09,29.09,0,0,1,.55,7.12c-.09,4.09-.9,8.91-3.49,11.66-4.48,4.76-7.15,4-7.15,4s1.83,6.23,4.32,7.56a1.59,1.59,0,0,1,.27.18c0-.12,0-.24.07-.35a3,3,0,0,1,.66,2.32c.08,2.71-1.8,7-3.5,9a5,5,0,0,1-2.19,1.18,3.77,3.77,0,0,0,.39.26,7.85,7.85,0,0,0,.86.44,4.25,4.25,0,0,0,1.28.39,6.08,6.08,0,0,1,4.42,2.37c1.5,2.1,2.39,4.93-.84,7.26l-11.51,3.48S131.49,863.52,132.7,859.18Z"
        transform="translate(-28.43 -18.54)"
        fill="url(#ccb18d0b-874b-442a-b8cb-57bcf76cdeb5)"
      />
      <path
        d="M207.05,869.31l11.15-3.49c3.13-2.34,2.27-5.17.82-7.28a5.84,5.84,0,0,0-4.27-2.35,5.22,5.22,0,0,1-2.08-.83A5,5,0,0,1,211,853.7a8.2,8.2,0,0,1-1.09-4.3s-11.94-4-15.38-.59A9,9,0,0,0,193,850.9a18,18,0,0,0-1.84,7.72s-.76,3.81-1.93,8.16S207.05,869.31,207.05,869.31Z"
        transform="translate(-28.43 -18.54)"
        fill="#2d293d"
      />
      <path
        d="M153.44,861.82l11.15-3.49c3.13-2.34,2.27-5.17.82-7.27a5.84,5.84,0,0,0-4.28-2.36,3.93,3.93,0,0,1-1.24-.38,7.86,7.86,0,0,1-.83-.45c-3-1.81-2.77-6-2.77-6s-11.94-4-15.38-.59a8.84,8.84,0,0,0-1.22,1.52,17.45,17.45,0,0,0-2.16,8.29s-.77,3.82-1.93,8.16S153.44,861.82,153.44,861.82Z"
        transform="translate(-28.43 -18.54)"
        fill="#2d293d"
      />
      <path
        d="M194.52,848.81A9,9,0,0,0,193,850.9h0l18,2.79a8.2,8.2,0,0,1-1.09-4.3S198,845.4,194.52,848.81Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M139.69,842.84l-.13,3.39c2.64,4.75,16.29,4.26,20.33,2.09a7.86,7.86,0,0,1-.83-.45c-3-1.81-2.77-6-2.77-6s-11.94-4-15.38-.59A8.84,8.84,0,0,0,139.69,842.84Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M138.1,828.16a31.07,31.07,0,0,1,2,4.7L139.61,845c2.88,5.2,18.94,4.12,21.2,1.44s4.84-9.83,2.43-11.15-4.18-7.56-4.18-7.56,2.59.72,6.94-4,3.53-15.73,2.85-18.37.45-11.38.45-11.38.08-6.16,1.39-8.11,4.36-13.23,4.36-13.23.14-3.85,2.37-5.76,3.92-9.71,3.92-9.71a10.06,10.06,0,0,0,1.79-6.55c-.31-3.86,2.92-7.9,2.92-7.9l5.87-16.4,5.4-12.27,2.49,7.33s.12,16.95-.63,20.46-2,12.86-2,12.86,2.84,6.27,1.26,11.45-1.56,16.41-1.56,16.41-2.28,23.17-1.12,25.06.83,6.5.83,6.5-6.82,13.29-4.9,15.22,1.12,7,1.12,7-4.3-.17-2.53,1.75S193,849.68,193,849.68l18.51,2.87a39.17,39.17,0,0,0,4.46-7.69c2.68-5.59-.26-5.09-2.71-5.8s-.83-2.19,2.16-3.92,1.46-5.95,1.46-5.95-4.17-7.71-2.6-8.26,2.12-11.16,2.12-11.16,3.56-12.5,2.92-15.91,2.91-11.44,2.91-11.44l1.44-9.64a26.63,26.63,0,0,0,4.09-18.17l.58-14.92S233.78,711,235,696.36c.76-9.34,1.14-22.11,1.31-30.08.1-4.48.14-7.44.14-7.44l-66.17-9.48a54.61,54.61,0,0,1-1.59,9.82c-.81,3.63-2.06,8.31-4,14.15-5.42,16.73-3,29.45-3,29.45l-.21,21.4s-6.4,14.08-5.35,19.05a40.64,40.64,0,0,1,.88,9S142.77,782.91,143.81,792s-5.21,23.21-5.21,23.21S136.67,825.33,138.1,828.16Z"
        transform="translate(-28.43 -18.54)"
        fill="#575988"
      />
      <path
        d="M179.17,749.5,159.05,746S170.06,758.16,179.17,749.5Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.05"
      />
      <path
        d="M162.73,726.39s-1,7.12,3.31,10C166,736.37,158.25,734.84,162.73,726.39Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M164.85,703.67s16.37,14.57,22.56,13.66S164.85,703.67,164.85,703.67Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M204,757s12.73,3.42,12.92,8.58S204,757,204,757Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M198.69,821s18,4.08,12.78,6.19-13.77,3.63-13.77,3.63S191.84,830.92,198.69,821Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.05"
      />
      <g opacity="0.05">
        <path
          d="M215,831a3.6,3.6,0,0,0,1.76-2.56l.17.33s1.54,4.21-1.46,6c-.34.19-.66.39-1,.58-.53-.12-1.11-.22-1.66-.38C210.37,834.22,212,832.74,215,831Z"
          transform="translate(-28.43 -18.54)"
        />
        <path
          d="M191.66,828.88c-.48-.48-.41-1.66,0-3.17a8.59,8.59,0,0,1,.86,4.5A3.5,3.5,0,0,0,191.66,828.88Z"
          transform="translate(-28.43 -18.54)"
        />
        <path
          d="M197.4,752.48a20.92,20.92,0,0,1,1,5.71,21.81,21.81,0,0,0-1.26-3.94S197.25,753.56,197.4,752.48Z"
          transform="translate(-28.43 -18.54)"
        />
        <path
          d="M156.17,742.81a7.34,7.34,0,0,1-.11-1.69c.19,1.16.31,2.23.38,3.17C156.36,743.81,156.27,743.32,156.17,742.81Z"
          transform="translate(-28.43 -18.54)"
        />
        <path
          d="M195.73,807.17a10.19,10.19,0,0,1-.32-3.43,11.57,11.57,0,0,1,.72,4.34A4.23,4.23,0,0,0,195.73,807.17Z"
          transform="translate(-28.43 -18.54)"
        />
        <path
          d="M190.81,836a60.4,60.4,0,0,1,1.75,9.53l18.51,2.87a38.76,38.76,0,0,0,4.47-7.69c.24-.49.42-.93.58-1.33,1.09.55,1.49,1.73-.11,5.05a39.23,39.23,0,0,1-4.46,7.68L193,849.26s-1-9.74-2.79-11.65C189.38,836.66,190,836.23,190.81,836Z"
          transform="translate(-28.43 -18.54)"
        />
        <path
          d="M216.44,809.35s-.56,10.61-2.12,11.16h0c-.71-1.79-1.17-3.47-.47-3.72,1.56-.56,2.13-11.16,2.13-11.16s3.56-12.49,2.92-15.91,2.9-11.43,2.9-11.43l1.45-9.65a26.63,26.63,0,0,0,4.09-18.17l.57-14.92s5.42-28.74,6.6-43.33c.75-9.34,1.13-22.11,1.31-30.08,0-1.44.06-2.72.08-3.8l.53.08s0,3-.14,7.43c-.17,8-.55,20.75-1.31,30.09-1.18,14.58-6.59,43.33-6.59,43.33l-.58,14.91a26.66,26.66,0,0,1-4.08,18.17L222.27,782s-3.55,8-2.91,11.44S216.44,809.35,216.44,809.35Z"
          transform="translate(-28.43 -18.54)"
        />
        <path
          d="M160.35,842.31a18,18,0,0,0,3.22-7.19c1.83,1.78-.6,8.35-2.75,10.9s-18.32,3.76-21.2-1.43l.11-2.93C143.73,845.94,158.21,844.85,160.35,842.31Z"
          transform="translate(-28.43 -18.54)"
        />
        <path
          d="M137.64,824a31.07,31.07,0,0,1,2,4.7l-.09,2.15a33.59,33.59,0,0,0-1.42-3.14,9.27,9.27,0,0,1-.52-3.83Z"
          transform="translate(-28.43 -18.54)"
        />
        <path
          d="M160,827.32a30.07,30.07,0,0,1-1.38-3.71s2.59.71,6.93-4.05c3.16-3.47,3.59-10.22,3.33-14.66.68,2.65,1.49,13.61-2.85,18.37C163.17,826.39,161.08,827.16,160,827.32Z"
          transform="translate(-28.43 -18.54)"
        />
        <path
          d="M169.31,793.52a82.23,82.23,0,0,0-.66,9.11,13,13,0,0,0-.26-1.44c-.67-2.65.44-11.38.44-11.38s.09-6.16,1.39-8.11,4.36-13.23,4.36-13.23.15-3.84,2.38-5.76,3.92-9.71,3.92-9.71a10.12,10.12,0,0,0,1.79-6.55c-.31-3.86,2.92-7.9,2.92-7.9l5.87-16.4,5.4-12.27,2.49,7.34s0,.9,0,2.34l-2-6-5.4,12.26-5.87,16.41s-3.23,4-2.92,7.9a10.06,10.06,0,0,1-1.79,6.55s-1.69,7.79-3.92,9.7-2.37,5.76-2.37,5.76-3.06,11.28-4.36,13.24S169.31,793.52,169.31,793.52Z"
          transform="translate(-28.43 -18.54)"
        />
      </g>
      <path
        d="M167.28,510.1l.94,5.66-.16,2.5-.12,1.84,6.39.91.77-1.3h0c1.42-2.35,4.36-7.14,5.29-7.86,1.22-.95,3.94-16.48,1.36-15.66a6.75,6.75,0,0,0-3.7,3.1S165.39,500.25,167.28,510.1Z"
        transform="translate(-28.43 -18.54)"
        fill="#ffcdd3"
      />
      <path
        d="M167.94,520.1l6.39.91.77-1.3h0a5.67,5.67,0,0,0-7-1.44Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M166.2,523.08l8.39,2.29.22-1.26.61-3.37a5.83,5.83,0,0,0-8.15-1.43l-.48,1.71Z"
        transform="translate(-28.43 -18.54)"
        fill="#dce6f2"
      />
      <path
        d="M303.74,516l8.84,5.2s.37-.71.89-1.68c.93-1.77,2.31-4.43,2.7-5.39.59-1.47,4.43-3.22,4.43-3.22,9.81-8.67-1.16-16.86-1.16-16.86-5.5-12.23-12.76,3.58-12.76,3.58s-1.25,8.43-.62,9,.54,2.91.54,2.91a34,34,0,0,0-2.38,5.08C303.91,515.45,303.74,516,303.74,516Z"
        transform="translate(-28.43 -18.54)"
        fill="#ffcdd3"
      />
      <path
        d="M303.74,516l8.84,5.2s.37-.71.89-1.68c-1.24-1.11-5.62-5-7.11-4.84a10.73,10.73,0,0,1-2.14,0C303.91,515.45,303.74,516,303.74,516Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M302.71,518.67l10,5.39.28-2.18.2-1.5s-5.68-5.26-7.42-5.14a9.44,9.44,0,0,1-2.66-.11l-.18,1.82Z"
        transform="translate(-28.43 -18.54)"
        fill="#dce6f2"
      />
      <path
        d="M190.45,548.34s44.07,6.7,35.9,3.7c-5.69-2.1-7.84-5.85-8.16-9.93a23.22,23.22,0,0,1,2-10.18,44.62,44.62,0,0,1,4.27-7.84s-33.12-19.91-27-2.73a27.14,27.14,0,0,1,1.61,8.09,22.8,22.8,0,0,1-1.18,8.08A24.2,24.2,0,0,1,190.45,548.34Z"
        transform="translate(-28.43 -18.54)"
        fill="#ffcdd3"
      />
      <path
        d="M197.5,521.36a27.14,27.14,0,0,1,1.61,8.09c3.08,2.79,6.58,2.75,11.07,2.92,3.45.14,7.23,1.12,10-.44a44.62,44.62,0,0,1,4.27-7.84S191.38,504.18,197.5,521.36Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <circle cx="183.01" cy="496.73" r="18.31" fill="#ffcdd3" />
      <path
        d="M190.45,548.34s44.07,6.7,35.9,3.7c-5.69-2.1-7.84-5.85-8.16-9.93-2.11-2.47-6.47-4.36-9.28-5.39a13.33,13.33,0,0,0-8-.44,11,11,0,0,0-3,1.25A24.2,24.2,0,0,1,190.45,548.34Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M166.2,523.08l8.39,2.29.22-1.26a7.47,7.47,0,0,0-8-3.09Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M302.71,518.67l10,5.39.28-2.18A75.72,75.72,0,0,0,302.89,517Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M168.65,659.18c17,3.37,41.3,7.83,45.21,6.8,3.25-.85,13.5-.35,22.41.3.1-4.48.14-7.44.14-7.44l-66.17-9.48A54.61,54.61,0,0,1,168.65,659.18Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M151.72,654.5s56.06,11.86,62.19,10.25,37.15,1.58,37.15,1.58c13.63,9.92,8.32-4.14,8.32-4.14s1.51-7.18,0-13.09a80,80,0,0,1-1.81-13.16s.67-9.22-.94-11.43-3-17.68-3-17.68-1.13-10.51-.89-12.81-.12-8.79-.12-8.79l-1.59-10.84c11.59-1.09,47.48-21.27,47.48-21.27,2-7.16,15.69-23.58,15.69-23.58a17.76,17.76,0,0,1,1.24-4.11c1-2.42-12.63-7.87-12.63-7.87S292,529.77,289.76,533.07s-9.91,9.32-9.91,9.32a7.51,7.51,0,0,0-3.4.31l-.18,0h0a27.47,27.47,0,0,0-7,3.69,13.4,13.4,0,0,0-9.52,3.17s-6.27-1.16-7.38-.13-6.46-.25-6.46-.25-5-11.58-8.61-8.41-18.67,2.44-18.67,2.44c-1.89-2.74-6.69-4.83-9.69-5.93a13.25,13.25,0,0,0-8-.44,10.39,10.39,0,0,0-3.23,1.41l-9.44,8.56s-2.49-3.48-2.15-4.24-3-1.5-3-1.5-4.41-1.56-6.08-2.08-3.3,1.24-3.44,1.4a17.78,17.78,0,0,0,1-6.73c-.35-2.94,2.05-5.47,2.05-5.47-4.87-13.43-17.44-2.82-17.44-2.82s-1.67,7.17-.54,10-1.56,8.56-1.32,10.11-.77,4.13-.88,7.05,1.21,8.52,2,11,8,8.32,8,8.32.13,8.78,3.16,14,.37,22.5.37,22.5-3.6,13.41-7.61,17.57S151.72,654.5,151.72,654.5Z"
        transform="translate(-28.43 -18.54)"
        fill="#656691"
      />
      <path
        d="M237.88,556.48s1.89-5,3.44-5.41a35.43,35.43,0,0,0,4.54-1.83l-.92-1.93s-5.84,1.37-6.82,3S237.88,556.48,237.88,556.48Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M269.22,546.45c.25,1.55,13.88,3.46,13.88,3.46l-6.65-7.21h0l-.17,0h0A27.47,27.47,0,0,0,269.22,546.45Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <circle cx="281.2" cy="508.32" r="1.23" fill="#575988" />
      <circle cx="279.53" cy="510.72" r="1.23" fill="#575988" />
      <circle cx="277.9" cy="512.93" r="1.23" fill="#575988" />
      <circle cx="276.2" cy="515.33" r="1.23" fill="#575988" />
      <circle cx="131.25" cy="509.62" r="1" fill="#575988" />
      <circle cx="131.01" cy="511.88" r="1" fill="#575988" />
      <circle cx="130.78" cy="514.14" r="1" fill="#575988" />
      <path
        d="M236.2,598.15c.15-.17-36.2,42.27-62.14,15.94C174.06,614.09,216.36,621.49,236.2,598.15Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M255.24,621.68s-20.77-.23-23.17,5.65l-.24,6.21a4,4,0,0,0,3.86.15c2.14-1.05,14.92-6.94,19.23-3.7Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M254.85,621.66s-19.85-.22-22.15,5.39l-.23,5.92a3.8,3.8,0,0,0,3.69.14c2-1,14.27-6.61,18.39-3.53Z"
        transform="translate(-28.43 -18.54)"
        fill="#656691"
      />
      <path
        d="M245.65,576.2a67.4,67.4,0,0,1-8.57,13.49A54.07,54.07,0,0,1,224,601.37S245.19,579,245.65,576.2Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M253.36,552.36s-4,14.81-13.15,19.54Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M258.61,554.07c.1-.27,2.62,11.94-12.21,18.07C246.4,572.14,252.67,570.27,258.61,554.07Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M168.42,540.57c.23,0-7.37,4.45-9.47,6.56C159,547.13,164.05,540.09,168.42,540.57Z"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M215.75,532.05a3.93,3.93,0,0,1-1.53,2.42,3.77,3.77,0,0,1-1.74.31c-5.59.14-11.41.16-16.48-2.19a6.22,6.22,0,0,1-2.45-1.76c-.88-1.16-1-2.69-1.31-4.11-.62-2.76-2.07-5.25-3.08-7.9a26,26,0,0,1-1.27-14,9.37,9.37,0,0,1,1.55-4c1.56-2.05,4.29-2.8,6.31-4.41s3.38-4.13,5.72-5.31c2.1-1.06,4.61-.83,6.92-.34a36.32,36.32,0,0,1,12.7,5.33c1.29.87,2.71,1.86,4.25,1.63a5.92,5.92,0,0,0,3.26-2.3,17,17,0,0,1,1.06,8,3.45,3.45,0,0,0,0,1.2,3.65,3.65,0,0,0,.8,1.31c1.31,1.65,2.08,4.21.66,5.77-.62.68-1.55,1-2.15,1.73-1.08,1.24-.81,3.1-.85,4.75a2.5,2.5,0,0,1-.46,1.61,2.39,2.39,0,0,1-2.28.45,6.22,6.22,0,0,0-2.4-.32,4,4,0,0,0-2.15,1.52C218.12,524.58,217,528.15,215.75,532.05Z"
        transform="translate(-28.43 -18.54)"
        fill="#2d293d"
      />
      <g opacity="0.1">
        <path
          d="M193,529.39a6.14,6.14,0,0,0,2.45,1.77c5.07,2.35,10.89,2.32,16.48,2.19a3.65,3.65,0,0,0,1.74-.32,3.88,3.88,0,0,0,1.53-2.41c1.23-3.91,2.37-7.47,5.08-10.65a4,4,0,0,1,2.15-1.53,6.42,6.42,0,0,1,2.4.32,2.36,2.36,0,0,0,2.28-.45,2.46,2.46,0,0,0,.46-1.6c0-1.65-.23-3.51.85-4.76.6-.69,1.53-1,2.15-1.72a3.62,3.62,0,0,0,.49-3.66c.92,1.59,1.27,3.6.07,4.91-.62.68-1.54,1-2.15,1.73-1.08,1.24-.8,3.1-.84,4.75a2.45,2.45,0,0,1-.47,1.61,2.38,2.38,0,0,1-2.28.45,6.17,6.17,0,0,0-2.39-.32,4,4,0,0,0-2.16,1.53c-2.7,3.17-3.84,6.74-5.08,10.64a2.89,2.89,0,0,1-3.26,2.74c-5.59.13-11.41.15-16.49-2.2a6.26,6.26,0,0,1-2.45-1.76,4.8,4.8,0,0,1-.73-1.51A1.84,1.84,0,0,0,193,529.39Z"
          transform="translate(-28.43 -18.54)"
        />
        <path
          d="M229.62,504.1a2.47,2.47,0,0,1-.52-1,3.45,3.45,0,0,1,0-1.2,17.05,17.05,0,0,0-.6-6.66l.1-.11a16.87,16.87,0,0,1,1.07,8A5.43,5.43,0,0,0,229.62,504.1Z"
          transform="translate(-28.43 -18.54)"
        />
      </g>
      <path
        d="M218.58,543.27s-23,2.15-24.9-1.37"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
      <path
        d="M174.51,532.1s-12.71-.47-15.68,4.18"
        transform="translate(-28.43 -18.54)"
        opacity="0.1"
      />
    </svg>
  );
};

export const ContactSVG = function () {
  return (
    <svg
      id="ae37f038-3a9e-4b82-ad68-fc94ba16af2a"
      className={'ContactSVG heroSVG'}
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="1096"
      height="574.74"
      viewBox="0 0 1096 574.74"
    >
      <defs>
        <linearGradient
          id="eb6c86d6-45fa-49e0-9a60-1b0612516196"
          x1="819.07"
          y1="732.58"
          x2="819.07"
          y2="560.46"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="gray" stop-opacity="0.25" />
          <stop offset="0.54" stop-color="gray" stop-opacity="0.12" />
          <stop offset="1" stop-color="gray" stop-opacity="0.1" />
        </linearGradient>
        <pattern
          id="ad310e25-2b04-44c8-bb7b-982389166780"
          data-name="New Pattern 3"
          width="36.88"
          height="49.48"
          patternUnits="userSpaceOnUse"
          viewBox="0 0 36.88 49.48"
        >
          <rect width="36.88" height="49.48" fill="none" />
          <path d="M4.33,13.19c4.5,0,4.51-7,0-7s-4.52,7,0,7Z" />
          <path d="M4.51,17.16c4.51,0,4.52-7,0-7s-4.51,7,0,7Z" />
          <path d="M4.51,20.94c4.51,0,4.52-7,0-7s-4.51,7,0,7Z" />
          <path d="M3.38,24.72c4.51,0,4.51-7,0-7s-4.51,7,0,7Z" />
          <path d="M1.09,28.29l.2.38a3.52,3.52,0,0,0,4.78,1.25,3.58,3.58,0,0,0,1.26-4.79l-.19-.37A3.52,3.52,0,0,0,2.35,23.5a3.59,3.59,0,0,0-1.26,4.79Z" />
          <path d="M1.49,30.1l.18.57a3.73,3.73,0,0,0,1.61,2.09,3.59,3.59,0,0,0,2.7.35A3.54,3.54,0,0,0,8.42,28.8l-.18-.56a3.68,3.68,0,0,0-1.61-2.1,3.61,3.61,0,0,0-2.69-.35A3.56,3.56,0,0,0,1.49,30.1Z" />
          <path d="M1.58,33.88v.38a3.54,3.54,0,0,0,3.5,3.5,3.56,3.56,0,0,0,3.5-3.5v-.38a3.54,3.54,0,0,0-3.5-3.5,3.57,3.57,0,0,0-3.5,3.5Z" />
          <path d="M4.89,42.3c4.51,0,4.51-7,0-7s-4.51,7,0,7Z" />
          <path d="M1.77,42v.19a3.54,3.54,0,0,0,3.5,3.5,3.56,3.56,0,0,0,3.5-3.5V42a3.54,3.54,0,0,0-3.5-3.5A3.56,3.56,0,0,0,1.77,42Z" />
          <path d="M6,49.29c4.5,0,4.51-7,0-7s-4.52,7,0,7Z" />
          <path d="M10,14.14c4.5,0,4.51-7,0-7s-4.52,7,0,7Z" />
          <path d="M6.59,20.94c4.51,0,4.52-7,0-7s-4.51,7,0,7Z" />
          <path d="M8.48,27c4.51,0,4.51-7,0-7s-4.51,7,0,7Z" />
          <path d="M8.48,29.26c4.51,0,4.51-7,0-7s-4.51,7,0,7Z" />
          <path d="M14.91,33.79c4.5,0,4.51-7,0-7s-4.51,7,0,7Z" />
          <path d="M9.81,38.52c4.5,0,4.51-7,0-7s-4.52,7,0,7Z" />
          <path d="M10.56,45.13c4.51,0,4.51-7,0-7s-4.51,7,0,7Z" />
          <path d="M10.56,49.48c4.51,0,4.51-7,0-7s-4.51,7,0,7Z" />
          <path d="M12.83,18.12c2.57,0,2.58-4,0-4s-2.58,4,0,4Z" />
          <path d="M13,20.39c2.57,0,2.58-4,0-4s-2.58,4,0,4Z" />
          <path d="M13.1,21v.19a2,2,0,0,0,4,0V21a2,2,0,0,0-4,0Z" />
          <path d="M15.1,25.87c2.57,0,2.58-4,0-4s-2.58,4,0,4Z" />
          <path d="M16.61,11.07a1,1,0,0,0,0-2,1,1,0,0,0,0,2Z" />
          <path d="M21.71,16.55a1,1,0,0,0,0-2,1,1,0,0,0,0,2Z" />
          <path d="M16.85,8.94V8.56a1,1,0,0,0-2,0v.38a1,1,0,0,0,2,0Z" />
          <path d="M16.48,4.78V4.59a1,1,0,0,0-2,0v.19a1,1,0,0,0,2,0Z" />
          <path d="M15.48,2a1,1,0,0,0,0-2,1,1,0,0,0,0,2Z" />
          <path d="M10.56,2a1,1,0,0,0,0-2,1,1,0,0,0,0,2Z" />
          <path d="M10.37,4.65a1,1,0,0,0,0-2,1,1,0,0,0,0,2Z" />
          <path d="M7.35,6.16a1,1,0,0,0,0-2,1,1,0,0,0,0,2Z" />
          <path d="M11.88,7.1h.38a1,1,0,0,0,0-2h-.38a1,1,0,0,0,0,2Z" />
          <path d="M13.28,11l.57,1.32a1,1,0,0,0,1.37.36,1,1,0,0,0,.36-1.37L15,10a1,1,0,0,0-1.37-.36A1,1,0,0,0,13.28,11Z" />
          <path d="M18.44,19.33v.19a1,1,0,0,0,2,0v-.19a1,1,0,0,0-2,0Z" />
          <path d="M20.68,24.93l.19.38c.57,1.15,2.3.14,1.72-1l-.19-.38c-.57-1.15-2.3-.14-1.72,1Z" />
          <path d="M22.13,29.38a2.48,2.48,0,0,0-.84,1.86,1,1,0,0,0,2,0,.56.56,0,0,1,.25-.44,1,1,0,0,0,0-1.42,1,1,0,0,0-1.41,0Z" />
          <path d="M20.32,33.41l-.54,1.71c-.38,1.23,1.55,1.76,1.93.53l.54-1.71c.38-1.23-1.55-1.76-1.93-.53Z" />
          <path d="M19.44,37h-.19a1,1,0,0,0,0,2h.19a1,1,0,0,0,0-2Z" />
          <path d="M17.64,41.5l-.19.38c-.58,1.15,1.15,2.16,1.72,1l.19-.38c.58-1.15-1.15-2.16-1.72-1Z" />
          <path d="M15.8,47.87v.56a1,1,0,0,0,2,0v-.56a1,1,0,0,0-2,0Z" />
          <path d="M14.34,49.43a1,1,0,0,0,0-2,1,1,0,0,0,0,2Z" />
          <path d="M14.34,41.31a1,1,0,0,0,0-2,1,1,0,0,0,0,2Z" />
          <path d="M17.13,36.47a2,2,0,0,0,1-1.64,1,1,0,0,0-2,0c0-.13.19-.2,0-.08-1.15.58-.14,2.3,1,1.72Z" />
          <path d="M17.37,31.29a1,1,0,0,0,0-2,1,1,0,0,0,0,2Z" />
          <path d="M18.12,28.46a1,1,0,0,0,0-2,1,1,0,0,0,0,2Z" />
          <path d="M19,24.94l.19-.38c.58-1.15-1.15-2.16-1.72-1l-.19.38c-.58,1.15,1.15,2.16,1.72,1Z" />
          <path d="M17.93,16a1,1,0,0,0,0-2,1,1,0,0,0,0,2Z" />
          <path d="M24.64,16.05l.57.94a1,1,0,0,0,1.72-1L26.37,15a1,1,0,0,0-1.73,1Z" />
          <path d="M34.88,29.72v.19a1,1,0,0,0,2,0v-.19a1,1,0,0,0-2,0Z" />
          <path d="M24,39.23a1,1,0,0,0,0-2,1,1,0,0,0,0,2Z" />
          <path d="M22.85,29a1,1,0,0,0,0-2,1,1,0,0,0,0,2Z" />
          <path d="M18.24,21.9l.57-.56c.93-.89-.48-2.3-1.41-1.41l-.58.56c-.93.89.49,2.3,1.42,1.41Z" />
        </pattern>
        <linearGradient
          id="a964f849-fa65-4178-8cc4-fb8fb10b3617"
          x1="462.91"
          y1="660.68"
          x2="462.91"
          y2="559.69"
          xlinkHref="#eb6c86d6-45fa-49e0-9a60-1b0612516196"
        />
      </defs>
      <g opacity="0.1">
        <ellipse cx="479.42" cy="362.12" rx="11.38" ry="14.9" fill="#3f3d56" />
        <path
          d="M540.43,461a18,18,0,0,0,2.38-9.11c0-8.23-5.1-14.9-11.39-14.9S520,443.68,520,451.91a18,18,0,0,0,2.38,9.11,18.61,18.61,0,0,0,0,18.21,18.61,18.61,0,0,0,0,18.21,17.94,17.94,0,0,0-2.38,9.11c0,8.22,5.1,14.9,11.38,14.9s11.39-6.68,11.39-14.9a17.94,17.94,0,0,0-2.38-9.11,18.61,18.61,0,0,0,0-18.21,18.61,18.61,0,0,0,0-18.21Z"
          transform="translate(-52 -162.63)"
          fill="#3f3d56"
        />
        <ellipse cx="479.42" cy="271.07" rx="11.38" ry="14.9" fill="#3f3d56" />
        <ellipse cx="479.42" cy="252.86" rx="11.38" ry="14.9" fill="#3f3d56" />
        <path
          d="M488.82,290.86a53.08,53.08,0,0,1-4.24-6.24l29.9-4.91-32.34.24a54.62,54.62,0,0,1-1-43.2l43.39,22.51-40-29.42a54.53,54.53,0,1,1,90,61,54.54,54.54,0,0,1,6.22,9.94L541.92,321l41.39-13.89a54.53,54.53,0,0,1-8.79,51.2,54.52,54.52,0,1,1-85.7,0,54.52,54.52,0,0,1,0-67.42Z"
          transform="translate(-52 -162.63)"
          fill="#3355ff"
        />
        <path
          d="M586.19,324.57a54.27,54.27,0,0,1-11.67,33.71,54.52,54.52,0,1,1-85.7,0C481.51,349,586.19,318.45,586.19,324.57Z"
          transform="translate(-52 -162.63)"
          opacity="0.1"
        />
      </g>
      <g opacity="0.1">
        <ellipse cx="612.28" cy="330.26" rx="8.51" ry="11.13" fill="#3f3d56" />
        <path
          d="M671,445.26a13.43,13.43,0,0,0,1.77-6.8c0-6.15-3.81-11.14-8.5-11.14s-8.51,5-8.51,11.14a13.33,13.33,0,0,0,1.78,6.8,13.9,13.9,0,0,0,0,13.61,13.9,13.9,0,0,0,0,13.61,13.33,13.33,0,0,0-1.78,6.8c0,6.15,3.81,11.14,8.51,11.14s8.5-5,8.5-11.14a13.43,13.43,0,0,0-1.77-6.8,14,14,0,0,0,0-13.61,14,14,0,0,0,0-13.61Z"
          transform="translate(-52 -162.63)"
          fill="#3f3d56"
        />
        <ellipse cx="612.28" cy="262.22" rx="8.51" ry="11.13" fill="#3f3d56" />
        <ellipse cx="612.28" cy="248.61" rx="8.51" ry="11.13" fill="#3f3d56" />
        <path
          d="M632.44,318.11a39,39,0,0,1-3.17-4.66l22.35-3.67-24.17.18a40.84,40.84,0,0,1-.78-32.29L659.1,294.5l-29.91-22a40.75,40.75,0,1,1,67.29,45.6,41.2,41.2,0,0,1,4.65,7.43l-29,15.07,30.93-10.38a40.76,40.76,0,0,1-6.57,38.26,40.74,40.74,0,1,1-64,0,40.74,40.74,0,0,1,0-50.38Z"
          transform="translate(-52 -162.63)"
          fill="#3355ff"
        />
        <path
          d="M705.2,343.3a40.57,40.57,0,0,1-8.72,25.19,40.74,40.74,0,1,1-64,0C627,361.56,705.2,338.73,705.2,343.3Z"
          transform="translate(-52 -162.63)"
          opacity="0.1"
        />
      </g>
      <g opacity="0.1">
        <ellipse cx="1038.58" cy="322.12" rx="11.38" ry="14.9" fill="#3f3d56" />
        <path
          d="M1081.57,421a18,18,0,0,1-2.38-9.11c0-8.23,5.1-14.9,11.39-14.9s11.38,6.67,11.38,14.9a18,18,0,0,1-2.38,9.11,18.61,18.61,0,0,1,0,18.21,18.61,18.61,0,0,1,0,18.21,17.94,17.94,0,0,1,2.38,9.11c0,8.22-5.1,14.9-11.38,14.9s-11.39-6.68-11.39-14.9a17.94,17.94,0,0,1,2.38-9.11,18.61,18.61,0,0,1,0-18.21,18.61,18.61,0,0,1,0-18.21Z"
          transform="translate(-52 -162.63)"
          fill="#3f3d56"
        />
        <ellipse cx="1038.58" cy="231.07" rx="11.38" ry="14.9" fill="#3f3d56" />
        <ellipse cx="1038.58" cy="212.86" rx="11.38" ry="14.9" fill="#3f3d56" />
        <path
          d="M1133.18,250.86a53.08,53.08,0,0,0,4.24-6.24l-29.9-4.91,32.34.24a54.62,54.62,0,0,0,1-43.2l-43.39,22.51,40-29.42a54.53,54.53,0,1,0-90,61,54.54,54.54,0,0,0-6.22,9.94L1080.08,281l-41.39-13.89a54.53,54.53,0,0,0,8.79,51.2,54.52,54.52,0,1,0,85.7,0,54.52,54.52,0,0,0,0-67.42Z"
          transform="translate(-52 -162.63)"
          fill="#3355ff"
        />
        <path
          d="M1035.81,284.57a54.27,54.27,0,0,0,11.67,33.71,54.52,54.52,0,1,0,85.7,0C1140.49,309,1035.81,278.45,1035.81,284.57Z"
          transform="translate(-52 -162.63)"
          opacity="0.1"
        />
      </g>
      <g opacity="0.1">
        <ellipse cx="928.72" cy="324.26" rx="8.51" ry="11.13" fill="#3f3d56" />
        <path
          d="M974,439.26a13.43,13.43,0,0,1-1.77-6.8c0-6.15,3.81-11.14,8.5-11.14s8.51,5,8.51,11.14a13.33,13.33,0,0,1-1.78,6.8,13.9,13.9,0,0,1,0,13.61,13.9,13.9,0,0,1,0,13.61,13.33,13.33,0,0,1,1.78,6.8c0,6.15-3.81,11.14-8.51,11.14s-8.5-5-8.5-11.14a13.43,13.43,0,0,1,1.77-6.8,14,14,0,0,1,0-13.61,14,14,0,0,1,0-13.61Z"
          transform="translate(-52 -162.63)"
          fill="#3f3d56"
        />
        <ellipse cx="928.72" cy="256.22" rx="8.51" ry="11.13" fill="#3f3d56" />
        <ellipse cx="928.72" cy="242.61" rx="8.51" ry="11.13" fill="#3f3d56" />
        <path
          d="M1012.56,312.11a39,39,0,0,0,3.17-4.66l-22.35-3.67,24.17.18a40.84,40.84,0,0,0,.78-32.29L985.9,288.5l29.91-22a40.75,40.75,0,1,0-67.29,45.6,41.2,41.2,0,0,0-4.65,7.43l29,15.07L942,324.23a40.76,40.76,0,0,0,6.57,38.26,40.74,40.74,0,1,0,64,0,40.74,40.74,0,0,0,0-50.38Z"
          transform="translate(-52 -162.63)"
          fill="#3355ff"
        />
        <path
          d="M939.8,337.3a40.57,40.57,0,0,0,8.72,25.19,40.74,40.74,0,1,0,64,0C1018,355.56,939.8,332.73,939.8,337.3Z"
          transform="translate(-52 -162.63)"
          opacity="0.1"
        />
      </g>
      <g opacity="0.1">
        <ellipse cx="61.59" cy="322.12" rx="11.38" ry="14.9" fill="#3f3d56" />
        <path
          d="M122.59,421a18,18,0,0,0,2.38-9.11c0-8.23-5.1-14.9-11.38-14.9s-11.38,6.67-11.38,14.9a18,18,0,0,0,2.37,9.11,18.67,18.67,0,0,0,0,18.21,18.67,18.67,0,0,0,0,18.21,17.93,17.93,0,0,0-2.37,9.11c0,8.22,5.09,14.9,11.38,14.9S125,474.77,125,466.55a17.94,17.94,0,0,0-2.38-9.11,18.61,18.61,0,0,0,0-18.21,18.61,18.61,0,0,0,0-18.21Z"
          transform="translate(-52 -162.63)"
          fill="#3f3d56"
        />
        <ellipse cx="61.59" cy="231.07" rx="11.38" ry="14.9" fill="#3f3d56" />
        <ellipse cx="61.59" cy="212.86" rx="11.38" ry="14.9" fill="#3f3d56" />
        <path
          d="M71,250.86a54.33,54.33,0,0,1-4.24-6.24l29.91-4.91L64.3,240a54.62,54.62,0,0,1-1-43.2l43.4,22.51-40-29.42a54.52,54.52,0,1,1,90,61,54.54,54.54,0,0,1,6.22,9.94L124.08,281l41.4-13.89a54.59,54.59,0,0,1-8.8,51.2,54.52,54.52,0,1,1-85.7,0,54.52,54.52,0,0,1,0-67.42Z"
          transform="translate(-52 -162.63)"
          fill="#3355ff"
        />
        <path
          d="M168.35,284.57a54.27,54.27,0,0,1-11.67,33.71,54.52,54.52,0,1,1-85.7,0C63.67,309,168.35,278.45,168.35,284.57Z"
          transform="translate(-52 -162.63)"
          opacity="0.1"
        />
      </g>
      <g opacity="0.1">
        <ellipse cx="171.44" cy="324.26" rx="8.51" ry="11.13" fill="#3f3d56" />
        <path
          d="M230.17,439.26a13.43,13.43,0,0,0,1.77-6.8c0-6.15-3.8-11.14-8.5-11.14s-8.51,5-8.51,11.14a13.43,13.43,0,0,0,1.78,6.8,13.9,13.9,0,0,0,0,13.61,13.9,13.9,0,0,0,0,13.61,13.43,13.43,0,0,0-1.78,6.8c0,6.15,3.81,11.14,8.51,11.14s8.5-5,8.5-11.14a13.43,13.43,0,0,0-1.77-6.8,14,14,0,0,0,0-13.61,14,14,0,0,0,0-13.61Z"
          transform="translate(-52 -162.63)"
          fill="#3f3d56"
        />
        <ellipse cx="171.44" cy="256.22" rx="8.51" ry="11.13" fill="#3f3d56" />
        <ellipse cx="171.44" cy="242.61" rx="8.51" ry="11.13" fill="#3f3d56" />
        <path
          d="M191.6,312.11a40.21,40.21,0,0,1-3.17-4.66l22.35-3.67-24.17.18a40.84,40.84,0,0,1-.78-32.29l32.43,16.83-29.91-22a40.75,40.75,0,1,1,67.29,45.6,40.12,40.12,0,0,1,4.65,7.43l-29,15.07,30.93-10.38a40.76,40.76,0,0,1-6.57,38.26,40.74,40.74,0,1,1-64,0,40.74,40.74,0,0,1,0-50.38Z"
          transform="translate(-52 -162.63)"
          fill="#3355ff"
        />
        <path
          d="M264.36,337.3a40.57,40.57,0,0,1-8.72,25.19,40.74,40.74,0,1,1-64,0C186.14,355.56,264.36,332.73,264.36,337.3Z"
          transform="translate(-52 -162.63)"
          opacity="0.1"
        />
      </g>
      <ellipse cx="548" cy="493.13" rx="548" ry="8.86" fill="#3355ff" opacity="0.1" />
      <ellipse cx="548" cy="565.88" rx="548" ry="8.86" fill="#3355ff" opacity="0.1" />
      <ellipse cx="548" cy="341.3" rx="548" ry="8.86" fill="#3355ff" opacity="0.1" />
      <ellipse cx="548" cy="417.21" rx="548" ry="8.86" fill="#3355ff" opacity="0.1" />
      <path
        d="M860.79,273a18.3,18.3,0,0,0-10.6,1.16,15.65,15.65,0,0,1-12.74,0,17.88,17.88,0,0,0-15,.29,9.24,9.24,0,0,1-4.31,1.08c-6.08,0-11.13-6.12-12.18-14.19a11.88,11.88,0,0,0,3-3.27c3.56-5.74,9.07-9.43,15.27-9.43s11.64,3.64,15.2,9.32a11.68,11.68,0,0,0,10.09,5.54h.16C854.57,263.45,858.76,267.33,860.79,273Z"
        transform="translate(-52 -162.63)"
        fill="#3355ff"
        opacity="0.1"
      />
      <path
        d="M879.3,247.65l-9.82,6.22,6-10.84a9.7,9.7,0,0,0-5.94-2.11h-.16a11.35,11.35,0,0,1-2-.15L864,242.88l1.43-2.6a11.79,11.79,0,0,1-5.83-4.42l-6,3.78,3.76-6.84c-3.48-4.18-8.18-6.74-13.34-6.74-6.2,0-11.71,3.68-15.28,9.42a11.41,11.41,0,0,1-10.09,5.44h-.33c-6.84,0-12.38,7.75-12.38,17.31s5.54,17.32,12.38,17.32a9.39,9.39,0,0,0,4.31-1.08,17.86,17.86,0,0,1,15-.3,15.55,15.55,0,0,0,12.74,0,17.92,17.92,0,0,1,14.86.29,9.3,9.3,0,0,0,4.26,1.06c6.84,0,12.38-7.76,12.38-17.32A21.93,21.93,0,0,0,879.3,247.65Z"
        transform="translate(-52 -162.63)"
        fill="#3355ff"
        opacity="0.1"
      />
      <path
        d="M443.26,267.59a12.84,12.84,0,0,0-7.43.81,10.92,10.92,0,0,1-8.91,0,12.48,12.48,0,0,0-10.49.21,6.62,6.62,0,0,1-3,.75c-4.25,0-7.79-4.28-8.53-9.93a8.32,8.32,0,0,0,2.13-2.29c2.49-4,6.35-6.6,10.69-6.6s8.15,2.55,10.64,6.52a8.19,8.19,0,0,0,7.07,3.88h.11C438.9,260.92,441.83,263.64,443.26,267.59Z"
        transform="translate(-52 -162.63)"
        fill="#3355ff"
        opacity="0.1"
      />
      <path
        d="M456.21,249.86l-6.87,4.36,4.17-7.59a6.75,6.75,0,0,0-4.15-1.48h-.12a7.49,7.49,0,0,1-1.42-.11l-2.33,1.48,1-1.82a8.3,8.3,0,0,1-4.08-3.09l-4.17,2.64,2.64-4.78a12.21,12.21,0,0,0-9.34-4.73c-4.34,0-8.2,2.58-10.69,6.6a8,8,0,0,1-7.07,3.81h-.23c-4.79,0-8.67,5.42-8.67,12.12s3.88,12.12,8.67,12.12a6.5,6.5,0,0,0,3-.76,12.5,12.5,0,0,1,10.48-.2,11.1,11.1,0,0,0,4.49,1,11,11,0,0,0,4.43-.94,12.54,12.54,0,0,1,10.4.2,6.48,6.48,0,0,0,3,.74c4.78,0,8.66-5.43,8.66-12.12A15.33,15.33,0,0,0,456.21,249.86Z"
        transform="translate(-52 -162.63)"
        fill="#3355ff"
        opacity="0.1"
      />
      <path
        d="M321.59,346a12.82,12.82,0,0,1,7.42.81,10.94,10.94,0,0,0,8.92,0,12.52,12.52,0,0,1,10.49.2,6.47,6.47,0,0,0,3,.76c4.25,0,7.79-4.29,8.52-9.94a8.15,8.15,0,0,1-2.12-2.29c-2.5-4-6.36-6.59-10.69-6.59s-8.15,2.54-10.65,6.52a8.19,8.19,0,0,1-7.06,3.88h-.11C325.94,339.37,323,342.08,321.59,346Z"
        transform="translate(-52 -162.63)"
        fill="#3355ff"
        opacity="0.1"
      />
      <path
        d="M308.63,328.3l6.88,4.36-4.18-7.58a6.79,6.79,0,0,1,4.16-1.49h.11a8.52,8.52,0,0,0,1.43-.1l2.33,1.47-1-1.81a8.29,8.29,0,0,0,4.07-3.09l4.17,2.64L324,317.91a12.2,12.2,0,0,1,9.34-4.72c4.33,0,8.2,2.58,10.69,6.6a8,8,0,0,0,7.06,3.81h.24c4.78,0,8.66,5.43,8.66,12.12s-3.88,12.12-8.66,12.12a6.49,6.49,0,0,1-3-.75,12.48,12.48,0,0,0-10.49-.21,10.86,10.86,0,0,1-4.48,1,11,11,0,0,1-4.44-.94,12.52,12.52,0,0,0-10.39.2,6.48,6.48,0,0,1-3,.74c-4.79,0-8.67-5.42-8.67-12.12A15.44,15.44,0,0,1,308.63,328.3Z"
        transform="translate(-52 -162.63)"
        fill="#3355ff"
        opacity="0.1"
      />
      <path
        d="M716.31,652.89c2.61-4.84-.35-10.76-3.75-15.07s-7.56-8.8-7.47-14.29c.13-7.89,8.51-12.56,15.2-16.74a74.3,74.3,0,0,0,13.65-11,20.13,20.13,0,0,0,4.19-5.62c1.39-3.08,1.35-6.6,1.26-10q-.43-16.89-1.67-33.76"
        transform="translate(-52 -162.63)"
        fill="none"
        stroke="#3f3d56"
        stroke-miterlimit="10"
        stroke-width="4"
      />
      <path
        d="M750.45,545.85a12.31,12.31,0,0,0-6.15-10.09l-2.76,5.45.09-6.6a12.31,12.31,0,1,0,8.82,11.24Z"
        transform="translate(-52 -162.63)"
        fill="#3355ff"
      />
      <path
        d="M728.49,629.17a12.31,12.31,0,0,1-23.24-5,12,12,0,0,1,.8-5,12.32,12.32,0,0,1,23,.13l-7.69,6.26,8.46-2A12.24,12.24,0,0,1,728.49,629.17Z"
        transform="translate(-52 -162.63)"
        fill="#3355ff"
      />
      <path
        d="M722.41,605.27a12.31,12.31,0,0,1-3.9-24.15l-.07,5.07,2.79-5.52h0a12.31,12.31,0,1,1,1.15,24.6Z"
        transform="translate(-52 -162.63)"
        fill="#3355ff"
      />
      <path
        d="M752.3,585.38a12.31,12.31,0,1,1,5.44-23l-2.17,6L760,564a12.31,12.31,0,0,1-7.74,21.37Z"
        transform="translate(-52 -162.63)"
        fill="#3355ff"
      />
      <path
        d="M748.79,549.13c-2.84.31-5.6,1.19-8.46,1.37s-6-.51-7.78-2.72a39.48,39.48,0,0,1-2.28-4,8.76,8.76,0,0,0-3.1-2.92,12.31,12.31,0,1,0,23,8.18C749.72,549.05,749.25,549.08,748.79,549.13Z"
        transform="translate(-52 -162.63)"
        opacity="0.1"
      />
      <path
        d="M752.3,585.38a12.31,12.31,0,0,1-11.71-17.56,9.11,9.11,0,0,1,2.47,2.48,41.72,41.72,0,0,0,2.44,4.07c1.92,2.25,5.2,3,8.17,2.85s5.84-1,8.8-1.25c.41,0,.82-.06,1.24-.07A12.31,12.31,0,0,1,752.3,585.38Z"
        transform="translate(-52 -162.63)"
        opacity="0.1"
      />
      <path
        d="M722.41,605.27a12.31,12.31,0,0,1-11.81-17.33,10,10,0,0,1,2.61,2.5,41.23,41.23,0,0,0,2.67,4.15c2.07,2.31,5.57,3.13,8.71,3s6-.81,9-1A12.33,12.33,0,0,1,722.41,605.27Z"
        transform="translate(-52 -162.63)"
        opacity="0.1"
      />
      <path
        d="M728.49,629.17a12.31,12.31,0,0,1-23.24-5,12,12,0,0,1,.8-5,12.29,12.29,0,0,1,2.7,2.41c1.17,1.42,1.94,3,3.3,4.37,2.51,2.47,6.58,3.49,10.19,3.58A51.7,51.7,0,0,0,728.49,629.17Z"
        transform="translate(-52 -162.63)"
        opacity="0.1"
      />
      <path
        d="M106.31,580.89c2.61-4.84-.35-10.76-3.75-15.07S95,557,95.09,551.53c.13-7.89,8.51-12.56,15.2-16.74a74.3,74.3,0,0,0,13.65-11,20.13,20.13,0,0,0,4.19-5.62c1.39-3.08,1.35-6.6,1.26-10q-.44-16.89-1.67-33.76"
        transform="translate(-52 -162.63)"
        fill="none"
        stroke="#3f3d56"
        stroke-miterlimit="10"
        stroke-width="4"
      />
      <path
        d="M140.45,473.85a12.31,12.31,0,0,0-6.15-10.09l-2.76,5.45.09-6.6a12.31,12.31,0,1,0,8.82,11.24Z"
        transform="translate(-52 -162.63)"
        fill="#3355ff"
      />
      <path
        d="M118.49,557.17a12.31,12.31,0,0,1-23.24-5,12,12,0,0,1,.8-5,12.32,12.32,0,0,1,23,.13l-7.69,6.26,8.46-2A12.24,12.24,0,0,1,118.49,557.17Z"
        transform="translate(-52 -162.63)"
        fill="#3355ff"
      />
      <path
        d="M112.41,533.27a12.31,12.31,0,0,1-3.9-24.15l-.07,5.07,2.79-5.52h0a12.31,12.31,0,1,1,1.15,24.6Z"
        transform="translate(-52 -162.63)"
        fill="#3355ff"
      />
      <path
        d="M142.3,513.38a12.31,12.31,0,1,1,5.44-23l-2.17,6L150,492a12.31,12.31,0,0,1-7.74,21.37Z"
        transform="translate(-52 -162.63)"
        fill="#3355ff"
      />
      <path
        d="M138.79,477.13c-2.84.31-5.6,1.19-8.46,1.37s-6-.51-7.78-2.72a39.48,39.48,0,0,1-2.28-4,8.76,8.76,0,0,0-3.1-2.92,12.31,12.31,0,1,0,23,8.18C139.72,477.05,139.25,477.08,138.79,477.13Z"
        transform="translate(-52 -162.63)"
        opacity="0.1"
      />
      <path
        d="M142.3,513.38a12.31,12.31,0,0,1-11.71-17.56,9.11,9.11,0,0,1,2.47,2.48,41.72,41.72,0,0,0,2.44,4.07c1.92,2.25,5.2,3,8.17,2.85s5.84-1,8.8-1.25c.41,0,.82-.06,1.24-.07A12.31,12.31,0,0,1,142.3,513.38Z"
        transform="translate(-52 -162.63)"
        opacity="0.1"
      />
      <path
        d="M112.41,533.27a12.31,12.31,0,0,1-11.81-17.33,10,10,0,0,1,2.61,2.5,41.23,41.23,0,0,0,2.67,4.15c2.07,2.31,5.57,3.13,8.71,3s6-.81,9-1A12.33,12.33,0,0,1,112.41,533.27Z"
        transform="translate(-52 -162.63)"
        opacity="0.1"
      />
      <path
        d="M118.49,557.17a12.31,12.31,0,0,1-23.24-5,12,12,0,0,1,.8-5,12.29,12.29,0,0,1,2.7,2.41c1.17,1.42,1.94,3,3.3,4.37,2.51,2.47,6.58,3.49,10.19,3.58A51.7,51.7,0,0,0,118.49,557.17Z"
        transform="translate(-52 -162.63)"
        opacity="0.1"
      />
      <path
        d="M512.52,498.52c-2.61-4.83.35-10.75,3.76-15.06s7.55-8.8,7.46-14.29c-.12-7.9-8.5-12.56-15.2-16.74a74,74,0,0,1-13.64-11,19.78,19.78,0,0,1-4.2-5.61c-1.38-3.09-1.34-6.6-1.26-10q.45-16.89,1.67-33.76"
        transform="translate(-52 -162.63)"
        fill="none"
        stroke="#3f3d56"
        stroke-miterlimit="10"
        stroke-width="4"
      />
      <path
        d="M478.39,391.49a12.3,12.3,0,0,1,6.14-10.09l2.76,5.45-.08-6.6a12.62,12.62,0,0,1,4.05-.49,12.31,12.31,0,1,1-12.87,11.73Z"
        transform="translate(-52 -162.63)"
        fill="#3355ff"
      />
      <path
        d="M500.34,474.81a12.31,12.31,0,1,0-.59-9.91l7.69,6.26-8.46-2A12.24,12.24,0,0,0,500.34,474.81Z"
        transform="translate(-52 -162.63)"
        fill="#3355ff"
      />
      <path
        d="M506.42,450.91a12.31,12.31,0,0,0,3.91-24.15l.06,5.07-2.79-5.52h0A12.31,12.31,0,0,0,494.7,438a12.16,12.16,0,0,0,.53,4.2A12.3,12.3,0,0,0,506.42,450.91Z"
        transform="translate(-52 -162.63)"
        fill="#3355ff"
      />
      <path
        d="M476.54,431a12.31,12.31,0,1,0-5.45-23l2.18,6-4.48-4.29a12.21,12.21,0,0,0-4,8.5,11.91,11.91,0,0,0,.31,3.39A12.3,12.3,0,0,0,476.54,431Z"
        transform="translate(-52 -162.63)"
        fill="#3355ff"
      />
      <path
        d="M480.05,394.77c2.84.31,5.6,1.19,8.45,1.37s6-.51,7.79-2.72a39.4,39.4,0,0,0,2.27-4,8.79,8.79,0,0,1,3.11-2.92,12.31,12.31,0,1,1-23,8.17C479.12,394.68,479.58,394.72,480.05,394.77Z"
        transform="translate(-52 -162.63)"
        opacity="0.1"
      />
      <path
        d="M476.54,431a12.32,12.32,0,0,0,11.71-17.56,9.15,9.15,0,0,0-2.48,2.48,41.72,41.72,0,0,1-2.44,4.07c-1.91,2.25-5.19,3-8.16,2.85s-5.84-1-8.8-1.25c-.41,0-.83-.06-1.24-.07A12.3,12.3,0,0,0,476.54,431Z"
        transform="translate(-52 -162.63)"
        opacity="0.1"
      />
      <path
        d="M506.42,450.91a12.3,12.3,0,0,0,11.81-17.33,9.83,9.83,0,0,0-2.6,2.5,41.23,41.23,0,0,1-2.67,4.15c-2.08,2.31-5.57,3.13-8.72,3s-6-.81-9-1A12.3,12.3,0,0,0,506.42,450.91Z"
        transform="translate(-52 -162.63)"
        opacity="0.1"
      />
      <path
        d="M500.34,474.81a12.31,12.31,0,0,0,22.45-10,11.82,11.82,0,0,0-2.7,2.41c-1.17,1.42-2,3-3.3,4.37-2.52,2.47-6.58,3.49-10.2,3.58A53.94,53.94,0,0,1,500.34,474.81Z"
        transform="translate(-52 -162.63)"
        opacity="0.1"
      />
      <circle cx="779.73" cy="238.18" r="99.96" fill="#3f3d56" />
      <path
        d="M874.64,426.59c-3.48-3.48-11.85-8.73-16-10.69-4.79-2.3-6.55-2.26-9.94.19-2.82,2-4.65,3.93-7.89,3.22s-9.66-5.55-15.87-11.74S813.91,395,813.22,391.71s1.21-5.08,3.23-7.9c2.44-3.39,2.51-5.15.19-9.94-2-4.15-7.19-12.5-10.7-16s-4.27-2.73-6.19-2a35.8,35.8,0,0,0-5.67,3c-3.48,2.33-5.43,4.27-6.8,7.19s-2.92,8.34,5.05,22.53a125.69,125.69,0,0,0,22.1,29.47l0,0,0,0A125.88,125.88,0,0,0,844,440.2c14.18,8,19.61,6.41,22.53,5.05s4.86-3.29,7.18-6.8a35.33,35.33,0,0,0,3-5.67C877.37,430.86,878.15,430.08,874.64,426.59Z"
        transform="translate(-52 -162.63)"
        fill="#3355ff"
      />
      <path
        d="M831.73,300.86a100,100,0,1,0,99.95,99.95A100,100,0,0,0,831.73,300.86Zm0,186.62a86.67,86.67,0,1,1,86.67-86.67A86.67,86.67,0,0,1,831.73,487.48Z"
        transform="translate(-52 -162.63)"
        opacity="0.1"
      />
      <circle cx="550.08" cy="390.01" r="99.96" fill="#3f3d56" />
      <path
        d="M658.93,522.44,629,552.89a.54.54,0,0,0,0,.78L650,576a3.62,3.62,0,0,1-2.55,6.17,3.64,3.64,0,0,1-2.56-1.06L624,558.86a.57.57,0,0,0-.8,0L618.11,564a22.37,22.37,0,0,1-16,6.73,22.86,22.86,0,0,1-16.28-6.92l-4.89-5a.57.57,0,0,0-.8,0l-20.84,22.2a3.61,3.61,0,0,1-5.11,0,3.6,3.6,0,0,1,0-5.11l20.92-22.28a.6.6,0,0,0,0-.78l-29.93-30.45a.55.55,0,0,0-.94.39v60.93a8.92,8.92,0,0,0,8.89,8.89H651a8.92,8.92,0,0,0,8.89-8.89V522.83A.55.55,0,0,0,658.93,522.44Z"
        transform="translate(-52 -162.63)"
        fill="#3355ff"
      />
      <path
        d="M602.08,563.5A15.14,15.14,0,0,0,613,559l43.59-44.37a8.7,8.7,0,0,0-5.5-2H553.15a8.64,8.64,0,0,0-5.5,2L591.25,559A15.08,15.08,0,0,0,602.08,563.5Z"
        transform="translate(-52 -162.63)"
        fill="#3355ff"
      />
      <path
        d="M600.82,452.69a100,100,0,1,0,99.95,99.95A100,100,0,0,0,600.82,452.69Zm0,186.62a86.67,86.67,0,1,1,86.67-86.67A86.67,86.67,0,0,1,600.82,639.31Z"
        transform="translate(-52 -162.63)"
        opacity="0.1"
      />
      <circle cx="312.85" cy="315.36" r="99.96" fill="#3f3d56" />
      <path
        d="M364.85,430.16,325,522.1l3.72,3.72,36.14-15.94L401,525.82l3.72-3.72Z"
        transform="translate(-52 -162.63)"
        fill="#3355ff"
      />
      <path
        d="M364.85,378A100,100,0,1,0,464.8,478,100,100,0,0,0,364.85,378Zm0,186.62A86.67,86.67,0,1,1,451.52,478,86.67,86.67,0,0,1,364.85,564.66Z"
        transform="translate(-52 -162.63)"
        opacity="0.1"
      />
      <path
        d="M840.93,603.88q-1.36-3.32-2.79-6.62a19.65,19.65,0,0,0-3.41-5.89,6.24,6.24,0,0,0-2-1.5,8.53,8.53,0,0,0-2.61-.52,20.83,20.83,0,0,0-4.1-.11c-.53-.16-1.13-.37-1.72-.61a14.28,14.28,0,0,0,10.64-13.25c0-.2,0-.41,0-.61a14.25,14.25,0,0,0-14.19-14.31,14,14,0,0,0-7.45,2.13,13.37,13.37,0,0,0-15,7.23,16.53,16.53,0,0,0-5.1,12.3c0,.21,0,.43,0,.63.26,7.77,5.28,14,11.62,14.63a6.66,6.66,0,0,0-1.84,1.23c-1.94,1.87-2.26,4.84-2.47,7.54l-.15,2L797,609.35a.62.62,0,0,0-.15,1.09l3.21,2.29c0,.19,0,.38,0,.57s0,.43.06.65a4.59,4.59,0,0,0-1.24,1.77,8.18,8.18,0,0,0-.29,3.24l.12,2.79a21.91,21.91,0,0,0,.85,6.21c.42,1.24,2.24,4.23,3.55,4.25-1.21,5.5-1.53,17.1-1.53,17.1-.15.15.27.29,1,.41.72,5.52,3.07,21,7.24,27.81a58.64,58.64,0,0,1,1.57,6.76s1.19,14.71,2.76,19.08c1.34,3.72,2.4,12.9,2.69,15.56a1.53,1.53,0,0,0-1.11,1.14c-.79,2.38-5.91,6-5.91,6a24.76,24.76,0,0,0-4.42,2.83c-1.61,1.45-1.55,2.76,5.6,1.94,13.8-1.59,16.16-6,16.16-6s-.22-.74-.55-1.7a18.46,18.46,0,0,0-1.81-4.27c-.2-.19-.4.13-.64.63a85.63,85.63,0,0,1-.94-19.31s.39-6.76-1.58-11.53a21.83,21.83,0,0,1,0-7.55c.79-3.18-3.15-18.69-3.15-18.69L816.23,651a3.28,3.28,0,0,1,.63,1.33l.06.23.06.33a.62.62,0,0,0,.16.31c1.54,6.4,5.76,24.13,5.76,26.73,0,3.18,3.94,11.13,3.94,11.13s1.57,13.12,4.33,18.28c2.1,3.93,2.15,9.69,2.05,12.23h0s-.47,3.27-1.26,4.06a9.66,9.66,0,0,0-1.49,2.59l-.09.19s-1.18,2.39-.39,2.79a19.37,19.37,0,0,0,9.46,1.19s1.58-2,1.58-2.78a12.52,12.52,0,0,0-.18-1.42c-.29-1.88-.83-4.84-.84-4.87.33-1.28-1-4.84-1-4.84l-.4-11.13a51.38,51.38,0,0,0-2.76-22.27s-2-7.15-1.57-9.14-.79-23.06-.79-23.06l-.12-.3a22.78,22.78,0,0,1,.12-4.47c.39-4.77-1.18-14.71-1.58-15.1a13.1,13.1,0,0,1-.56-3.29c.09-.83.36-3.26.73-6.28a112.91,112.91,0,0,0,11.62-1,1.45,1.45,0,0,0,1-.4,1.4,1.4,0,0,0,.23-.81C845.39,615.24,843.2,609.42,840.93,603.88ZM833,616.49c.41-2.85.85-5.61,1.29-7.66l.06.18a55.65,55.65,0,0,1,1.9,6.3A21.43,21.43,0,0,1,833,616.49Z"
        transform="translate(-52 -162.63)"
        fill="url(#eb6c86d6-45fa-49e0-9a60-1b0612516196)"
      />
      <path
        d="M802.37,648.68s2.36,21.23,7.47,29.48a57.21,57.21,0,0,1,1.57,6.68s1.18,14.54,2.75,18.86,2.75,16.12,2.75,16.12,5.5,6.28,7.47,1.18a82.82,82.82,0,0,1-1.18-20.44s.39-6.68-1.57-11.4a21.32,21.32,0,0,1,0-7.46c.78-3.15-3.15-18.47-3.15-18.47l-3.14-15.33Z"
        transform="translate(-52 -162.63)"
        fill="#be6f72"
      />
      <path
        d="M827.13,724.93s-2.36,4.32-16.11,5.89c-7.14.81-7.19-.48-5.58-1.92a24.9,24.9,0,0,1,4.4-2.8s5.11-3.53,5.89-5.89,3.54-.39,3.54-.39c3.93,5.89,4.72-1.58,5.5-.79a17.73,17.73,0,0,1,1.81,4.21C826.91,724.19,827.13,724.93,827.13,724.93Z"
        transform="translate(-52 -162.63)"
        fill="#ff6f61"
      />
      <path
        d="M827.13,724.93s-2.36,4.32-16.11,5.89c-7.14.81-7.19-.48-5.58-1.92,1.12.71,3.38,1,7.93-.83,6.55-2.68,11.3-4.23,13.21-4.83C826.91,724.19,827.13,724.93,827.13,724.93Z"
        transform="translate(-52 -162.63)"
        opacity="0.1"
      />
      <path
        d="M823.2,700.56s.39-6.68-1.57-11.4a21.32,21.32,0,0,1,0-7.46c.78-3.15-3.15-18.47-3.15-18.47l-3.14-15.33-2.72.16,3.11,15.17s3.93,15.32,3.15,18.47a21.32,21.32,0,0,0,0,7.46c2,4.72,1.57,11.4,1.57,11.4A82.82,82.82,0,0,0,821.63,721a3.44,3.44,0,0,1-1.14,1.62c1.46.66,3,.63,3.89-1.62A82.82,82.82,0,0,1,823.2,700.56Z"
        transform="translate(-52 -162.63)"
        opacity="0.1"
      />
      <path
        d="M820.64,562.42a14,14,0,0,0-7.42,2.11,13.35,13.35,0,0,0-15,7.15,16.28,16.28,0,0,0-5.09,12.16c0,8.36,5.63,15.13,12.57,15.13,5,0,9.38-3.56,11.39-8.71a13.8,13.8,0,0,0,3.54.46,14.15,14.15,0,0,0,0-28.3Z"
        transform="translate(-52 -162.63)"
        fill="#3f3d56"
      />
      <path
        d="M832.24,650.65l1.18,3.14s1.18,20.83.78,22.8,1.58,9,1.58,9a50.31,50.31,0,0,1,2.75,22l.39,11s1.57,4.32.79,5.11S833,723,833,723s.79-8.25-2-13.36-4.32-18.08-4.32-18.08-3.93-7.86-3.93-11-6.29-28.69-6.29-28.69Z"
        transform="translate(-52 -162.63)"
        fill="#be6f72"
      />
      <path
        d="M801.58,650.26s.4-14.15,2-18.47a29.33,29.33,0,0,0,1.75-6.27s23.79,4.3,25.76,2.73c0,0,.39,5.5.79,5.89s2,10.22,1.57,14.94,0,4.71,0,4.71-16.12,2.36-16.51,0-1.57-2.35-1.57-2.35S800.8,651,801.58,650.26Z"
        transform="translate(-52 -162.63)"
        fill="#3f3d56"
      />
      <g opacity="0.1">
        <path
          d="M814.55,650.26s-9.94-.27-12.94-.81c0,.51,0,.81,0,.81-.78.78,13.76,1.18,13.76,1.18a1,1,0,0,1,.54.22C815.38,650.26,814.55,650.26,814.55,650.26Z"
          transform="translate(-52 -162.63)"
        />
        <path
          d="M831.85,634.14c-.4-.39-.79-5.89-.79-5.89a1.69,1.69,0,0,1-.67.24c.14,1.66.41,4.21.67,4.47s2,10.22,1.57,14.94,0,4.71,0,4.71-12.75,1.87-15.84.62c0,.17.09.36.12.56.39,2.36,16.51,0,16.51,0s-.4,0,0-4.71S832.24,634.54,831.85,634.14Z"
          transform="translate(-52 -162.63)"
        />
        <path
          d="M814.55,650.26s-9.94-.27-12.94-.81c0,.51,0,.81,0,.81-.78.78,13.76,1.18,13.76,1.18a1,1,0,0,1,.54.22C815.38,650.26,814.55,650.26,814.55,650.26Z"
          transform="translate(-52 -162.63)"
          fill="url(#ad310e25-2b04-44c8-bb7b-982389166780)"
        />
        <path
          d="M831.85,634.14c-.4-.39-.79-5.89-.79-5.89a1.69,1.69,0,0,1-.67.24c.14,1.66.41,4.21.67,4.47s2,10.22,1.57,14.94,0,4.71,0,4.71-12.75,1.87-15.84.62c0,.17.09.36.12.56.39,2.36,16.51,0,16.51,0s-.4,0,0-4.71S832.24,634.54,831.85,634.14Z"
          transform="translate(-52 -162.63)"
          fill="url(#ad310e25-2b04-44c8-bb7b-982389166780)"
        />
      </g>
      <path
        d="M818.9,587.18a5.21,5.21,0,0,0,1.5,1.94,3.36,3.36,0,0,0,1.41.61c-.88.51-1.84.89-2.72,1.4a48.36,48.36,0,0,0-4,3,8.14,8.14,0,0,1-4.59,1.78,5.62,5.62,0,0,0,.64-5.59,5.22,5.22,0,0,1-.7-1.94c0-1.13,1-2,1.93-2.6.75-.51,1.52-1,2.3-1.49.61-.38,1.53-1.18,2.3-1.15s.86.71,1,1.41A11.09,11.09,0,0,0,818.9,587.18Z"
        transform="translate(-52 -162.63)"
        fill="#be6f72"
      />
      <path
        d="M818.9,587.18a5.21,5.21,0,0,0,1.5,1.94,3.36,3.36,0,0,0,1.41.61c-.88.51-1.84.89-2.72,1.4a48.36,48.36,0,0,0-4,3,8.14,8.14,0,0,1-4.59,1.78,5.62,5.62,0,0,0,.64-5.59,5.22,5.22,0,0,1-.7-1.94c0-1.13,1-2,1.93-2.6.75-.51,1.52-1,2.3-1.49.61-.38,1.53-1.18,2.3-1.15s.86.71,1,1.41A11.09,11.09,0,0,0,818.9,587.18Z"
        transform="translate(-52 -162.63)"
        opacity="0.1"
      />
      <circle cx="776.11" cy="438.7" r="9.04" fill="#be6f72" />
      <path
        d="M840.88,729.64c0,.79-1.57,2.75-1.57,2.75a19.46,19.46,0,0,1-9.43-1.18c-.79-.39.39-2.75.39-2.75l.09-.19a9.54,9.54,0,0,1,1.49-2.56c.78-.78,1.25-4,1.25-4,2.44-4,6.77,1.73,6.77,1.73s.55,3,.84,4.82C840.81,728.91,840.88,729.44,840.88,729.64Z"
        transform="translate(-52 -162.63)"
        fill="#ff6f61"
      />
      <path
        d="M840.88,729.64c0,.79-1.57,2.75-1.57,2.75a19.46,19.46,0,0,1-9.43-1.18c-.79-.39.39-2.75.39-2.75l.09-.19a19,19,0,0,0,8.56,1.76l1.79-1.79C840.81,728.91,840.88,729.44,840.88,729.64Z"
        transform="translate(-52 -162.63)"
        opacity="0.1"
      />
      <circle cx="758.03" cy="419.83" r="8.84" fill="#be6f72" />
      <path
        d="M802.9,600.14c-1.94,1.85-2.26,4.78-2.46,7.45l-.3,3.91a19.72,19.72,0,0,0-.07,3.17c0,.65.16,1.31.22,2s.08,1.56.09,2.35l0,5.78a6.82,6.82,0,0,0,.64,3.47,2.36,2.36,0,0,0,3,1.08,3.42,3.42,0,0,0,1.24-1.92,29.85,29.85,0,0,0,2-7.32c.08-.87.09-1.74.17-2.61s.23-1.78.36-2.66c.56-3.68.81-7.4,1.06-11.11.07-1.1,1.06-5.43-.38-5.91-.7-.23-2.15.49-2.82.73A7.94,7.94,0,0,0,802.9,600.14Z"
        transform="translate(-52 -162.63)"
        fill="#be6f72"
      />
      <path
        d="M802.9,600.14c-1.94,1.85-2.26,4.78-2.46,7.45l-.3,3.91a19.72,19.72,0,0,0-.07,3.17c0,.65.16,1.31.22,2s.08,1.56.09,2.35l0,5.78a6.82,6.82,0,0,0,.64,3.47,2.36,2.36,0,0,0,3,1.08,3.42,3.42,0,0,0,1.24-1.92,29.85,29.85,0,0,0,2-7.32c.08-.87.09-1.74.17-2.61s.23-1.78.36-2.66c.56-3.68.81-7.4,1.06-11.11.07-1.1,1.06-5.43-.38-5.91-.7-.23-2.15.49-2.82.73A7.94,7.94,0,0,0,802.9,600.14Z"
        transform="translate(-52 -162.63)"
        opacity="0.1"
      />
      <path
        d="M821.23,588.16s-6.68,5.11-10.61,6.29c0,0-2.33,2.66-2.73,3.3s-1.2,7.7-2,9.28-2.75,5.11,0,8.64c0,0,.78,3.54.39,4.72s-1.82,5.5-.52,5.7,5.24,2.94,8.77,2.16,16.71,3,16.71,3S833.42,611,835,607.42l-3.54-1.18s-9.82-5.89-3.93-14.93C827.52,591.31,822,590.13,821.23,588.16Z"
        transform="translate(-52 -162.63)"
        fill="#ff6f61"
      />
      <path
        d="M796.84,611.83l8.12,5.75a.6.6,0,0,0,.71,0l2.2-1.65a.62.62,0,0,0,0-.94l-6.25-5.55a.6.6,0,0,0-.61-.12L797,610.76A.61.61,0,0,0,796.84,611.83Z"
        transform="translate(-52 -162.63)"
        fill="#3f3d56"
      />
      <path
        d="M799.57,629.15a21.76,21.76,0,0,1-.85-6.13l-.12-2.77a8,8,0,0,1,.29-3.2,5.23,5.23,0,0,1,3.37-2.95,11.64,11.64,0,0,1,4.59-.33,1.18,1.18,0,0,1,.59.16,1.1,1.1,0,0,1,.32.54,3.62,3.62,0,0,1,.18,2.89,3,3,0,0,1-.92.95c-1.09.78-2.36,1.3-3.39,2.15a1.23,1.23,0,0,0-.46.58,1.35,1.35,0,0,0,0,.63,10.08,10.08,0,0,0,.52,1.61,1.59,1.59,0,0,0,.45.68c.19.16.44.22.64.37.43.35,1.33.81,1.28,1.36-.15,2-1.35,4.24-1.82,6.22C803.34,635.78,800.15,630.84,799.57,629.15Z"
        transform="translate(-52 -162.63)"
        fill="#be6f72"
      />
      <g opacity="0.1">
        <path
          d="M812.2,628.25l-.22,0a6.73,6.73,0,0,0,2.57,0l.25,0A9,9,0,0,0,812.2,628.25Z"
          transform="translate(-52 -162.63)"
        />
        <path
          d="M832.83,606.83c-1.41,3.17-3.49,20.34-3.86,23.75,1.38.36,2.29.62,2.29.62S833.42,611,835,607.42Z"
          transform="translate(-52 -162.63)"
        />
      </g>
      <path
        d="M828.42,601.61a3,3,0,0,0,1.29,1.95,17.31,17.31,0,0,1,2.29,2.32,16.43,16.43,0,0,1,2.27,4.55,55.75,55.75,0,0,1,1.89,6.22c-5,2.32-10.68,2.21-16,3.74a12.77,12.77,0,0,0-6,3.55,8.27,8.27,0,0,0-2.21,6.51.85.85,0,0,0,.12.39.84.84,0,0,0,.7.28,6,6,0,0,0,3.67-1.26,17.46,17.46,0,0,0,2.81-2.76,4.52,4.52,0,0,1,2-1.48c2.89-.88,6-.83,9-.88a113.42,113.42,0,0,0,13.41-1.06,1.08,1.08,0,0,0,1.2-1.2c.44-5.9-1.75-11.66-4-17.13q-1.35-3.29-2.78-6.55a19.4,19.4,0,0,0-3.4-5.82,6,6,0,0,0-2-1.48A8.46,8.46,0,0,0,830,591a19,19,0,0,0-4.39-.08,9.36,9.36,0,0,0-.42,2.27c.08,2.7,1.26,5.23,2.42,7.67C827.76,601.23,828.19,601.25,828.42,601.61Z"
        transform="translate(-52 -162.63)"
        fill="#be6f72"
      />
      <path
        d="M812.41,606.67a7.33,7.33,0,0,0-1,3.82,5.14,5.14,0,0,0,.25,1.56,5.06,5.06,0,0,0,3.19,3"
        transform="translate(-52 -162.63)"
        fill="none"
        stroke="#000"
        stroke-miterlimit="10"
        opacity="0.1"
      />
      <path
        d="M817.5,573.82a4.59,4.59,0,0,0-1.45.23c-1.31-2-4.39-3.38-8-3.38-4.78,0-8.65,2.47-8.65,5.51s3.87,5.5,8.65,5.5a12.17,12.17,0,0,0,5.19-1.1,4.71,4.71,0,1,0,4.24-6.76Z"
        transform="translate(-52 -162.63)"
        fill="#3f3d56"
      />
      <path
        d="M817.89,582.07a4.7,4.7,0,0,1-4.24-2.67,12.17,12.17,0,0,1-5.19,1.1c-4.77,0-8.64-2.46-8.64-5.5a3.31,3.31,0,0,1,0-.55,3.73,3.73,0,0,0-.44,1.73c0,3,3.87,5.5,8.65,5.5a12.17,12.17,0,0,0,5.19-1.1,4.71,4.71,0,0,0,8.87-1.17A4.69,4.69,0,0,1,817.89,582.07Z"
        transform="translate(-52 -162.63)"
        opacity="0.1"
      />
      <path
        d="M798.23,574a13.35,13.35,0,0,1,15-7.15,14.14,14.14,0,0,1,21.52,10.86c0-.39,0-.78,0-1.18a14.14,14.14,0,0,0-21.57-12,13.35,13.35,0,0,0-15,7.15,16.28,16.28,0,0,0-5.09,12.16c0,.4,0,.79,0,1.18A16,16,0,0,1,798.23,574Z"
        transform="translate(-52 -162.63)"
        opacity="0.1"
      />
      <path
        d="M888.39,577c2.61-4.83-.35-10.76-3.76-15.07s-7.55-8.79-7.46-14.29c.12-7.89,8.5-12.55,15.2-16.74a73.9,73.9,0,0,0,13.64-11,19.93,19.93,0,0,0,4.2-5.61c1.38-3.09,1.34-6.6,1.26-10q-.44-16.9-1.67-33.76"
        transform="translate(-52 -162.63)"
        fill="none"
        stroke="#3f3d56"
        stroke-miterlimit="10"
        stroke-width="4"
      />
      <path
        d="M922.52,469.93a12.29,12.29,0,0,0-6.14-10.08l-2.76,5.45.08-6.6a12.08,12.08,0,0,0-4.05-.49,12.31,12.31,0,1,0,12.87,11.72Z"
        transform="translate(-52 -162.63)"
        fill="#3355ff"
      />
      <path
        d="M900.57,553.26a12.31,12.31,0,1,1,.59-9.92l-7.69,6.26,8.46-2A12.24,12.24,0,0,1,900.57,553.26Z"
        transform="translate(-52 -162.63)"
        fill="#3355ff"
      />
      <path
        d="M894.49,529.35a12.31,12.31,0,0,1-3.91-24.15l-.06,5.07,2.79-5.51h0a12.32,12.32,0,0,1,12.87,11.73,12.3,12.3,0,0,1-11.72,12.87Z"
        transform="translate(-52 -162.63)"
        fill="#3355ff"
      />
      <path
        d="M924.37,509.47a12.31,12.31,0,1,1,5.45-23l-2.18,6,4.48-4.3a12.24,12.24,0,0,1,4,8.5,11.88,11.88,0,0,1-.31,3.39A12.31,12.31,0,0,1,924.37,509.47Z"
        transform="translate(-52 -162.63)"
        fill="#3355ff"
      />
      <path
        d="M920.87,473.21c-2.84.32-5.61,1.2-8.46,1.38s-6-.51-7.79-2.73a38.2,38.2,0,0,1-2.27-4,8.85,8.85,0,0,0-3.1-2.92,12.31,12.31,0,1,0,23,8.17C921.79,473.13,921.33,473.16,920.87,473.21Z"
        transform="translate(-52 -162.63)"
        opacity="0.1"
      />
      <path
        d="M924.37,509.47a12.32,12.32,0,0,1-11.71-17.56,9.11,9.11,0,0,1,2.48,2.47,39.47,39.47,0,0,0,2.44,4.07c1.91,2.26,5.19,3,8.16,2.86s5.84-1,8.8-1.25c.41,0,.83-.07,1.24-.08A12.31,12.31,0,0,1,924.37,509.47Z"
        transform="translate(-52 -162.63)"
        opacity="0.1"
      />
      <path
        d="M894.49,529.35A12.3,12.3,0,0,1,882.68,512a10.15,10.15,0,0,1,2.6,2.5c1,1.35,1.55,2.91,2.67,4.15,2.08,2.32,5.57,3.13,8.72,3.06s6-.82,9-1.05A12.31,12.31,0,0,1,894.49,529.35Z"
        transform="translate(-52 -162.63)"
        opacity="0.1"
      />
      <path
        d="M900.57,553.26a12.32,12.32,0,0,1-22.45-10,12.06,12.06,0,0,1,2.7,2.41c1.18,1.43,1.95,3,3.3,4.38,2.52,2.47,6.58,3.48,10.2,3.58A53.94,53.94,0,0,0,900.57,553.26Z"
        transform="translate(-52 -162.63)"
        opacity="0.1"
      />
      <path
        d="M1047.39,729c2.61-4.83-.35-10.76-3.76-15.07s-7.55-8.79-7.46-14.29c.12-7.89,8.5-12.55,15.2-16.74a73.9,73.9,0,0,0,13.64-11,19.93,19.93,0,0,0,4.2-5.61c1.38-3.09,1.34-6.6,1.26-10q-.43-16.9-1.67-33.76"
        transform="translate(-52 -162.63)"
        fill="none"
        stroke="#3f3d56"
        stroke-miterlimit="10"
        stroke-width="4"
      />
      <path
        d="M1081.52,621.93a12.29,12.29,0,0,0-6.14-10.08l-2.76,5.45.08-6.6a12.08,12.08,0,0,0-4-.49,12.31,12.31,0,1,0,12.87,11.72Z"
        transform="translate(-52 -162.63)"
        fill="#3355ff"
      />
      <path
        d="M1059.57,705.26a12.31,12.31,0,1,1,.59-9.92l-7.69,6.26,8.46-2A12.24,12.24,0,0,1,1059.57,705.26Z"
        transform="translate(-52 -162.63)"
        fill="#3355ff"
      />
      <path
        d="M1053.49,681.35a12.31,12.31,0,0,1-3.91-24.15l-.06,5.07,2.79-5.51h0a12.32,12.32,0,0,1,12.87,11.73,12.3,12.3,0,0,1-11.72,12.87Z"
        transform="translate(-52 -162.63)"
        fill="#3355ff"
      />
      <path
        d="M1083.37,661.47a12.31,12.31,0,1,1,5.45-23l-2.18,6,4.48-4.3a12.24,12.24,0,0,1,4,8.5,11.88,11.88,0,0,1-.31,3.39A12.31,12.31,0,0,1,1083.37,661.47Z"
        transform="translate(-52 -162.63)"
        fill="#3355ff"
      />
      <path
        d="M1079.87,625.21c-2.84.32-5.61,1.2-8.46,1.38s-6-.51-7.79-2.73a38.2,38.2,0,0,1-2.27-4,8.85,8.85,0,0,0-3.1-2.92,12.31,12.31,0,1,0,23,8.17C1080.79,625.13,1080.33,625.16,1079.87,625.21Z"
        transform="translate(-52 -162.63)"
        opacity="0.1"
      />
      <path
        d="M1083.37,661.47a12.32,12.32,0,0,1-11.71-17.56,9.11,9.11,0,0,1,2.48,2.47,39.47,39.47,0,0,0,2.44,4.07c1.91,2.26,5.19,3,8.16,2.86s5.84-1,8.8-1.25c.41,0,.83-.07,1.24-.08A12.31,12.31,0,0,1,1083.37,661.47Z"
        transform="translate(-52 -162.63)"
        opacity="0.1"
      />
      <path
        d="M1053.49,681.35A12.3,12.3,0,0,1,1041.68,664a10.15,10.15,0,0,1,2.6,2.5c1,1.35,1.55,2.91,2.67,4.15,2.08,2.32,5.57,3.13,8.72,3.06s6-.82,9-1.05A12.31,12.31,0,0,1,1053.49,681.35Z"
        transform="translate(-52 -162.63)"
        opacity="0.1"
      />
      <path
        d="M1059.57,705.26a12.32,12.32,0,0,1-22.45-10,12.06,12.06,0,0,1,2.7,2.41c1.18,1.43,2,3,3.3,4.38,2.52,2.47,6.58,3.48,10.2,3.58A53.94,53.94,0,0,0,1059.57,705.26Z"
        transform="translate(-52 -162.63)"
        opacity="0.1"
      />
      <path
        d="M530,587.91a9.81,9.81,0,0,0-3.91-7.92,11.5,11.5,0,0,0-9.61-11.28,11.48,11.48,0,0,0-7.65-8.55h0a9.76,9.76,0,0,0-1.42-.33l-.14,0-.25,0-.2,0-.22,0-.27,0h-.61a11.26,11.26,0,0,0-10.88,9.62c-3.51-.81-6.72.24-7.31,2.46a3,3,0,0,0,.1,1.78c.6,1.72,2.55,3.37,5.16,4.18l.34.1.51.13.11,0h0a8.84,8.84,0,0,0-.84,3.79,8.74,8.74,0,0,0,4.71,7.8l-.23.14a3.12,3.12,0,0,0-.76,1.06,15.86,15.86,0,0,0-1.47,3.54c-.25,1.06-.29,2.16-.6,3.21-.58,1.93-2.06,3.56-2.23,5.57-.08.9.07,2-.57,2.58a3.11,3.11,0,0,1-.51.36,4.13,4.13,0,0,0-1.11,1.17,3.88,3.88,0,0,1-.78,1.12c-.58.43-1.53.39-1.81,1.06s.45,1.46.28,2.19-.79.87-1.24,1.28a4.45,4.45,0,0,0-1.07,2,6.56,6.56,0,0,1-5.4-1.38,10.09,10.09,0,0,1,.56,2,8.76,8.76,0,0,0-2.91-1.46,9.19,9.19,0,0,1-3.1-2.3l1.66-.23L469,600.41l-2.17-.45,1.94,3.73a1.19,1.19,0,0,0-.66.79,3.39,3.39,0,0,0-.07,1.27,22.73,22.73,0,0,0,.5,3l.56,2.62c.05.24.11.49.18.73a6.89,6.89,0,0,0-2.17.24,18.88,18.88,0,0,0-4.51-1.07,2.5,2.5,0,0,0-1,0,2.59,2.59,0,0,0-.95.77,30.76,30.76,0,0,0-3.35,4.72c-4,6.86-9.21,12.85-14.14,19.05-3.4,1.38-6.83,2.69-10.26,4l-7.38,2.82a11.19,11.19,0,0,1-4.58,1c-.7,0-1.57-.15-2,.45a4.21,4.21,0,0,0-.45,1l-.76.08h0a8.74,8.74,0,0,0-1.77-3.26,1.12,1.12,0,0,0-.83.64c-.18.33-.29.69-.5,1-.39.58-1.08.86-1.57,1.35s-.8,1.25-1.34,1.75a5.3,5.3,0,0,1-2.51,1,15.84,15.84,0,0,0-3.93,1.49,6.33,6.33,0,0,1-1.45.67,5.45,5.45,0,0,1-1.71.06l-3.9-.29a3.08,3.08,0,0,0-1.05.05,2,2,0,0,0-1.24,2,3.15,3.15,0,0,0,1.24,2.15,7.94,7.94,0,0,0,2.22,1.15A65.15,65.15,0,0,0,409.79,658v.79a17.75,17.75,0,0,0,8,1.9,1.24,1.24,0,0,0,.6-.11,1.32,1.32,0,0,0,.5-.78,32.17,32.17,0,0,0,1.56-7.66h0a4,4,0,0,0,1.41-.36c1.34-.37,2.68.55,4.07.7,1.71.19,3.29-.81,4.91-1.42l.7-.23a7.68,7.68,0,0,1-1.62,1.55c-.67.48-1.42.84-2.07,1.34a14.26,14.26,0,0,1-1.76,1.36,11.05,11.05,0,0,1-1.35.52,8.91,8.91,0,0,0-1.93,1,3.91,3.91,0,0,0-1.31,1.28,1.92,1.92,0,0,0-.11,1.8,1.9,1.9,0,0,0,1.29.9,5.29,5.29,0,0,0,1.59,0c2.12-.16,4.23-.35,6.34-.54a16.92,16.92,0,0,0,2.65-.38c.46-.11.92-.26,1.38-.39a12.31,12.31,0,0,1,2.41-.36,2,2,0,0,1,.7.07c.49.16.84.66,1.34.76a2,2,0,0,0,1-.13,22.3,22.3,0,0,1,4.69-.5c.69,0,1.5-.17,1.82-.81s-.26-1.67-.52-2.52a7.71,7.71,0,0,1-.22-1.66,10.39,10.39,0,0,0-1.16-3.94,10.29,10.29,0,0,1-.87-1.8,45.47,45.47,0,0,0,8.63-4.38,15.43,15.43,0,0,1,4.92-2.37,13.38,13.38,0,0,1,6.18.72,140.61,140.61,0,0,1,14.17,4.94c2.21.91,4.41,1.87,6.69,2.56a10.43,10.43,0,0,0,2.38,2.31,11,11,0,0,0,5.15,1.41,67.48,67.48,0,0,0,7.25.27,12.23,12.23,0,0,0,5.4-1,5.55,5.55,0,0,0,1.13-.75,4.48,4.48,0,0,0,3.56-1.31A8.63,8.63,0,0,0,512,646.5c.59-2.28.14-5,1.54-6.82.37-.5.86-.9,1.23-1.4a3.94,3.94,0,0,0,.64-2.31.47.47,0,0,1,.06-.09,8.47,8.47,0,0,0,.6-2.3,13.14,13.14,0,0,1,.65-1.82,56.19,56.19,0,0,0,1.86-5.39,31.49,31.49,0,0,0,.86-3.7c.15-1,.24-2,.32-3a18.63,18.63,0,0,1,.91-4.63,37.68,37.68,0,0,0,2.1-11.08v-.22a7.43,7.43,0,0,0,6.58-7.56,7.89,7.89,0,0,0-.69-3.23A10,10,0,0,0,530,587.91Zm-35.78,43.47c.11.39.24.77.37,1.15-.59-.57-1.16-1.16-1.75-1.74.23.08.47.15.69.24A3.73,3.73,0,0,1,494.19,631.38Zm-2.83-1.92c-3.46-3-7.46-5.33-11-8.24,1.93.95,3.81,2.06,5.67,3.12q3.31,1.89,6.71,3.63A5.49,5.49,0,0,1,491.36,629.46Zm1.47-7.56.17-.17c0,.43,0,.82,0,1.19l-.93-.32A8.28,8.28,0,0,0,492.83,621.9ZM462.43,630a28.63,28.63,0,0,0,3.68-5.25c1.37,2.39,3.6,4.12,5.49,6.13C468.55,630.49,465.49,630.16,462.43,630Z"
        transform="translate(-52 -162.63)"
        fill="url(#a964f849-fa65-4178-8cc4-fb8fb10b3617)"
      />
      <polygon
        points="415.35 438.25 417.53 438.69 424.96 449.68 421.69 450.12 415.35 438.25"
        fill="#2f2e41"
      />
      <path
        d="M414.49,645.46a42.78,42.78,0,0,0,2.18,5.67,54,54,0,0,0,7.25-2.07,22.86,22.86,0,0,0-1.51-2,7.46,7.46,0,0,0-2.05-1.57,5.64,5.64,0,0,0-2.49,0C416.75,645.46,415.62,645.48,414.49,645.46Z"
        transform="translate(-52 -162.63)"
        fill="#fbbebe"
      />
      <path
        d="M420.37,648.39a4.52,4.52,0,0,1-2.48-2.82A9.08,9.08,0,0,0,416,642.2a1.08,1.08,0,0,0-.84.63c-.18.32-.29.68-.49,1-.4.57-1.1.85-1.6,1.33s-.8,1.23-1.34,1.72a5.32,5.32,0,0,1-2.53,1,16.41,16.41,0,0,0-4,1.47,6.9,6.9,0,0,1-1.47.66,5.82,5.82,0,0,1-1.72,0l-3.94-.28a3.08,3.08,0,0,0-1,0,1.91,1.91,0,0,0-1.25,2,3,3,0,0,0,1.25,2.12,8.3,8.3,0,0,0,2.24,1.14,65.9,65.9,0,0,0,10.56,3v.78a18.28,18.28,0,0,0,8.05,1.87,1.36,1.36,0,0,0,.6-.1,1.32,1.32,0,0,0,.5-.78,31.2,31.2,0,0,0,1.65-8.56,6.82,6.82,0,0,0-.17-2.21c-.22-.71.52-.41-.16-.69"
        transform="translate(-52 -162.63)"
        fill="#2f2e41"
      />
      <path
        d="M495.93,633.54c-11.68.7-23.22-2.72-34.92-3.08a17.05,17.05,0,0,0-4.34.27,21.87,21.87,0,0,0-4.3,1.67c-6.27,2.92-12.76,5.34-19.24,7.75l-7.45,2.77a11.28,11.28,0,0,1-4.61,1c-.71,0-1.58-.15-2,.44-1.21,1.8-.64,4.43.16,6.45.26.65.7,1.36,1.4,1.43a4.07,4.07,0,0,0,1.42-.36c1.35-.36,2.7.55,4.1.7,1.72.18,3.32-.8,4.95-1.4,2.7-1,5.64-1,8.48-1.44,4.75-.79,9.16-3,13.28-5.51a15.5,15.5,0,0,1,4.95-2.34,13.7,13.7,0,0,1,6.23.71,143,143,0,0,1,14.29,4.86,66.61,66.61,0,0,0,7.46,2.73,27,27,0,0,0,16.73-1c1.87-.74,3.9-2,4-4.06.07-1.15-.83-2.16-1.42-3.15-.38-.63-.77-1.26-1.18-1.87C501.92,637.21,499.48,633.33,495.93,633.54Z"
        transform="translate(-52 -162.63)"
        fill="#2f2e41"
      />
      <path
        d="M495.93,633.54c-11.68.7-23.22-2.72-34.92-3.08a17.05,17.05,0,0,0-4.34.27,21.87,21.87,0,0,0-4.3,1.67c-6.27,2.92-12.76,5.34-19.24,7.75l-7.45,2.77a11.28,11.28,0,0,1-4.61,1c-.71,0-1.58-.15-2,.44-1.21,1.8-.64,4.43.16,6.45.26.65.7,1.36,1.4,1.43a4.07,4.07,0,0,0,1.42-.36c1.35-.36,2.7.55,4.1.7,1.72.18,3.32-.8,4.95-1.4,2.7-1,5.64-1,8.48-1.44,4.75-.79,9.16-3,13.28-5.51a15.5,15.5,0,0,1,4.95-2.34,13.7,13.7,0,0,1,6.23.71,143,143,0,0,1,14.29,4.86,66.61,66.61,0,0,0,7.46,2.73,27,27,0,0,0,16.73-1c1.87-.74,3.9-2,4-4.06.07-1.15-.83-2.16-1.42-3.15-.38-.63-.77-1.26-1.18-1.87C501.92,637.21,499.48,633.33,495.93,633.54Z"
        transform="translate(-52 -162.63)"
        opacity="0.1"
      />
      <path
        d="M436.92,646q2.74.93,5.53,1.72c1-1.71,3-2.9,3.43-4.86a.46.46,0,0,0,0-.26.48.48,0,0,0-.21-.19,10.48,10.48,0,0,0-4.34-1.27c-1.2-.07-1.75,1.18-2.29,2.06C438.83,643.59,437.41,646.19,436.92,646Z"
        transform="translate(-52 -162.63)"
        fill="#fbbebe"
      />
      <path
        d="M439.48,644.78a4,4,0,0,1-2.69-1.77c-.25-.45-.53-1.06-1.05-1s-.69.6-.8,1.07a30,30,0,0,1-1.51,5.19,9.74,9.74,0,0,1-3.23,4.25c-.68.47-1.43.82-2.1,1.32a14.43,14.43,0,0,1-1.77,1.34,10.51,10.51,0,0,1-1.36.5,9.43,9.43,0,0,0-1.94,1,3.85,3.85,0,0,0-1.33,1.27,1.83,1.83,0,0,0-.1,1.77,1.89,1.89,0,0,0,1.29.88,5.44,5.44,0,0,0,1.61,0c2.13-.15,4.26-.34,6.39-.53a18.44,18.44,0,0,0,2.67-.37l1.39-.38a11.06,11.06,0,0,1,2.43-.36,1.89,1.89,0,0,1,.71.07c.49.16.84.65,1.35.75a2.26,2.26,0,0,0,1-.13,22.08,22.08,0,0,1,4.73-.49c.7,0,1.52-.18,1.84-.8.4-.78-.26-1.65-.53-2.49a8,8,0,0,1-.22-1.63,9.94,9.94,0,0,0-1.17-3.88c-.54-1-1.28-2.1-.9-3.16a3,3,0,0,0,.36-1.09C444.4,644.39,440.46,645,439.48,644.78Z"
        transform="translate(-52 -162.63)"
        fill="#2f2e41"
      />
      <path
        d="M478.42,614.8a9.12,9.12,0,0,1-4.66-4.62c-.19-.44-.35-.91-.54-1.35a10.26,10.26,0,0,0-2.78-3.87,1.37,1.37,0,0,0-1-.43,1.09,1.09,0,0,0-.75.81,3.09,3.09,0,0,0-.08,1.25,22.27,22.27,0,0,0,.5,2.92l.57,2.58a5.66,5.66,0,0,0,.35,1.15,4,4,0,0,0,.95,1.13c.52.48,1.05.94,1.58,1.4a5.43,5.43,0,0,0,1,.69,5.81,5.81,0,0,0,1.77.52,15.06,15.06,0,0,1,6.64,2.56s0-1.73,0-1.92a2.54,2.54,0,0,0-.5-1.39A8.87,8.87,0,0,0,478.42,614.8Z"
        transform="translate(-52 -162.63)"
        fill="#fbbebe"
      />
      <path
        d="M478.42,614.8a9.12,9.12,0,0,1-4.66-4.62c-.19-.44-.35-.91-.54-1.35a10.26,10.26,0,0,0-2.78-3.87,1.37,1.37,0,0,0-1-.43,1.09,1.09,0,0,0-.75.81,3.09,3.09,0,0,0-.08,1.25,22.27,22.27,0,0,0,.5,2.92l.57,2.58a5.66,5.66,0,0,0,.35,1.15,4,4,0,0,0,.95,1.13c.52.48,1.05.94,1.58,1.4a5.43,5.43,0,0,0,1,.69,5.81,5.81,0,0,0,1.77.52,15.06,15.06,0,0,1,6.64,2.56s0-1.73,0-1.92a2.54,2.54,0,0,0-.5-1.39A8.87,8.87,0,0,0,478.42,614.8Z"
        transform="translate(-52 -162.63)"
        opacity="0.1"
      />
      <ellipse cx="450.2" cy="429.57" rx="2.84" ry="2.86" fill="#2f2e41" />
      <path
        d="M500.44,590.48a3.07,3.07,0,0,0-2.24.32,3.11,3.11,0,0,0-.77,1.05,15.25,15.25,0,0,0-1.48,3.48c-.25,1-.29,2.13-.61,3.16-.58,1.9-2.07,3.51-2.24,5.49-.08.89.07,1.93-.58,2.53a3.68,3.68,0,0,1-.51.37,3.84,3.84,0,0,0-1.12,1.15,3.77,3.77,0,0,1-.79,1.09c-.58.43-1.54.39-1.82,1s.45,1.44.28,2.16-.8.86-1.25,1.26a4.37,4.37,0,0,0-1.08,2,6.67,6.67,0,0,1-5.44-1.35,17.32,17.32,0,0,1,.85,6.22,2.54,2.54,0,0,1-.5,1.92,34.64,34.64,0,0,1,6.67,1.16,4.6,4.6,0,0,0,2.91,0,4.86,4.86,0,0,0,1.34-1.06c1.2-1.22,2.46-2.55,2.75-4.24a24.91,24.91,0,0,0,.05-2.87,16.18,16.18,0,0,1,.73-3.49,41.53,41.53,0,0,0,1.27-7.18c.13-1.5,1.43-2.7,2.11-4,1.28-2.53,2.6-5.16,2.69-8C501.7,591.73,501.38,590.58,500.44,590.48Z"
        transform="translate(-52 -162.63)"
        fill="#2f2e41"
      />
      <path
        d="M500.44,590.48a3.07,3.07,0,0,0-2.24.32,3.11,3.11,0,0,0-.77,1.05,15.25,15.25,0,0,0-1.48,3.48c-.25,1-.29,2.13-.61,3.16-.58,1.9-2.07,3.51-2.24,5.49-.08.89.07,1.93-.58,2.53a3.68,3.68,0,0,1-.51.37,3.84,3.84,0,0,0-1.12,1.15,3.77,3.77,0,0,1-.79,1.09c-.58.43-1.54.39-1.82,1s.45,1.44.28,2.16-.8.86-1.25,1.26a4.37,4.37,0,0,0-1.08,2,6.67,6.67,0,0,1-5.44-1.35,17.32,17.32,0,0,1,.85,6.22,2.54,2.54,0,0,1-.5,1.92,34.64,34.64,0,0,1,6.67,1.16,4.6,4.6,0,0,0,2.91,0,4.86,4.86,0,0,0,1.34-1.06c1.2-1.22,2.46-2.55,2.75-4.24a24.91,24.91,0,0,0,.05-2.87,16.18,16.18,0,0,1,.73-3.49,41.53,41.53,0,0,0,1.27-7.18c.13-1.5,1.43-2.7,2.11-4,1.28-2.53,2.6-5.16,2.69-8C501.7,591.73,501.38,590.58,500.44,590.48Z"
        transform="translate(-52 -162.63)"
        opacity="0.1"
      />
      <path
        d="M497.78,636c-2.43-1.16-4.21-3.31-6.18-5.16-3.75-3.53-8.34-6-12.29-9.33-2.62-2.19-5-4.74-7.83-6.58a19.57,19.57,0,0,0-8.39-2.93,2.23,2.23,0,0,0-1,0,2.3,2.3,0,0,0-.95.75,30.22,30.22,0,0,0-3.39,4.65c-5,8.5-12.11,15.64-18,23.54a1.5,1.5,0,0,0-.29.56,1.39,1.39,0,0,0,.22.87l1.2,2.34c.67,1.32,1.75,2.85,3.19,2.59a3.49,3.49,0,0,0,1.67-1.07l5.38-5.15,5.64-5.39c3.3-3.15,6.66-6.38,8.82-10.42,1.68,2.92,4.67,4.83,6.71,7.5.78,1,1.42,2.13,2.12,3.21,1.11,1.72,2.38,3.34,3.64,5l6.47,8.25a12.38,12.38,0,0,0,3,3,11.45,11.45,0,0,0,5.19,1.39,68.59,68.59,0,0,0,7.31.26,12.6,12.6,0,0,0,5.45-1,4.94,4.94,0,0,0,2.95-4.39,6.44,6.44,0,0,0-.93-2.73C505.15,641.59,502.13,638.07,497.78,636Z"
        transform="translate(-52 -162.63)"
        fill="#2f2e41"
      />
      <ellipse cx="451.95" cy="431.55" rx="2.19" ry="2.2" fill="#e8e8f0" />
      <path
        d="M503.47,592.53a4.21,4.21,0,0,1,.24,3.16,12.82,12.82,0,0,1-1.41,2.91,13.85,13.85,0,0,1-1.83,2.6c3.38.16,6.65-1.16,9.62-2.76,2.4-1.29,4.79-2.88,6.07-5.29a2.8,2.8,0,0,1-2.24-.42,8,8,0,0,1-1.71-1.59l-1.69-1.9a7.61,7.61,0,0,1-1-1.37,3.78,3.78,0,0,1-.45-2.21,12.87,12.87,0,0,1-2.24,1.86c-1.21.79-2.54,1.36-3.76,2.14-.42.28-1.38.72-1.13,1.28S503.13,591.93,503.47,592.53Z"
        transform="translate(-52 -162.63)"
        fill="#fbbebe"
      />
      <path
        d="M503.47,592.53a4.21,4.21,0,0,1,.24,3.16,12.82,12.82,0,0,1-1.41,2.91,13.85,13.85,0,0,1-1.83,2.6c3.38.16,6.65-1.16,9.62-2.76,2.4-1.29,4.79-2.88,6.07-5.29a2.8,2.8,0,0,1-2.24-.42,8,8,0,0,1-1.71-1.59l-1.69-1.9a7.61,7.61,0,0,1-1-1.37,3.78,3.78,0,0,1-.45-2.21,12.87,12.87,0,0,1-2.24,1.86c-1.21.79-2.54,1.36-3.76,2.14-.42.28-1.38.72-1.13,1.28S503.13,591.93,503.47,592.53Z"
        transform="translate(-52 -162.63)"
        opacity="0.1"
      />
      <path
        d="M503.51,592.86a2.85,2.85,0,0,0,0,3.3c.1.12.46.87.61.88a.55.55,0,0,0,.38-.2,25.1,25.1,0,0,0,2.14-2.55,4.76,4.76,0,0,1,2.72-1.78,5.88,5.88,0,0,1,3.75,1.17,3.56,3.56,0,0,1,1.29,1,3.49,3.49,0,0,1,.42,1.43,68.9,68.9,0,0,1,.38,9.09,35.82,35.82,0,0,1-.43,6.55c-.22,1.11-.54,2.2-.69,3.33a21.24,21.24,0,0,0-.14,3v4.18a11,11,0,0,0,.16,2.29c.2.91.63,1.76.92,2.65a17.33,17.33,0,0,1,.61,3.13l.57,4.32c.18,1.36.32,2.85-.51,4-.37.49-.86.89-1.24,1.38-1.41,1.84-1,4.47-1.55,6.72a8.38,8.38,0,0,1-2.74,4.2,4.53,4.53,0,0,1-3.61,1.29c-1.76-.33-2.81-2.16-3.29-3.89s-.65-3.61-1.69-5.07a13.45,13.45,0,0,0-3.34-2.79,5.77,5.77,0,0,1-2.61-3.39c-.11-.63,0-1.28-.11-1.92a4.53,4.53,0,0,0-2.79-3.67c-.9-.35-2-.48-2.52-1.3a6.07,6.07,0,0,0,2.63-3.53,18.13,18.13,0,0,0,.64-4.46l.3-5c.14-2.25.2-4.47,1.19-6.49.44-.9,1-1.75,1.45-2.64a28.66,28.66,0,0,0,1.55-3.87c.72-2.06,1.44-4.12,2.08-6.2a11.68,11.68,0,0,1,1.14-2.89C501.72,594.19,502.5,593.06,503.51,592.86Z"
        transform="translate(-52 -162.63)"
        fill="#e8e8f0"
      />
      <path
        d="M492.36,625.5l1.33,0,.28-2a4.17,4.17,0,0,1,.28-1.17,7,7,0,0,1,.77-1.12c1.3-1.85,1.21-4.3,1.53-6.55a33.33,33.33,0,0,1,2.92-8.56l2.58-5.75a7.94,7.94,0,0,0,.56-1.47,8.82,8.82,0,0,0,.16-1.7c0-.89.28-4.13.31-5,0-.33-.73-.15-.88-.44-.32-.64-.76,1.09-1.37,1.47a3.36,3.36,0,0,0-1.19,1.74c-.56,1.44-.9,3-1.42,4.43a9.05,9.05,0,0,1-2.41,3.92c-.53.46-1.14.83-1.64,1.33-1.6,1.58-1.76,4.09-1.81,6.35C492.32,612.36,492.06,625.5,492.36,625.5Z"
        transform="translate(-52 -162.63)"
        fill="#2f2e41"
      />
      <path
        d="M511.5,590.47a4.54,4.54,0,0,0-2.37,3.25,16.44,16.44,0,0,1-1.2,4c-1.62,2.82-5.75,3.64-6.9,6.69a12.3,12.3,0,0,0-.46,3.15c-.2,2.19-.92,4.3-1.14,6.48a28.87,28.87,0,0,0,.12,5.09L501,636.35a23,23,0,0,1-.43,7.58,7.3,7.3,0,0,0,4.34-.72c1.35-.62,2.59-1.47,3.9-2.19,2.24-1.24,4.72-2.11,6.69-3.76a4.09,4.09,0,0,0,.9-1A8.65,8.65,0,0,0,517,634a12.2,12.2,0,0,1,.65-1.78,52.45,52.45,0,0,0,1.88-5.32,30.53,30.53,0,0,0,.86-3.64c.16-1,.25-2,.33-3a17.6,17.6,0,0,1,.92-4.55,36.65,36.65,0,0,0,2.11-10.92,5.71,5.71,0,0,0-.11-1.6,8.56,8.56,0,0,0-.88-1.83c-.6-1.13-1-2.37-1.52-3.52a17.31,17.31,0,0,0-5.91-6.21C514.17,590.84,512.81,590,511.5,590.47Z"
        transform="translate(-52 -162.63)"
        fill="#2f2e41"
      />
      <path
        d="M481.29,618.57a10.43,10.43,0,0,1-2.75-2.09c-.36-.42-.66-.89-1-1.31a6.81,6.81,0,0,0-3.46-2,16.9,16.9,0,0,0-4-.39,7.26,7.26,0,0,0-2.67.32,2.72,2.72,0,0,0-1.77,1.9,3.15,3.15,0,0,0,1.35,2.8,6.36,6.36,0,0,0,2.69,1.3,21.5,21.5,0,0,0,2.43.29c4.78.5,9.05,3.1,13.24,5.47q5.52,3.14,11.26,5.84a23.4,23.4,0,0,0,.19-3.45c0-.86-.07-2.18-.88-2.69a17.66,17.66,0,0,0-3.58-1.07,56.34,56.34,0,0,1-7.21-2.92C483.81,620,482.54,619.3,481.29,618.57Z"
        transform="translate(-52 -162.63)"
        fill="#fbbebe"
      />
      <ellipse cx="450.2" cy="420.35" rx="8.52" ry="8.57" fill="#fbbebe" />
      <path
        d="M513.93,600.18a13.66,13.66,0,0,0-1.65,3.09c-1,2.16-2.7,4-3.53,6.29s-.84,5.23-2.55,7.1a2.49,2.49,0,0,0-.75,1.08,5.16,5.16,0,0,1-.08.78c-.25.68-1.36.71-1.57,1.41-.06.2,0,.42-.1.62-.17.45-.77.52-1.16.79-.83.56-.66,1.86-1.25,2.67a2.25,2.25,0,0,1-2.13.75,7.5,7.5,0,0,1-2.21-.83,2.13,2.13,0,0,0-.8-.25,1.65,1.65,0,0,0-.92.32,5.67,5.67,0,0,0-2.3,4.85,15.84,15.84,0,0,0,1.32,5.43,2.18,2.18,0,0,0,.43.81,1.91,1.91,0,0,0,2.12.16,10,10,0,0,1,2.07-.93c1.32-.24,2.61.67,3.95.59a5.49,5.49,0,0,0,2.66-1.17,14.7,14.7,0,0,0,3.58-3c.58-.77,1-1.64,1.52-2.46a31.54,31.54,0,0,1,2.15-2.87l4.92-6a13.83,13.83,0,0,0,1.32-1.82,12.83,12.83,0,0,0,1-2.75,21.07,21.07,0,0,0,1-4.89,18.79,18.79,0,0,0-.36-4.1,14.49,14.49,0,0,0-1-3.91C518.54,599.68,515.94,597.84,513.93,600.18Z"
        transform="translate(-52 -162.63)"
        fill="#2f2e41"
      />
      <path
        d="M531.05,589a9.6,9.6,0,0,0-3.94-7.8,11.41,11.41,0,0,0-9.69-11.11,11.07,11.07,0,0,0-21.81.59c-3.54-.8-6.78.24-7.37,2.42s1.91,5,5.64,6a10.51,10.51,0,0,0,3.62.36,11.08,11.08,0,0,0,7.62,4.75,11.37,11.37,0,0,0,8.32,8.58,9.55,9.55,0,0,0,2.57,3.55c0,.27,0,.55,0,.83a7.21,7.21,0,1,0,14.42,0,7.7,7.7,0,0,0-.69-3.19A9.64,9.64,0,0,0,531.05,589Z"
        transform="translate(-52 -162.63)"
        fill="#f86d70"
      />
      <path
        d="M490.64,573.56c.59-2.18,3.83-3.22,7.37-2.42a11.26,11.26,0,0,1,11-9.48l.73,0a10.84,10.84,0,0,0-3.14-.47,11.26,11.26,0,0,0-11,9.48c-3.54-.8-6.78.24-7.37,2.42s1.91,5,5.64,6a11,11,0,0,0,2.14.37C492.44,578.39,490.05,575.79,490.64,573.56Z"
        transform="translate(-52 -162.63)"
        opacity="0.1"
      />
      <path
        d="M518.37,597.59a7.52,7.52,0,0,1,0-.82,9.34,9.34,0,0,1-2.57-3.55,11.34,11.34,0,0,1-8.32-8.59,11.05,11.05,0,0,1-7.63-4.74,9.6,9.6,0,0,1-2.13-.06,11.11,11.11,0,0,0,7.35,4.37,11.37,11.37,0,0,0,8.32,8.58,9.55,9.55,0,0,0,2.57,3.55c0,.27,0,.55,0,.83a7.34,7.34,0,0,0,7.17,7.46A7.46,7.46,0,0,1,518.37,597.59Z"
        transform="translate(-52 -162.63)"
        opacity="0.1"
      />
      <ellipse
        cx="505.04"
        cy="584.74"
        rx="1.31"
        ry="1.75"
        transform="translate(-302.82 261.95) rotate(-37.22)"
        fill="#fbbebe"
      />
    </svg>
  );
};

export const ProjectsSVG = function () {
  return (
    <svg
      className="ProjectsSVG"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="971.69"
      height="562.86"
      viewBox="-0.847 -1 975.694 566.859"
    >
      <defs>
        <path id="eR2BRSHQc" d="M962.98 501.21v2.23H.15v-2.23h962.83z" />
        <path id="d1EGy8eXiv" d="M809.96 0v318.78H188.4V0h621.56z" />
        <path
          id="aP6YG9894"
          d="M325.99 175.61c-.81 0-1.46-.65-1.46-1.46v-51.54c0-.81.65-1.46 1.46-1.46h128.87c.8 0 1.46.65 1.46 1.45v51.55c0 .81-.65 1.46-1.46 1.46H325.99zm1.46-2.92H453.4v-48.63H327.45v48.63z"
        />
        <path
          id="e4GrPPr6s8"
          d="M325.99 209.44c-.81 0-1.46-.65-1.46-1.46v-21.91c0-.8.65-1.46 1.46-1.46h54.77c.8 0 1.46.66 1.46 1.46v21.91c0 .81-.65 1.46-1.46 1.46h-54.77zm1.46-2.92h51.85v-18.99h-51.85v18.99z"
        />
        <path
          id="e1CilFOxq"
          d="M400.09 209.44c-.81 0-1.46-.65-1.46-1.46v-21.91c0-.8.65-1.46 1.46-1.46h54.77c.8 0 1.46.66 1.46 1.46v21.91c0 .81-.65 1.46-1.46 1.46h-54.77zm1.46-2.92h51.85v-18.99h-51.85v18.99z"
        />
        <path
          id="f15KtcUmE"
          d="M452.71 173.9c-12.72-4.99-114.53-44.94-127.25-49.94a1.462 1.462 0 01-.83-1.89c.3-.75 1.14-1.12 1.89-.82 12.73 4.99 114.54 44.94 127.26 49.93.75.3 1.12 1.15.83 1.9a1.47 1.47 0 01-1.9.82z"
        />
        <path
          id="c2spb7RcA5"
          d="M324.53 174.15c0-.59.36-1.13.92-1.35 12.88-5.16 115.98-46.4 128.87-51.55.75-.3 1.59.07 1.89.82.3.75-.06 1.59-.81 1.89-12.89 5.16-115.98 46.39-128.87 51.55-.17.07-.35.1-.54.1-.81 0-1.46-.65-1.46-1.46z"
        />
        <path
          id="aUGBNJXsp"
          d="M379.42 208.53c-5.32-2.09-47.84-18.84-53.16-20.94a1.45 1.45 0 01-.82-1.89c.3-.75 1.14-1.12 1.89-.82 5.32 2.09 47.84 18.84 53.16 20.94.75.29 1.12 1.14.82 1.89-.22.56-.76.93-1.36.93-.18 0-.36-.04-.53-.11z"
        />
        <path
          id="cxZK7DFh2"
          d="M325.34 207.18c0-.62.38-1.17.96-1.38 5.31-1.93 47.84-17.39 53.16-19.33.75-.27 1.59.11 1.87.87.28.75-.11 1.59-.87 1.87 0 0 0 .01-.01.01-5.31 1.93-47.84 17.39-53.16 19.33-.16.06-.32.08-.49.09-.81 0-1.46-.66-1.46-1.46z"
        />
        <path
          id="e1iKq7Dyd2"
          d="M453.54 208.54c-5.15-1.93-46.39-17.39-51.55-19.33a1.462 1.462 0 01-.85-1.88c.28-.75 1.12-1.13 1.88-.85 5.15 1.93 46.39 17.4 51.55 19.33a1.462 1.462 0 01-.52 2.83c-.17 0-.35-.04-.51-.1z"
        />
        <path
          id="aiaFGW55i"
          d="M401.05 205.56c0-.62.39-1.17.98-1.37 5.16-1.78 46.39-15.95 51.55-17.72.76-.27 1.59.13 1.86.89.26.76-.14 1.6-.9 1.86 0 0-.01 0-.01.01-5.16 1.77-46.39 15.94-51.55 17.71-.15.06-.31.08-.47.08-.81 0-1.46-.65-1.46-1.46z"
        />
        <path
          id="bbHKDt2jT"
          d="M224.56 71.49c0-12.09 9.8-21.89 21.89-21.89s21.89 9.8 21.89 21.89c-.01 12.09-9.8 21.88-21.89 21.9-12.09 0-21.89-9.81-21.89-21.9zm2.92 0c0 10.48 8.49 18.98 18.97 18.98 10.48 0 18.97-8.5 18.97-18.98-.01-10.47-8.49-18.96-18.97-18.97-10.48 0-18.97 8.5-18.97 18.97z"
        />
        <path
          id="aGr5Jnz1q"
          d="M369.04 71.49c0-12.09 9.8-21.89 21.89-21.89s21.89 9.8 21.89 21.89c-.01 12.09-9.8 21.88-21.89 21.9-12.09 0-21.89-9.81-21.89-21.9zm2.92 0c0 10.48 8.5 18.98 18.97 18.98 10.48 0 18.98-8.5 18.98-18.98-.02-10.47-8.5-18.96-18.98-18.97-10.47 0-18.97 8.5-18.97 18.97z"
        />
        <path
          id="g10rqlbHX"
          d="M548.55 71.49c0-12.09 9.8-21.89 21.89-21.89s21.89 9.8 21.89 21.89c-.01 12.09-9.8 21.88-21.89 21.9-12.09 0-21.89-9.81-21.89-21.9zm2.92 0c0 10.48 8.49 18.98 18.97 18.98 10.48 0 18.97-8.5 18.97-18.98-.01-10.47-8.5-18.96-18.97-18.97-10.48 0-18.97 8.5-18.97 18.97z"
        />
        <path
          id="e2HYodK6J5"
          d="M736.62 71.49c0-12.09 9.8-21.89 21.89-21.89s21.89 9.8 21.89 21.89c-.01 12.09-9.81 21.88-21.89 21.9-12.09 0-21.89-9.81-21.89-21.9zm2.92 0c0 10.48 8.49 18.98 18.97 18.98 10.48 0 18.97-8.5 18.97-18.98-.01-10.47-8.5-18.96-18.97-18.97-10.48 0-18.97 8.5-18.97 18.97z"
        />
        <path
          id="c1SnpkDxDX"
          d="M387.06 78.25v-1.1c.85-.82 1.32-1.28 1.41-1.37 3.4-3.23 4.93-4.95 4.95-6.95.13-1.31-.81-2.47-2.12-2.6a2.26 2.26 0 00-.52 0c-1.04.04-2.04.44-2.82 1.12-.06-.12-.51-1.14-.57-1.26a5.802 5.802 0 013.76-1.35 3.743 3.743 0 014.06 3.39c.01.16.01.31.01.47 0 2.45-1.78 4.44-4.58 7.14-.07.06-.43.39-1.06.98v.04h5.97v1.49h-8.49z"
        />
        <path
          id="a1cMKru6na"
          d="M245.97 66.53h-.04l-2.31 1.24-.35-1.37 2.9-1.55h1.54v13.29h-1.74V66.53z"
        />
        <path
          id="e4ddCfqeM"
          d="M759.82 78.14v-3.62h-6.18v-1.18l5.93-8.49h1.95v8.26h1.86v1.41h-1.86v3.62h-1.7zm0-5.03v-4.44c0-.69.02-1.39.06-2.08h-.06c-.41.78-.74 1.35-1.1 1.96-.22.3-1.31 1.81-3.26 4.52v.04h4.36z"
        />
        <path
          id="a5lkHtOsLR"
          d="M568.19 76.07c.9.53 1.91.82 2.95.84 2.31 0 3.02-1.47 3-2.57-.02-1.86-1.69-2.66-3.43-2.66h-1v-1.35h1c1.31 0 2.96-.68 2.96-2.25 0-1.06-.67-2-2.33-2-.95.02-1.87.33-2.65.88-.05-.13-.43-1.18-.47-1.31a6.204 6.204 0 013.47-1.02c2.62 0 3.8 1.55 3.8 3.16a3.303 3.303 0 01-2.45 3.13v.04c1.7.25 2.96 1.7 2.96 3.42 0 2.12-1.65 3.98-4.84 3.98-1.21.02-2.41-.29-3.46-.9.1-.27.4-1.11.49-1.39z"
        />
        <path
          id="b10tNkFLdQ"
          d="M509.88 207.98c-.81 0-1.46-.65-1.46-1.46v-82.46c0-.8.65-1.45 1.45-1.45h128.87c.81-.01 1.46.65 1.46 1.45v82.46c0 .81-.65 1.46-1.45 1.46H509.88zm1.46-2.92h125.94v-79.54H511.34v79.54z"
        />
        <path
          id="a4MwpmYRYd"
          d="M536.87 140.85c-.8 0-1.45-.66-1.45-1.46 0-.81.65-1.46 1.45-1.46h78.81c.81 0 1.46.65 1.46 1.46 0 .8-.65 1.46-1.46 1.46h-78.81z"
        />
        <path
          id="l1ktLZGOw1"
          d="M536.87 153.98c-.8 0-1.46-.65-1.46-1.45 0-.81.65-1.46 1.46-1.47h78.81c.81 0 1.46.66 1.46 1.46 0 .81-.65 1.46-1.46 1.46h-78.81z"
        />
        <path
          id="c44432okn"
          d="M536.87 167.12c-.8 0-1.45-.66-1.45-1.46 0-.81.65-1.46 1.45-1.46h78.81c.81 0 1.46.65 1.46 1.46 0 .8-.65 1.46-1.46 1.46h-78.81z"
        />
        <path
          id="g16wq29ee9"
          d="M536.87 180.25c-.8 0-1.46-.65-1.46-1.45 0-.81.65-1.46 1.46-1.47h78.81c.81 0 1.46.66 1.46 1.46 0 .81-.65 1.46-1.46 1.46h-78.81z"
        />
        <path
          id="b1NXHcEQKr"
          d="M536.87 193.39c-.8 0-1.45-.66-1.45-1.46 0-.81.65-1.46 1.45-1.46h78.81c.81 0 1.46.65 1.47 1.45 0 .81-.65 1.46-1.46 1.47H536.87z"
        />
        <path
          id="bjgfbQDbG"
          d="M217.76 125.11c-.03-.79-.66-1.42-1.45-1.45-.83.03-1.48.72-1.45 1.55.03.79.66 1.42 1.45 1.45.83-.03 1.48-.72 1.45-1.55z"
        />
        <path
          id="dpIvEcQsF"
          d="M217.76 141.16c-.03-.79-.66-1.42-1.45-1.45-.83.03-1.48.73-1.45 1.56.03.78.66 1.41 1.45 1.44.83-.03 1.48-.72 1.45-1.55z"
        />
        <path
          id="c1Iv4CEfx"
          d="M217.76 157.21c-.03-.78-.66-1.42-1.45-1.44-.83.03-1.48.72-1.45 1.55.03.79.66 1.42 1.45 1.45.83-.03 1.48-.73 1.45-1.56z"
        />
        <path
          id="bv0ti55b7"
          d="M217.76 173.27c-.03-.79-.66-1.42-1.45-1.45-.83.03-1.48.72-1.45 1.55.03.79.66 1.42 1.45 1.45.83-.03 1.48-.72 1.45-1.55z"
        />
        <path
          id="aoE5jaqO1"
          d="M217.76 189.32c-.03-.79-.66-1.42-1.45-1.45-.83.03-1.48.73-1.45 1.56.03.78.66 1.42 1.45 1.44.83-.03 1.48-.72 1.45-1.55z"
        />
        <path
          id="c15loYPkuG"
          d="M217.76 205.38c-.03-.79-.66-1.42-1.45-1.45-.83.03-1.48.72-1.45 1.55.03.79.66 1.42 1.45 1.45.83-.03 1.48-.73 1.45-1.55z"
        />
        <path
          id="h4aBFEOXTi"
          d="M230.4 126.62c-.81 0-1.46-.65-1.46-1.46 0-.81.65-1.46 1.46-1.46h46.7c.81 0 1.46.65 1.46 1.46 0 .81-.65 1.46-1.46 1.46h-46.7z"
        />
        <path
          id="aa6zizuxa"
          d="M230.4 142.67c-.81 0-1.46-.65-1.46-1.45-.01-.81.65-1.46 1.45-1.47h46.71c.81 0 1.46.65 1.46 1.46.01.81-.65 1.46-1.45 1.46h-.01-46.7z"
        />
        <path
          id="a885uBEQR"
          d="M230.4 158.73c-.81 0-1.46-.66-1.46-1.46 0-.81.65-1.46 1.46-1.46h46.7c.81-.01 1.46.65 1.46 1.45.01.81-.65 1.46-1.45 1.47h-.01-46.7z"
        />
        <path
          id="d6Pr1qTIM5"
          d="M230.4 174.78c-.81 0-1.46-.65-1.46-1.46 0-.81.65-1.46 1.46-1.46h46.7c.81 0 1.46.65 1.46 1.46.01.8-.65 1.46-1.45 1.46h-.01-46.7z"
        />
        <path
          id="aaAxhAKAB"
          d="M230.4 190.83c-.81 0-1.46-.65-1.46-1.46 0-.8.65-1.46 1.46-1.46h46.7c.81 0 1.46.65 1.46 1.46.01.81-.65 1.46-1.45 1.46h-.01-46.7z"
        />
        <path
          id="bfty30ef2"
          d="M230.4 206.89c-.81 0-1.46-.65-1.46-1.46-.01-.81.65-1.46 1.45-1.46h46.71c.81 0 1.46.65 1.46 1.45.01.81-.65 1.46-1.45 1.47h-.01-46.7z"
        />
        <path
          id="cg4P4OGYz"
          d="M742.8 213.55c-4.32 0-7.83-3.51-7.84-7.84v-80.84c.01-4.33 3.52-7.83 7.84-7.83h3.81c.81 0 1.46.65 1.46 1.45 0 .19-.03.38-.1.55-.33.81.05 1.72.86 2.05.19.08.39.12.59.12h17.91c.87 0 1.57-.71 1.57-1.58 0-.2-.04-.4-.11-.58-.31-.75.05-1.6.8-1.91.17-.07.36-.1.55-.1h4.08c4.32 0 7.83 3.51 7.84 7.83v80.84c-.01 4.33-3.52 7.84-7.84 7.84H742.8zm0-93.6a4.942 4.942 0 00-4.92 4.92v80.84c.01 2.72 2.21 4.92 4.92 4.92h31.42c2.71 0 4.91-2.2 4.92-4.92v-80.84a4.942 4.942 0 00-4.92-4.92h-2.41a4.498 4.498 0 01-4.48 4.18h-17.91c-2.36 0-4.31-1.83-4.48-4.18h-2.14z"
        />
        <path
          id="fZb69SCsW"
          d="M671.14 167.12c-.81 0-1.46-.66-1.46-1.46 0-.81.65-1.46 1.46-1.46h37.34c-5.07-5.07-7.89-7.89-8.45-8.46-.57-.57-.57-1.49 0-2.06.57-.57 1.49-.57 2.06 0 1.09 1.1 9.85 9.85 10.95 10.95.57.57.57 1.49 0 2.06-.28.27-.65.43-1.04.43h-40.86z"
        />
        <path
          id="fHvLutWIR"
          d="M700.33 175.87c0-.38.15-.75.43-1.03l10.21-10.21c.57-.57 1.5-.57 2.07 0 .57.57.57 1.49 0 2.06-1.03 1.02-9.2 9.19-10.22 10.22-.27.27-.64.42-1.03.42-.81 0-1.46-.65-1.46-1.46z"
        />
        <path
          id="hcrqG8OaH"
          d="M736.23 289.95a167.192 167.192 0 010-56.89h47.72a102.28 102.28 0 000 56.89h-47.72z"
        />
        <path
          id="c36Df2nxjJ"
          d="M566.73 280.17c3.26-18.82 3.26-38.07 0-56.89h-47.72a102.28 102.28 0 010 56.89h47.72z"
        />
        <path
          id="e24duvVUvt"
          d="M639.35 296.17c3.25-18.82 3.25-38.07 0-56.89h-47.72a102.28 102.28 0 010 56.89h47.72z"
        />
        <path
          id="e38581jFAu"
          d="M530.16 239.85c-.5 0-.9-.65-.9-1.46 0-.8.4-1.46.9-1.46h29.04c.5 0 .91.66.91 1.46 0 .81-.41 1.46-.91 1.46h-29.04z"
        />
        <path
          id="a3bjBapYjH"
          d="M530.16 253.39c-.5 0-.9-.65-.9-1.46 0-.8.4-1.46.9-1.46h29.04c.5 0 .91.66.91 1.46 0 .81-.41 1.46-.91 1.46h-29.04z"
        />
        <path
          id="aVuMVyP6U"
          d="M602.78 262.01c-.5 0-.91-.66-.91-1.46 0-.81.41-1.46.91-1.46h29.04c.5 0 .91.65.91 1.46 0 .8-.41 1.46-.91 1.46h-29.04z"
        />
        <path
          id="a13IRZt9nG"
          d="M602.78 275.55c-.5 0-.91-.66-.91-1.46 0-.81.41-1.46.91-1.46h29.04c.5 0 .91.65.91 1.46 0 .8-.41 1.46-.91 1.46h-29.04z"
        />
        <path
          id="a1pYLXR9fr"
          d="M744.32 248.47c-.5 0-.9-.65-.9-1.46 0-.81.4-1.46.9-1.46h29.04c.5 0 .91.65.91 1.46 0 .81-.41 1.46-.91 1.46h-29.04z"
        />
        <path
          id="c1zCXOzhr7"
          d="M744.32 262.01c-.5 0-.9-.66-.9-1.46 0-.81.4-1.46.9-1.46h29.04c.5 0 .91.65.91 1.46 0 .8-.41 1.46-.91 1.46h-29.04z"
        />
        <path
          id="atlj9EOGi"
          d="M530.16 266.93c-.5 0-.9-.65-.9-1.46 0-.81.4-1.46.9-1.46h29.04c.5 0 .91.65.91 1.46 0 .81-.41 1.46-.91 1.46h-29.04z"
        />
        <path
          id="b2S2aobed"
          d="M326.72 281.4c3.26-18.82 3.26-38.07 0-56.89H279a102.28 102.28 0 010 56.89h47.72z"
        />
        <path
          id="dF9Z549n9"
          d="M290.16 241.08c-.5 0-.91-.65-.91-1.46 0-.8.41-1.45.91-1.45h29.03c.5 0 .91.65.91 1.45 0 .81-.41 1.46-.91 1.46h-29.03z"
        />
        <path
          id="afH8Ip2d"
          d="M290.16 254.62c-.5 0-.91-.65-.91-1.46 0-.8.41-1.46.91-1.46h29.03c.5 0 .91.66.91 1.46 0 .81-.41 1.46-.91 1.46h-29.03z"
        />
        <path
          id="a1ro449ecS"
          d="M290.16 268.16c-.5 0-.91-.65-.91-1.46 0-.8.41-1.46.91-1.46h29.03c.5 0 .91.66.91 1.46 0 .81-.41 1.46-.91 1.46h-29.03z"
        />
        <path
          id="a1qUppLBEQ"
          d="M802.22 265.5s-29.31 23.03-14.65 28.27l24.08-18.85c-1.89-1.88-7.54-7.54-9.43-9.42z"
        />
        <path
          id="b2Hef4h5AZ"
          d="M803.27 257.12c-3.77 6.28-5.86 9.77-6.28 10.47 0 0 10.47 0 12.56 15.71.56-.7 3.35-4.19 8.38-10.47l-14.66-15.71z"
        />
        <path id="blQXkvyge" d="M943.58 527.26l-12.57 7.33-5.23-3.14 1.04-35.6h15.71l1.05 31.41z" />
        <path
          id="fRJsCBQUc"
          d="M868.19 487.47l2.09 33.51-29.31 12.56c1.25-10.68 1.95-16.61 2.09-17.8 0 0 8.38-13.61 6.28-28.27h18.85z"
        />
        <path
          id="cNaEfY6D"
          d="M913.21 235.13s16.76 43.98 19.9 71.2l8.37 99.47c.7 6.21 4.19 37.28 10.47 93.19l-29.31 4.19-12.57-94.24-28.27-93.18-6.28 93.18-5.24 84.81-27.22 1.05-2.09-87.95-11.52-112.04 6.28-53.4c41.32-3.35 67.15-5.44 77.48-6.28z"
        />
        <path
          id="e1K2bUq1Hb"
          d="M928.92 529.35s1.72-17.58 14.47-7.74l2.28-1.68 10.47 23.04s12.57 17.8-9.42 19.89l-19.9-19.89c-.14-.63-.83-3.77-2.09-9.43l1.05-6.17c1.67 1.06 2.72 1.72 3.14 1.98z"
        />
        <path
          id="h22tBNB0nj"
          d="M876.57 523.07c0 10.47-1.05 11.52-1.05 11.52-1.57.42-14.14 3.77-15.71 4.19 0 0-10.47-1.05-16.75 5.23 0 0-37.69 10.47-37.69 2.1 0-8.38 26.17-21.99 26.17-21.99s7.78-13.13 13.31-11.8c5.54 1.33 7.63 3.42 7.63 4.47 0 1.05-3.14 8.38-3.14 8.38s17.8-4.19 18.85-16.76c5.25 3 8.45 8.62 8.38 14.66z"
        />
        <path
          id="bL1JqcCd"
          d="M866.1 53.99c-14.46 0-26.18 11.72-26.18 26.18 0 14.46 11.72 26.18 26.18 26.18 14.45 0 26.17-11.72 26.17-26.18 0-14.46-11.72-26.18-26.17-26.18z"
        />
        <path
          id="cbMFg8P9E"
          d="M896.98 113.15c-18.84 27.02-29.31 42.02-31.41 45.02 0 0-2.09-49.21-8.37-57.58-6.29-8.38 28.27-13.61 28.27-13.61 1.53 3.49 5.37 12.21 11.51 26.17z"
        />
        <path
          id="e1Q6WHD4Vf"
          d="M876.04 127.81l4.19 1.05 5.24-4.19 7.32-23.04 10.48 7.33 13.61 137.17-84.81 2.09 11.51-95.28 10.47-27.22 7.56-10 5.01 15.23 4.19 10.47 5.23-13.61z"
        />
        <path
          id="hpsNkrZ0E"
          d="M894.89 200.06c1.92-56.83 2.99-88.4 3.2-94.72 0 0 6.22.48 8.32 3.62l36.64 9.43c-.62 9.73-5.65 87.63-6.28 97.37 0 0 26.18 77.48 16.75 81.67l-26.17 3.14c-4.33-13.4-15.15-46.9-32.46-100.51z"
        />
        <path
          id="a4nO2h5OIa"
          d="M844.11 188.02l11.1-63.84-24.71 16.72 6.28 46.07c-3.14 18.85-4.89 29.32-5.24 31.41 0 0-19.89 86.91-13.61 90.05h13.61c.84-5.87 5.03-35.18 12.57-87.96v-32.45z"
        />
        <path
          id="c5b73uDcc"
          d="M837.82 138.8l-7.32 2.1-3.15 41.88-5.23 36.65c-15.08 27.01-23.45 42.02-25.13 45.02 0 0 12.56-8.38 17.8 15.71 1.84-3.22 11.07-19.28 27.67-48.19l-4.64-93.17z"
        />
        <path
          id="ckEmre4je"
          d="M919.49 257.12s-29.31 23.04-14.65 28.27l24.08-18.85c-1.89-1.88-7.54-7.53-9.43-9.42z"
        />
        <path id="bMw2jJvlq" d="M927.87 280.16l-12.56-21.99 5.23-9.43 16.75 19.9-9.42 11.52z" />
        <path
          id="egTJrffWp"
          d="M935.2 122.05c5.03-2.51 7.82-3.91 8.38-4.19 0 0 6.28 8.38 7.33 15.71 0 0 6.28 16.75 6.28 21.99L971.85 210c-3.35 6.81-30.16 61.26-33.51 68.06 0 0-7.33-25.13-23.03-27.22 1.74-2.44 10.47-14.66 26.17-36.65l-14.66-26.17 8.38-65.97z"
        />
        <path
          id="b1wyqDsBKL"
          d="M892.94 53.25s-10.32-11.36-24.68-10.37c.41-.45 3.64-4 4.04-4.45 0 0-9.87-3.95-18.84 6.42-4.72 5.46-10.18 11.87-13.58 19.09h-5.29l2.21 4.86-7.73 4.86c4.76-.53 7.4-.82 7.93-.88-.47 2.66-.54 5.38-.21 8.06.34 2.68 1.7 5.13 3.81 6.82 0 0 6.12-12.67 6.12-14.65v4.94s4.94-4.44 4.94-7.41l2.69 3.46 1.35-5.43L872.3 74l-2.69-4.44 10.32 1.48c-2.42-3.26-3.77-5.07-4.04-5.44 0 0 11.67 6.43 12.12 11.86.45 5.43 3.86 10.58 3.86 10.58s9.15-25.4-3.86-32.81c.99-.4 4.44-1.78 4.93-1.98z"
        />
        <path
          id="c5eaftJH5n"
          d="M890.49 75.98c0 2.02-1.31 3.67-2.93 3.67s-2.93-1.65-2.93-3.67 1.31-3.66 2.93-3.66 2.93 1.64 2.93 3.66z"
        />
      </defs>
      <use fill="#3f3d56" xlinkHref="#eR2BRSHQc" />
      <use fillOpacity="0" stroke="#000" strokeOpacity="0" xlinkHref="#eR2BRSHQc" />
      <use fill="#3f3d56" xlinkHref="#d1EGy8eXiv" />
      <use fillOpacity="0" stroke="#000" strokeOpacity="0" xlinkHref="#d1EGy8eXiv" />
      <use fill="#fff" xlinkHref="#aP6YG9894" />
      <use fillOpacity="0" stroke="#000" strokeOpacity="0" xlinkHref="#aP6YG9894" />
      <use fill="#fff" xlinkHref="#e4GrPPr6s8" />
      <use fillOpacity="0" stroke="#000" strokeOpacity="0" xlinkHref="#e4GrPPr6s8" />
      <use fill="#fff" xlinkHref="#e1CilFOxq" />
      <use fillOpacity="0" stroke="#000" strokeOpacity="0" xlinkHref="#e1CilFOxq" />
      <use fill="#fff" xlinkHref="#f15KtcUmE" />
      <use fillOpacity="0" stroke="#000" strokeOpacity="0" xlinkHref="#f15KtcUmE" />
      <use fill="#fff" xlinkHref="#c2spb7RcA5" />
      <use fillOpacity="0" stroke="#000" strokeOpacity="0" xlinkHref="#c2spb7RcA5" />
      <use fill="#fff" xlinkHref="#aUGBNJXsp" />
      <use fillOpacity="0" stroke="#000" strokeOpacity="0" xlinkHref="#aUGBNJXsp" />
      <use fill="#fff" xlinkHref="#cxZK7DFh2" />
      <use fillOpacity="0" stroke="#000" strokeOpacity="0" xlinkHref="#cxZK7DFh2" />
      <use fill="#fff" xlinkHref="#e1iKq7Dyd2" />
      <use fillOpacity="0" stroke="#000" strokeOpacity="0" xlinkHref="#e1iKq7Dyd2" />
      <use fill="#fff" xlinkHref="#aiaFGW55i" />
      <use fillOpacity="0" stroke="#000" strokeOpacity="0" xlinkHref="#aiaFGW55i" />
      <use fill="#fff" xlinkHref="#bbHKDt2jT" />
      <use fillOpacity="0" stroke="#000" strokeOpacity="0" xlinkHref="#bbHKDt2jT" />
      <use fill="#fff" xlinkHref="#aGr5Jnz1q" />
      <use fillOpacity="0" stroke="#000" strokeOpacity="0" xlinkHref="#aGr5Jnz1q" />
      <use fill="#fff" xlinkHref="#g10rqlbHX" />
      <use fillOpacity="0" stroke="#000" strokeOpacity="0" xlinkHref="#g10rqlbHX" />
      <use fill="#fff" xlinkHref="#e2HYodK6J5" />
      <use fillOpacity="0" stroke="#000" strokeOpacity="0" xlinkHref="#e2HYodK6J5" />
      <use fill="#fff" xlinkHref="#c1SnpkDxDX" />
      <use fillOpacity="0" stroke="#000" strokeOpacity="0" xlinkHref="#c1SnpkDxDX" />
      <use fill="#fff" xlinkHref="#a1cMKru6na" />
      <use fillOpacity="0" stroke="#000" strokeOpacity="0" xlinkHref="#a1cMKru6na" />
      <use fill="#fff" xlinkHref="#e4ddCfqeM" />
      <use fillOpacity="0" stroke="#000" strokeOpacity="0" xlinkHref="#e4ddCfqeM" />
      <use fill="#fff" xlinkHref="#a5lkHtOsLR" />
      <use fillOpacity="0" stroke="#000" strokeOpacity="0" xlinkHref="#a5lkHtOsLR" />
      <use fill="#fff" xlinkHref="#b10tNkFLdQ" />
      <use fillOpacity="0" stroke="#000" strokeOpacity="0" xlinkHref="#b10tNkFLdQ" />
      <use fill="#fff" xlinkHref="#a4MwpmYRYd" />
      <use fillOpacity="0" stroke="#000" strokeOpacity="0" xlinkHref="#a4MwpmYRYd" />
      <use fill="#fff" xlinkHref="#l1ktLZGOw1" />
      <use fillOpacity="0" stroke="#000" strokeOpacity="0" xlinkHref="#l1ktLZGOw1" />
      <use fill="#fff" xlinkHref="#c44432okn" />
      <use fillOpacity="0" stroke="#000" strokeOpacity="0" xlinkHref="#c44432okn" />
      <use fill="#fff" xlinkHref="#g16wq29ee9" />
      <use fillOpacity="0" stroke="#000" strokeOpacity="0" xlinkHref="#g16wq29ee9" />
      <use fill="#fff" xlinkHref="#b1NXHcEQKr" />
      <use fillOpacity="0" stroke="#000" strokeOpacity="0" xlinkHref="#b1NXHcEQKr" />
      <use fill="#fff" xlinkHref="#bjgfbQDbG" />
      <use fillOpacity="0" stroke="#000" strokeOpacity="0" xlinkHref="#bjgfbQDbG" />
      <use fill="#fff" xlinkHref="#dpIvEcQsF" />
      <use fillOpacity="0" stroke="#000" strokeOpacity="0" xlinkHref="#dpIvEcQsF" />
      <use fill="#fff" xlinkHref="#c1Iv4CEfx" />
      <use fillOpacity="0" stroke="#000" strokeOpacity="0" xlinkHref="#c1Iv4CEfx" />
      <use fill="#fff" xlinkHref="#bv0ti55b7" />
      <use fillOpacity="0" stroke="#000" strokeOpacity="0" xlinkHref="#bv0ti55b7" />
      <use fill="#fff" xlinkHref="#aoE5jaqO1" />
      <use fillOpacity="0" stroke="#000" strokeOpacity="0" xlinkHref="#aoE5jaqO1" />
      <use fill="#fff" xlinkHref="#c15loYPkuG" />
      <use fillOpacity="0" stroke="#000" strokeOpacity="0" xlinkHref="#c15loYPkuG" />
      <use fill="#fff" xlinkHref="#h4aBFEOXTi" />
      <use fillOpacity="0" stroke="#000" strokeOpacity="0" xlinkHref="#h4aBFEOXTi" />
      <use fill="#fff" xlinkHref="#aa6zizuxa" />
      <use fillOpacity="0" stroke="#000" strokeOpacity="0" xlinkHref="#aa6zizuxa" />
      <use fill="#fff" xlinkHref="#a885uBEQR" />
      <use fillOpacity="0" stroke="#000" strokeOpacity="0" xlinkHref="#a885uBEQR" />
      <use fill="#fff" xlinkHref="#d6Pr1qTIM5" />
      <use fillOpacity="0" stroke="#000" strokeOpacity="0" xlinkHref="#d6Pr1qTIM5" />
      <use fill="#fff" xlinkHref="#aaAxhAKAB" />
      <use fillOpacity="0" stroke="#000" strokeOpacity="0" xlinkHref="#aaAxhAKAB" />
      <g>
        <use fill="#fff" xlinkHref="#bfty30ef2" />
        <use fillOpacity="0" stroke="#000" strokeOpacity="0" xlinkHref="#bfty30ef2" />
      </g>
      <g>
        <use fill="#fff" xlinkHref="#cg4P4OGYz" />
        <use fillOpacity="0" stroke="#000" strokeOpacity="0" xlinkHref="#cg4P4OGYz" />
      </g>
      <g>
        <use fill="#fff" xlinkHref="#fZb69SCsW" />
        <use fillOpacity="0" stroke="#000" strokeOpacity="0" xlinkHref="#fZb69SCsW" />
      </g>
      <g>
        <use fill="#fff" xlinkHref="#fHvLutWIR" />
        <use fillOpacity="0" stroke="#000" strokeOpacity="0" xlinkHref="#fHvLutWIR" />
      </g>
      <g>
        <use fill="#ff6584" xlinkHref="#hcrqG8OaH" />
        <use fillOpacity="0" stroke="#000" strokeOpacity="0" xlinkHref="#hcrqG8OaH" />
      </g>
      <g>
        <use fill="#35f" xlinkHref="#c36Df2nxjJ" />
        <use fillOpacity="0" stroke="#000" strokeOpacity="0" xlinkHref="#c36Df2nxjJ" />
      </g>
      <g>
        <use fill="#35f" xlinkHref="#e24duvVUvt" />
        <use fillOpacity="0" stroke="#000" strokeOpacity="0" xlinkHref="#e24duvVUvt" />
      </g>
      <g>
        <use fill="#fff" xlinkHref="#e38581jFAu" />
        <use fillOpacity="0" stroke="#000" strokeOpacity="0" xlinkHref="#e38581jFAu" />
      </g>
      <g>
        <use fill="#fff" xlinkHref="#a3bjBapYjH" />
        <use fillOpacity="0" stroke="#000" strokeOpacity="0" xlinkHref="#a3bjBapYjH" />
      </g>
      <g>
        <use fill="#fff" xlinkHref="#aVuMVyP6U" />
        <use fillOpacity="0" stroke="#000" strokeOpacity="0" xlinkHref="#aVuMVyP6U" />
      </g>
      <g>
        <use fill="#fff" xlinkHref="#a13IRZt9nG" />
        <use fillOpacity="0" stroke="#000" strokeOpacity="0" xlinkHref="#a13IRZt9nG" />
      </g>
      <g>
        <use fill="#fff" xlinkHref="#a1pYLXR9fr" />
        <use fillOpacity="0" stroke="#000" strokeOpacity="0" xlinkHref="#a1pYLXR9fr" />
      </g>
      <g>
        <use fill="#fff" xlinkHref="#c1zCXOzhr7" />
        <use fillOpacity="0" stroke="#000" strokeOpacity="0" xlinkHref="#c1zCXOzhr7" />
      </g>
      <g>
        <use fill="#fff" xlinkHref="#atlj9EOGi" />
        <use fillOpacity="0" stroke="#000" strokeOpacity="0" xlinkHref="#atlj9EOGi" />
      </g>
      <g>
        <use fill="#35f" xlinkHref="#b2S2aobed" />
        <use fillOpacity="0" stroke="#000" strokeOpacity="0" xlinkHref="#b2S2aobed" />
      </g>
      <g>
        <use fill="#fff" xlinkHref="#dF9Z549n9" />
        <use fillOpacity="0" stroke="#000" strokeOpacity="0" xlinkHref="#dF9Z549n9" />
      </g>
      <g>
        <use fill="#fff" xlinkHref="#afH8Ip2d" />
        <use fillOpacity="0" stroke="#000" strokeOpacity="0" xlinkHref="#afH8Ip2d" />
      </g>
      <g>
        <use fill="#fff" xlinkHref="#a1ro449ecS" />
        <use fillOpacity="0" stroke="#000" strokeOpacity="0" xlinkHref="#a1ro449ecS" />
      </g>
      <g>
        <use fill="#a0616a" xlinkHref="#a1qUppLBEQ" />
        <use fillOpacity="0" stroke="#000" strokeOpacity="0" xlinkHref="#a1qUppLBEQ" />
      </g>
      <g>
        <use fill="#cfcce0" xlinkHref="#b2Hef4h5AZ" />
        <use fillOpacity="0" stroke="#000" strokeOpacity="0" xlinkHref="#b2Hef4h5AZ" />
      </g>
      <g>
        <use fill="#a0616a" xlinkHref="#blQXkvyge" />
        <use fillOpacity="0" stroke="#000" strokeOpacity="0" xlinkHref="#blQXkvyge" />
      </g>
      <g>
        <use fill="#a0616a" xlinkHref="#fRJsCBQUc" />
        <use fillOpacity="0" stroke="#000" strokeOpacity="0" xlinkHref="#fRJsCBQUc" />
      </g>
      <g>
        <use fill="#2f2e41" xlinkHref="#cNaEfY6D" />
        <use fillOpacity="0" stroke="#000" strokeOpacity="0" xlinkHref="#cNaEfY6D" />
      </g>
      <g>
        <use fill="#2f2e41" xlinkHref="#e1K2bUq1Hb" />
        <use fillOpacity="0" stroke="#000" strokeOpacity="0" xlinkHref="#e1K2bUq1Hb" />
      </g>
      <g>
        <use fill="#2f2e41" xlinkHref="#h22tBNB0nj" />
        <use fillOpacity="0" stroke="#000" strokeOpacity="0" xlinkHref="#h22tBNB0nj" />
      </g>
      <g>
        <use fill="#a0616a" xlinkHref="#bL1JqcCd" />
        <use fillOpacity="0" stroke="#000" strokeOpacity="0" xlinkHref="#bL1JqcCd" />
      </g>
      <g>
        <use fill="#a0616a" xlinkHref="#cbMFg8P9E" />
        <use fillOpacity="0" stroke="#000" strokeOpacity="0" xlinkHref="#cbMFg8P9E" />
      </g>
      <g>
        <use fill="#cfcce0" xlinkHref="#e1Q6WHD4Vf" />
        <use fillOpacity="0" stroke="#000" strokeOpacity="0" xlinkHref="#e1Q6WHD4Vf" />
      </g>
      <g>
        <use fill="#575a89" xlinkHref="#hpsNkrZ0E" />
        <use fillOpacity="0" stroke="#000" strokeOpacity="0" xlinkHref="#hpsNkrZ0E" />
      </g>
      <g>
        <use fill="#575a89" xlinkHref="#a4nO2h5OIa" />
        <use fillOpacity="0" stroke="#000" strokeOpacity="0" xlinkHref="#a4nO2h5OIa" />
      </g>
      <g>
        <use fill="#575a89" xlinkHref="#c5b73uDcc" />
        <use fillOpacity="0" stroke="#000" strokeOpacity="0" xlinkHref="#c5b73uDcc" />
      </g>
      <g>
        <use fill="#a0616a" xlinkHref="#ckEmre4je" />
        <use fillOpacity="0" stroke="#000" strokeOpacity="0" xlinkHref="#ckEmre4je" />
      </g>
      <g>
        <use fill="#cfcce0" xlinkHref="#bMw2jJvlq" />
        <use fillOpacity="0" stroke="#000" strokeOpacity="0" xlinkHref="#bMw2jJvlq" />
      </g>
      <g>
        <use fill="#575a89" xlinkHref="#egTJrffWp" />
        <use fillOpacity="0" stroke="#000" strokeOpacity="0" xlinkHref="#egTJrffWp" />
      </g>
      <g>
        <use fill="#2f2e41" xlinkHref="#b1wyqDsBKL" />
        <use fillOpacity="0" stroke="#000" strokeOpacity="0" xlinkHref="#b1wyqDsBKL" />
      </g>
      <g>
        <use fill="#a0616a" xlinkHref="#c5eaftJH5n" />
        <use fillOpacity="0" stroke="#000" strokeOpacity="0" xlinkHref="#c5eaftJH5n" />
      </g>
    </svg>
  );
};
